<template>
  <div class="main" id="main">
    <div id="navigation">
      <h3>Teamio Automation Workflow Builder</h3>
      <div class="saveWorkflow" @click="validateAndSave">Save Workflow</div>
      <div v-if="allowActivate" class="saveWorkflow" @click="activate">Activate Workflow</div>
      <div class="saveWorkflow" @click="reset">Reset</div>

      <!--
        <div id="leftside">
            <div id="details">
            <div id="back"><img src="../assets/img/arrow.svg"></div>
            <div id="names">
                <p id="title">Your automation pipeline</p>
                <p id="subtitle">Marketing automation</p>
            </div>
        </div>
        </div>
        <div id="centerswitch">
            <div id="leftswitch">Diagram view</div>
            <div id="rightswitch">Code editor</div>
        </div>
        <div id="buttonsright">
            <div id="discard">Discard</div>
            <div id="publish">Publish to site</div>
        </div>
        -->
    </div>

    <ErrorDisplay />

    <div id="leftcard">
      <p id="header">Blocks</p>
      <div id="search" style="display:none">
        <img src="../assets/img/search.svg" />
        <input type="text" placeholder="Search blocks" />
      </div>
      <div id="subnav">
        <div id="triggers" class="navactive side">Triggers</div>
        <div id="actions" class="navdisabled side">Actions</div>
      </div>
      <div id="blocklist"></div>
      <!--
        <div id="footer">
            <a href="https://github.com/alyssaxuu/flowy/" target="_blank">GitHub</a>
            <span>·</span>
            <a href="https://twitter.com/alyssaxuu/status/1199724989353730048" target="_blank">Twitter</a>
            <span>·</span>
                <a href="https://alyssax.com" target="_blank"><p>Made with</p><img src="../assets/img/heart.svg"><p>by</p> Alyssa X</a>
        </div>
        -->
    </div>

    <!-- ORIGINAL
    <div id="propwrap">
        <div id="properties">
            <div id="close">
                <img src="../assets/img/close.svg">
            </div>
            <p id="header2">Properties</p>
            <div id="propswitch">
                <div id="dataprop">Data</div>
                <div id="alertprop">Alerts</div>
                <div id="logsprop">Logs</div>
            </div>
            <div id="proplist">
                <p class="inputlabel">Select database</p>
                <div class="dropme">Database 1 <img src="../assets/img/dropdown.svg"></div>
                <p class="inputlabel">Check properties</p>
                <div class="dropme">All<img src="../assets/img/dropdown.svg"></div>
                <div class="checkus"><img src="../assets/img/checkon.svg"><p>Log on successful performance</p></div>
                <div class="checkus"><img src="../assets/img/checkoff.svg"><p>Give priority to this block</p></div>
            </div>
            <div id="divisionthing"></div>
            <div id="removeblock">Delete blocks</div>
        </div>
    </div>
    -->

    <!-- X Followups Completed Trigger Properties  -->
    <div id="xFollowupsCompletedwrap" class="blockpropswrap">
      <div id="xFollowupsCompletedproperties" class="blockprops">
        <div id="xFollowupsCompletedclose" class="workflow-close">
          <img src="../assets/img/close.svg" />
        </div>
        <div class="header">x Followups Completed</div>
        <div id="proplist">
          <p id="header3">Trigger on how many followups</p>
          <b-form-input class="w-25" id="xFollowupNumber" v-model="xFollowupNumber" placeholder="Enter a number here" size="sm"></b-form-input>
          <p/>
        </div>
        <div id="divisionthing"></div>
        <div class="save-button-container">
          <div id="xFollowupsCompletedsave" class="saveblock">Save</div>
          <div id="xFollowupsCompletedsaveclose" class="saveblock saveblock-close">Save &amp; Close</div>
        </div>
      </div>
    </div>

    <!-- New Patient Properties -->
    <div id="newpatientwrap" class="blockpropswrap">
      <div id="newpatientproperties" class="blockprops">
        <div id="newpatientclose" class="workflow-close">
          <img src="../assets/img/close.svg" />
        </div>
        <p id="header2">New Patient Properties</p>
        <div id="propswitch">
          <div id="dataprop">Data</div>
          <div id="alertprop">Options</div>
          <div id="logsprop">Other</div>
        </div>
        <div id="proplist">
          <p class="inputlabel">Only run if the Patient is...</p>
          <div class="dropme">
            John Smith <img src="../assets/img/dropdown.svg" />
          </div>
        </div>
        <div id="divisionthing"></div>
        <div class="save-button-container">
          <div id="saveblock" class="saveblock">Save</div>
          <div id="saveblockclose" class="saveblock saveblock-close">Save &amp; Close</div>
        </div>
      </div>
    </div>

    <!-- SMS Properties -->
    <div id="smswrap" class="blockpropswrap">
      <div id="smsproperties" class="blockprops">
        <div id="smsclose" class="workflow-close">
          <img src="../assets/img/close.svg" />
        </div>
        <p id="header2">SMS Properties</p>

        <!-- SMS Feature Not Enabled Notice -->
        <div v-if="!smsFeatureEnabled" class="workflow-feature-notice">
          <div class="notice-icon-container">
            <i class="fa fa-mobile notice-icon"></i>
          </div>
          <div class="notice-content">
            <span class="notice-title">{{ smsOutboundOff ? 'Texting Turned Off' : 'SMS Not Configured' }}</span>
            <span class="notice-text">{{ smsOutboundOff ? smsDisabledMessage : 'This feature requires SMS to be set up for your account.' }}</span>
            <FeatureRequestNote v-if="!smsOutboundOff" feature="SMS" />
          </div>
          <FeatureRequestButton
            v-if="!smsOutboundOff"
            class="notice-button"
            feature-key="SMS"
            feature-label="2-Way SMS texting"
            source-page="Workflow Builder - SMS step"
          />
        </div>

        <div id="proplist" :class="{ 'feature-disabled-overlay': !smsFeatureEnabled }">
          <div id="send-sms-proccode-properties">
            <table id="send-sms-proc-table" width="100%" cellpadding="5" cellspacing="2">
              <thead>
                <th>If Proc Code matches...</th>
                <th>Use Template</th>
                <th>Send when...</th>
                <th></th>
              </thead>
              <tbody id="send-sms-proc-table-body">
                <tr id="send-sms-row">
                  <td width="30%">
                    <select id="send-sms-proc-code" multiple/>
                  </td>
                  <td width="30%">
                    <select id="send-sms-template"/>
                  </td>
                  <td width="30%">
                    <select id="send-sms-when"/>
                  </td>
                  <td width="10%">
                    <!-- <i id="send-sms-delete" class="glyphicon glyphicon-trash"/> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <p/>
            <a href="#" id="addMoreCodesForSms" class="ml-2 mt-2">Add more</a>
            <p/>
          </div>

          <div id="send-sms-website-form-properties">
            <p id="header3">Website Form Submission related Properties</p>
            <table id="send-sms-website-form-table" width="100%" cellpadding="5" cellspacing="2">
              <thead>
                <th>If Form Element</th>
                <th>Matches</th>
                <th>Use Template</th>
                <!-- <th>Send when...</th> -->
                <th></th>
              </thead>
              <tbody id="send-sms-website-form-table-body">
                <tr id="send-sms-webform-row">
                  <td width="10%">
                    <select id="send-sms-webform-elmname"/>
                  </td>
                  <td width="10%">
                    <select id="send-sms-webform-elmval"/>
                  </td>
                  <td width="9%">
                    <select id="send-sms-webform-template"/>
                  </td>
                  <!--
                  <td width="9%">
                    <select id="send-sms-webform-when"/>
                  </td>
                -->
                  <td width="2%">
                    <!-- <i id="send-sms-webform-delete-0" class="glyphicon glyphicon-trash"/> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div id="divisionthing"></div>
        <div class="save-button-container">
          <div id="smssave" class="saveblock">Save</div>
          <div id="smssaveclose" class="saveblock saveblock-close">Save &amp; Close</div>
        </div>
      </div>
    </div>

    <!-- Email Properties -->
    <div id="emailwrap" class="blockpropswrap">
      <div id="emailproperties" class="blockprops">
        <div id="emailclose" class="workflow-close">
          <img src="../assets/img/close.svg" />
        </div>
        <p id="header2">Email Properties</p>

        <!-- Email Feature Not Enabled Notice -->
        <div v-if="!emailFeatureEnabled" class="workflow-feature-notice">
          <div class="notice-icon-container">
            <i class="fa fa-envelope-o notice-icon"></i>
          </div>
          <div class="notice-content">
            <span class="notice-title">Email Not Configured</span>
            <span class="notice-text">This feature requires verified email addresses for your account.</span>
            <FeatureRequestNote feature="EMAIL" />
          </div>
          <FeatureRequestButton
            class="notice-button"
            feature-key="EMAIL"
            feature-label="Patient email"
            source-page="Workflow Builder - Email step"
          />
        </div>

        <div id="proplist" :class="{ 'feature-disabled-overlay': !emailFeatureEnabled }">
          <div>
            <p class="inputlabel">Select From Name</p>
            <b-form-input id="emailFromName" v-model="emailFromName" placeholder="Enter your name" :disabled="!emailFeatureEnabled"></b-form-input>
            <p class="inputlabel mt-5">Select From Email Address</p>
              <b-form-select
                v-if="emailFeatureEnabled"
                v-model="emailFrom"
                :options="verifiedEmails"
                id="emailFrom"
              ></b-form-select>
              <b-form-select
                v-else
                disabled
                :options="[{ value: null, text: 'No verified emails configured' }]"
              ></b-form-select>
          </div>

          <div class="mt-5 ml-2" id="send-email-proccode-properties">
            <table id="send-email-proc-table" width="100%" cellpadding="5" cellspacing="2">
              <thead>
                <th>If Proc Code matches...</th>
                <th>Use Template</th>
                <!-- <th>Send when...</th> -->
                <th></th>
              </thead>
              <tbody id="send-email-proc-table-body">
                <tr id="send-email-row">
                  <td width="45%">
                    <select id="send-email-proc-code" multiple/>
                  </td>
                  <td width="45%">
                    <select id="send-email-template"/>
                  </td>
                  <!--
                  <td width="30%">
                    <select id="send-email-when"/>
                  </td>
                  -->
                  <td width="10%">
                    <!-- <i id="send-email-delete" class="glyphicon glyphicon-trash"/> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <p/>
            <a href="#" id="addMoreCodesForEmail" class="ml-2">Add more</a>
            <p/>
            <div class="mt-5 ml-2">
              <!--
              <b-form-checkbox
                id="onlyIfPreviousUnopened"
                name="onlyIfPreviousUnopened"
                value="true"
                unchecked-value="false"              >
                Only send if previous email un-opened
              </b-form-checkbox>
              -->
            </div>
          </div>

          <div id="send-email-website-form-properties">
            <p id="header3">Website Form Submission related Properties</p>
            <table id="send-email-website-form-table" width="100%" cellpadding="5" cellspacing="2">
              <thead>
                <th>If Form Element</th>
                <th>Matches</th>
                <th>Use Template</th>
              </thead>
              <tbody id="send-email-website-form-table-body">
                <tr id="send-email-webform-row">
                  <td width="33%">
                    <select id="send-email-webform-elmname"/>
                  </td>
                  <td width="33%">
                    <select id="send-email-webform-elmval"/>
                  </td>
                  <td width="34%">
                    <select id="send-email-webform-template"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div id="divisionthing"></div>
        <div class="save-button-container">
          <div id="emailsave" class="saveblock">Save</div>
          <div id="emailsaveclose" class="saveblock saveblock-close">Save &amp; Close</div>
        </div>
      </div>
    </div>

    <!-- Assign Task Properties -->
    <div id="assigntaskwrap" class="blockpropswrap">
      <div id="assigntaskproperties" class="blockprops">
        <div id="assigntaskclose" class="workflow-close">
          <img src="../assets/img/close.svg" />
        </div>
        <p id="header2">Assign Task Properties</p>
        <!--
        <div id="propswitch">
          <div id="dataprop">Data</div>
          <div id="alertprop">Options</div>
          <div id="logsprop">Other</div>
        </div>
        -->
        <div id="proplist">
          <div class="mt-5 ml-2" id="assign-task-proccode-properties">
            <table id="assign-task-proc-table" width="100%" cellpadding="5" cellspacing="2">
              <thead>
                <th>If Proc Code matches...</th>
                <th>Assign Task To</th>
                <th>Task Description</th>
                <th>Task Due Date</th>
                <th>Attach Wiki?</th>
                <th>Tags</th> <!-- MODIFIED: Header Text -->
                <th></th>
              </thead>
              <tbody id="assign-task-proc-table-body">
                <tr id="assign-task-row">
                  <td width="15%">
                    <select id="assign-task-proc-code" multiple></select> <!-- MODIFIED: Add closing tag -->
                  </td>
                  <td width="15%">
                    <select id="assign-task-employee" multiple></select> <!-- MODIFIED: Add closing tag -->
                  </td>
                  <td width="20%">
                    <textarea class="workflowTextbox task-description-textarea" id="assign-task-desc" rows="2" placeholder="Enter task description..."></textarea>
                  </td>
                  <td width="15%">
                    <select id="assign-task-duedate"></select> <!-- MODIFIED: Add closing tag -->
                  </td>
                  <td width="15%">
                    <select id="assign-task-wiki" multiple></select> <!-- MODIFIED: Add closing tag -->
                  </td>
                  <!-- MODIFIED: Changed input to select -->
                  <td width="15%">
                    <select multiple id="assign-task-tag"></select>
                  </td>
                  <!-- END MODIFICATION -->
                  <td width="10%">
                    <!-- <i id="assign-task-delete-0" class="glyphicon glyphicon-trash"/> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <p/><a href="#" id="addMoreCodesForAssignTask" class="ml-2">Add more</a><p/>
          </div>

          <div id="assign-task-website-form-properties">
            <p id="header3">Website Form Submission related Properties</p>
            <table id="assign-task-website-form-table" width="100%" cellpadding="5" cellspacing="2">
              <thead>
                <th>If Form Element</th>
                <th>Matches</th>
                <th>Assign Task To</th>
                <th>Task Description</th>
                <th>Task Due Date</th>
                <th>Attach Wiki?</th>
                <th>Tags</th> <!-- MODIFIED: Header Text -->
                <th></th>
              </thead>
              <tbody id="assign-task-website-form-table-body">
                <tr id="assign-task-webform-row">
                  <td width="10%">
                    <select id="assign-task-webform-elmname"></select> <!-- MODIFIED: Add closing tag -->
                  </td>
                  <td width="10%">
                    <select id="assign-task-webform-elmval"></select> <!-- MODIFIED: Add closing tag -->
                  </td>
                  <td width="15%">
                    <select id="assign-task-webform-employee" multiple></select> <!-- MODIFIED: Add multiple and closing tag -->
                  </td>
                  <td width="20%">
                    <textarea class="workflowTextbox task-description-textarea" id="assign-task-webform-desc" rows="2" placeholder="Enter task description..."></textarea>
                  </td>
                  <td width="15%">
                    <select id="assign-task-webform-duedate"></select> <!-- MODIFIED: Add closing tag -->
                  </td>
                  <td width="15%">
                    <select id="assign-task-webform-wiki" multiple></select> <!-- MODIFIED: Add closing tag -->
                  </td>
                   <!-- MODIFIED: Changed input to select -->
                  <td width="10%">
                    <select multiple id="assign-task-webform-tag"></select>
                  </td>
                   <!-- END MODIFICATION -->
                  <td width="10%">
                    <!-- <i id="send-form-delete" class="glyphicon glyphicon-trash"/> --> <!-- Incorrect ID? -->
                  </td>
                </tr>
              </tbody>
            </table>
            <p/>
            <!-- MODIFIED: Corrected Add More button ID (assuming this was intended) -->
            <a href="#" id="addMoreCodesForAssignTaskWebform" class="ml-2 mt-2">Add more</a>
            <p/>
            <!-- END MODIFICATION -->
          </div>
        </div>

        <div id="divisionthing"></div>
        <!-- MODIFIED: Changed save button ID to match function -->
        <div class="save-button-container">
          <div id="assigntasksave" class="saveblock">Save</div>
          <div id="assigntasksaveclose" class="saveblock saveblock-close">Save &amp; Close</div>
        </div>
        <!-- END MODIFICATION -->
      </div>
    </div>

    <!-- End of Assign Task Properties -->

    <!-- Kanban Properties -->

    <div id="kanbanwrap" class="blockpropswrap">
      <div id="kanbanproperties" class="blockprops">
        <div id="kanbanclose" class="workflow-close">
          <img src="../assets/img/close.svg" />
        </div>
        <p id="header2">Kanban Properties</p>
        <!--
        <div id="propswitch">
          <div id="dataprop">Data</div>
          <div id="alertprop">Options</div>
          <div id="logsprop">Other</div>
        </div>
        -->
        <div id="proplist">
          <div id="kanban-properties">
            <table id="kanban-table" width="100%" cellpadding="5" cellspacing="2">
              <thead>
                <th>If Proc Code matches...</th>
                <th>Select Kanban</th>
                <th>Select Column</th>
                <th>Card Action</th>
                <th>Select Card</th>
                <th>Card Properties</th>
                <th></th>
              </thead>
              <tbody id="kanban-table-body">
                <tr id="send-sms-row">
                  <td width="15%">
                    <select id="kanban-proc-code" multiple/>
                  </td>
                  <td width="15%">
                    <select id="kanban-board"/>
                  </td>
                  <td width="15%">
                    <select id="kanban-board-column"/>
                  </td>
                  <td width="15%">
                    <select id="kanban-board-card-action"/>
                  </td>
                  <td width="15%">
                    <select id="kanban-board-card" style="display: none;"/>
                  </td>
                  <td width="20%">
                    <!-- Card Properties Container (for both Add and Update) -->
                    <div id="kanban-card-update-properties" style="display: none;">
                      <div class="card-update-field mb-2">
                        <label class="small text-muted">Card Title:</label>
                        <input type="text" id="kanban-card-new-title" class="form-control form-control-sm" placeholder="Select action first"/>
                      </div>
                      <div class="card-update-field mb-2">
                        <label class="small text-muted">Card Description:</label>
                        <textarea id="kanban-card-new-description" class="form-control form-control-sm" rows="2" placeholder="Select action first"></textarea>
                      </div>
                      <div class="card-update-field mb-2">
                        <label class="small text-muted" id="kanban-move-column-label">Column:</label>
                        <select id="kanban-board-move-to-column" class="form-control form-control-sm" style="display: none;">
                          <option value="">Select column</option>
                        </select>
                      </div>
                      <div class="card-update-field">
                        <label class="small text-muted">Card Tags:</label>
                        <input type="text" id="kanban-card-new-tags" class="form-control form-control-sm" placeholder="Select action first"/>
                      </div>
                    </div>
                  </td>
                  <td width="5%">
                    <!-- <i id="kanban-delete" class="glyphicon glyphicon-trash"/> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <p/>
            <a href="#" id="addMoreCodesForKanban" class="ml-2 mt-2">Add more</a>
            <p/>
          </div>
        </div>
        <div id="divisionthing"></div>
        <div class="save-button-container">
          <div id="kanbansave" class="saveblock">Save</div>
          <div id="kanbansaveclose" class="saveblock saveblock-close">Save &amp; Close</div>
        </div>
      </div>
    </div>

    <!-- End of Kanban Properties -->

    <!-- Wait Properties -->
    <div id="waitwrap" class="blockpropswrap">
      <div id="waitproperties" class="blockprops">
        <div id="waitclose" class="workflow-close">
          <img src="../assets/img/close.svg" />
        </div>
        <p id="header2">Wait Properties</p>
        
        <div id="proplist">
          <div id="wait-properties">
            <!-- Wait Type Selection -->
            <div class="form-group">
              <label class="section-label">Wait Type:</label>
              <div class="radio-group">
                <!-- Specific Duration Option with inline controls -->
                <div class="wait-option-container">
                  <label class="radio-inline">
                    <input type="radio" id="waitFor" name="waitType" value="duration" checked>
                    <span class="radio-content">
                      <strong>⏱️ Specific Duration</strong>
                      <small>Wait for a fixed amount of time</small>
                    </span>
                  </label>
                  
                  <!-- Duration controls directly under the option -->
                  <div id="waitForFirstOption" class="wait-option-details">
                    <div class="form-group">
                      <label for="waitForDurationNum" class="section-label">Duration:</label>
                      <div class="duration-controls">
                        <input type="number" id="waitForDurationNum" class="form-control duration-input" min="1" value="1" placeholder="1">
                        <select id="waitForDurationOptionSelected" class="form-control duration-select">
                          <option value="minutes">Minute(s)</option>
                          <option value="hours">Hour(s)</option>
                          <option value="days">Day(s)</option>
                          <option value="weeks">Week(s)</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Until Condition Option -->
                <div class="wait-option-container disabled-container">
                  <label class="radio-inline disabled-option">
                    <input type="radio" id="waitUntilCondition" name="waitType" value="condition" disabled>
                    <span class="radio-content">
                      <strong>🎯 Until Condition <span class="coming-soon-badge">Coming Soon</span></strong>
                      <small>Wait until a specific event occurs</small>
                      <div class="feature-preview">
                        <div class="preview-title">🚀 What this will do:</div>
                        <ul class="preview-list">
                          <li>📅 Wait until appointment is scheduled/completed</li>
                          <li>📝 Wait until patient submits a form</li>
                          <li>💳 Wait until payment is received</li>                                                    
                        </ul>
                        <div class="preview-note">Perfect for creating smart, responsive workflows that adapt to patient actions!</div>
                      </div>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            
            <!-- Condition Option -->
            <div id="waitForThirdOption" class="wait-option" style="display: none;">
              <div class="form-group">
                <label for="waitUntilConditionOptionSelected" class="section-label">Wait until:</label>
                <select id="waitUntilConditionOptionSelected" class="form-control">
                  <option value="appointment_scheduled">📅 Appointment is scheduled</option>
                  <option value="appointment_completed">✅ Appointment is completed</option>
                  <option value="form_submitted">📝 Form is submitted</option>
                  <option value="payment_received">💳 Payment is received</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div id="divisionthing"></div>
        <div class="save-button-container">
          <div id="waitsave" class="saveblock">Save</div>
          <div id="waitsaveclose" class="saveblock saveblock-close">Save &amp; Close</div>
        </div>
      </div>
    </div>

    <!-- End of Wait Properties -->

    <!-- Slack Properties -->
    <div id="slackwrap" class="blockpropswrap">
      <div id="slackproperties" class="blockprops">
        <div id="slackclose" class="workflow-close">
          <img src="../assets/img/close.svg" />
        </div>
        <p id="header2">Slack Message Properties</p>
        
        <div id="proplist">
          <div id="slack-properties">
            <!-- Slack Not Connected Warning -->
            <div id="slack-not-connected-warning" class="slack-warning" style="display: none;">
              <div class="alert alert-warning">
                <i class="fa fa-exclamation-triangle"></i>
                <strong>Slack Not Connected</strong>
                <p>You need to connect your Slack workspace in Settings before using this action.</p>
                <a href="/app/settings" class="btn btn-sm btn-primary mt-2">Go to Settings</a>
              </div>
            </div>
            
            <!-- Slack Connected Content -->
            <div id="slack-connected-content">
              <div class="form-group">
                <label class="section-label" for="slackChannel">Select Channel:</label>
                <select id="slackChannel" class="form-control">
                  <option value="">-- Select a channel --</option>
                </select>
                <small class="text-muted">Choose the Slack channel to send messages to</small>
              </div>
              
              <div class="form-group mt-4">
                <label class="section-label" for="slackMessage">Message:</label>
                <textarea id="slackMessage" class="form-control" rows="5" 
                  placeholder="Enter the message to send to Slack. You can use variables like {patient_name}, {appointment_date}, etc."></textarea>
                <small class="text-muted mt-2">
                  <strong>Available variables:</strong> 
                  <code v-pre>{{patient_name}}</code>, 
                  <code v-pre>{{patient_phone}}</code>, 
                  <code v-pre>{{appointment_date}}</code>, 
                  <code v-pre>{{appointment_time}}</code>, 
                  <code v-pre>{{provider_name}}</code>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div id="divisionthing"></div>
        <div class="save-button-container">
          <div id="slacksave" class="saveblock">Save</div>
          <div id="slacksaveclose" class="saveblock saveblock-close">Save &amp; Close</div>
        </div>
      </div>
    </div>
    <!-- End of Slack Properties -->

    <!-- Send Form Properties -->
    <div id="sendformwrap" class="blockpropswrap">
      <div id="sendformproperties" class="blockprops">
        <div id="sendformclose" class="workflow-close">
          <img src="../assets/img/close.svg" />
        </div>
        <p id="header2">Send Form Properties</p>
        
        <div id="proplist">
          <div id="send-form-properties">
            <!-- Main checkbox for new patients only -->
            <div class="form-group">
              <label class="section-label">
                <input type="checkbox" id="sendForNewPatientsCheck" class="mr-2">
                Send form only for new patients
              </label>
              <small class="form-text text-muted">Check this to only send forms to newly registered patients</small>
            </div>

            <!-- New Patient Options (hidden by default, indented to show they're sub-options) -->
            <div id="sendForNewPatientsOnly" class="new-patient-options" style="display: none;">
              <div class="options-container">
                <div class="form-group">
                  <label class="section-label">📧 Send Via:</label>
                  <div class="send-options">
                    <label class="checkbox-inline mr-4">
                      <input type="checkbox" id="sendFormNewPatientsEmail" class="mr-2">
                      <span class="option-text">Email</span>
                    </label>
                    <label class="checkbox-inline">
                      <input type="checkbox" id="sendFormNewPatientsText" class="mr-2">
                      <span class="option-text">SMS</span>
                    </label>
                  </div>
                </div>

                <!-- Email Configuration Section -->
                <div class="delivery-method-section">
                  <h6 class="method-header">📧 Email Configuration</h6>
                  <div class="form-group">
                    <label for="send-form-new-patient-send-with-email-template" class="form-label">Email Template:</label>
                    <select id="send-form-new-patient-send-with-email-template" class="form-control">
                      <option value="">Select email template...</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label for="send-form-new-patient-send-with-email-when" class="form-label">Send Email When:</label>
                    <select id="send-form-new-patient-send-with-email-when" class="form-control">
                      <option value="">Please select an option</option>
                      <option value="immediately">Immediately</option>
                      <option value="1dayb">1 Day Before Appointment</option>
                      <option value="2daysb">2 Days Before Appointment</option>
                      <option value="3daysb">3 Days Before Appointment</option>
                      <option value="1weekb">1 Week Before Appointment</option>
                    </select>
                  </div>
                </div>

                <!-- SMS Configuration Section -->
                <div class="delivery-method-section">
                  <h6 class="method-header">📱 SMS Configuration</h6>
                  <div class="form-group">
                    <label for="send-form-new-patient-send-with-text-template" class="form-label">SMS Template:</label>
                    <select id="send-form-new-patient-send-with-text-template" class="form-control">
                      <option value="">Select SMS template...</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label for="send-form-new-patient-send-with-text-when" class="form-label">Send SMS When:</label>
                    <select id="send-form-new-patient-send-with-text-when" class="form-control">
                      <option value="">Please select an option</option>
                      <option value="immediately">Immediately</option>
                      <option value="1dayb">1 Day Before Appointment</option>
                      <option value="2daysb">2 Days Before Appointment</option>
                      <option value="3daysb">3 Days Before Appointment</option>
                      <option value="1weekb">1 Week Before Appointment</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Procedure Code Based Form Sending -->
            <div class="mt-3 ml-2" id="send-form-proccode-properties">
              <table id="send-form-proc-table" width="100%" cellpadding="5" cellspacing="2">
                <thead>
                  <th>If Proc Code matches...</th>
                  <th>Send Form</th>
                  <th>Send Via</th>
                  <th>Send when...</th>
                  <th></th>
                </thead>
                <tbody id="send-form-proc-table-body">
                  <tr id="send-form-row">
                    <td width="20%">
                      <select id="send-form-proc-code" multiple/>
                    </td>
                    <td width="20%">
                      <select id="send-form-template"/>
                    </td>
                    <td width="20%">
                      <select id="send-form-send-via"/>
                    </td>
                    <td width="30%">
                      <select id="send-form-when"/>
                    </td>
                    <td width="10%">
                      <!-- <i id="send-form-delete" class="glyphicon glyphicon-trash"/> -->
                    </td>
                  </tr>
                </tbody>
              </table>
              <p/>
              <a href="#" id="addMoreCodesForSendForm" class="ml-2 mt-2">Add more</a>
              <p/>
            </div>
          </div>
        </div>
        <div id="divisionthing"></div>
        <div class="save-button-container">
          <div id="sendformsave" class="saveblock">Save</div>
          <div id="sendformsaveclose" class="saveblock saveblock-close">Save &amp; Close</div>
        </div>
      </div>
    </div>

    <!-- End of Send Form Properties -->

    <div id="canvas"></div>

    <b-modal ref="modal-workflow-save-name" size="sm" body-class="bg-white" title="Name Your Workflow" @ok="_saveWorkflow" @cancel="hideModal('modal-workflow-save-name')">
        <b-form-group label="Save Workflow As:" label-for="workflow-name">
            <b-form-input
                id="workflow-name"
                v-model="workflowName"
                type="text"
                size="sm"
                placeholder="Workflow Name Goes here"
            ></b-form-input>
            <span class="mt-5">Workflow name can not have white space, brackets or any special characters except dashes</span>
        </b-form-group>
    </b-modal>

    <b-modal ref="sure-modal-remove-all-blocks" size="sm" body-class="bg-white" title="Are you sure?" @ok="runSureOk('REMOVE-ALL-BLOCKS')" @cancel="hideModal('sure-modal-remove-all-blocks')">
      Are you sure you want to delete all blocks and start over?
    </b-modal>

    <kanban-modal ref="kanbanModal"/>

  </div>
</template>

<script>
/* eslint-disable */

// https://www.cssscript.com/demo/multi-select-autocomplete-selectpure/

import flowycss from "@/pages/Workflow/assets/css/flowy.min.css";
import maincss from "@/pages/Workflow/assets/css/styles.css";
//import flowy from '@/pages/Workflow/assets/js/flowy.min.js';
import flowy from "@/pages/Workflow/assets/js/flowy.js";
//import {startFlowy} from '@/pages/Workflow/assets/js/main.js';
//import DatePicker from "vue2-datepicker";

import flatpickrcss from "@/pages/Workflow/assets/css/flatpickr.min.css";
import flatpickr1 from "@/pages/Workflow/assets/js/flatpickr.js";

// Import SlimSelect from npm package instead of CDN
import SlimSelect from 'slim-select';
import 'slim-select/dist/slimselect.min.css';

import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import mixin from "../../../mixin.js";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import axios from 'axios';
import AwsStlConverter from "@/pages/Workflow/components/index.js";
import moment from "moment-timezone";
import CommonQueries from '@/sql/queries';
import KanbanModal from '../../Kanban/KanbanModal.vue';
import FeatureRequestButton from '@/components/FeatureRequestButton/FeatureRequestButton.vue';
import FeatureRequestNote from '@/components/FeatureRequestButton/FeatureRequestNote.vue';
import { listVerifiedEmails } from '@/utils/verifiedSender.js';
import { isEmailEnabled, isSmsEnabled, hasSmsNumber, SMS_DISABLED_MESSAGE } from '@/utils/siteCapability.js';
import { withoutReviewRequestTemplates } from '@/utils/wikiTags';

export default {
  name: "WorkflowBuilder",
  components: { ErrorDisplay, KanbanModal, FeatureRequestButton, FeatureRequestNote },
  mixins: [mixin],
  props: ['workflowID'],

  created() {
    if(this.allSettings)
      this.init();
  },

  async mounted() {
    //console.log(`mounted`);
    
    // Add workflow-page class to body to exclude from DatePicker z-index fix
    document.body.classList.add('workflow-page');

    // Set up global reference for JavaScript functions to access Vue instance
    window.vueInstance = this;

    // Make SlimSelect globally available since it's imported
    window.SlimSelect = SlimSelect;
    console.log('✅ SlimSelect loaded from npm package and made globally available');

    // ========================================
    // DROPDOWN POSITIONING FIX FOR WORKFLOW PANELS
    // ========================================
    // SlimSelect dropdowns inside scrollable containers (.blockprops) need
    // to be repositioned when opened to avoid appearing off-screen or misaligned.
    // This fix uses MutationObserver to detect when dropdowns open and repositions them.
    
    const repositionDropdown = (ssContent, ssMain) => {
      if (!ssContent || !ssMain) return;
      
      // Get the select element's position relative to the viewport
      const rect = ssMain.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      
      // Calculate available space below and above the select element
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;
      
      // Estimate dropdown height (use actual height if available, otherwise estimate)
      const dropdownHeight = ssContent.offsetHeight || 250;
      const dropdownWidth = rect.width;
      
      // Determine if dropdown should open above or below
      const openBelow = spaceBelow >= dropdownHeight || spaceBelow >= spaceAbove;
      
      // Calculate position
      let top, left;
      
      if (openBelow) {
        top = rect.bottom;
      } else {
        top = rect.top - dropdownHeight;
      }
      
      left = rect.left;
      
      // Ensure dropdown doesn't go off-screen horizontally
      if (left + dropdownWidth > viewportWidth) {
        left = viewportWidth - dropdownWidth - 10; // 10px padding from edge
      }
      if (left < 10) {
        left = 10;
      }
      
      // Ensure dropdown doesn't go off-screen vertically
      if (top < 10) {
        top = 10;
      }
      if (top + dropdownHeight > viewportHeight) {
        top = viewportHeight - dropdownHeight - 10;
      }
      
      // Apply fixed positioning with calculated values
      ssContent.style.cssText = `
        position: fixed !important;
        top: ${top}px !important;
        left: ${left}px !important;
        width: ${dropdownWidth}px !important;
        z-index: 999999 !important;
        max-height: ${Math.min(dropdownHeight, openBelow ? spaceBelow - 10 : spaceAbove - 10)}px !important;
        overflow-y: auto !important;
        background-color: #fff !important;
        box-shadow: 0 4px 20px rgba(0,0,0,0.2) !important;
        border-radius: 4px !important;
      `;
    };

    // Track the most recently clicked ss-main element
    let lastClickedMain = null;
    
    // Listen for clicks on ss-main elements to track which one was clicked
    document.addEventListener('click', (e) => {
      const ssMain = e.target.closest('.ss-main');
      if (ssMain) {
        lastClickedMain = ssMain;
        // Store timestamp to handle edge cases
        lastClickedMain._clickTime = Date.now();
      }
    }, true); // Use capture phase to catch before SlimSelect handles it
    
    // Helper function to find the ss-main associated with an ss-content
    const findAssociatedMain = (ssContent) => {
      // Method 1: Use the most recently clicked ss-main (most reliable!)
      // Only use if clicked within the last 500ms
      if (lastClickedMain && lastClickedMain._clickTime && (Date.now() - lastClickedMain._clickTime) < 500) {
        return lastClickedMain;
      }
      
      // Method 2: Find the ss-main with ss-open class (SlimSelect adds this when open)
      const openMains = document.querySelectorAll('.ss-main.ss-open');
      if (openMains.length === 1) {
        return openMains[0];
      }
      
      // Method 3: Check if ss-content has a data-id attribute matching ss-main
      const dataId = ssContent.getAttribute('data-id');
      if (dataId) {
        const mainById = document.querySelector(`.ss-main[data-id="${dataId}"]`);
        if (mainById) return mainById;
      }
      
      // Method 4: SlimSelect stores reference in the content element
      if (ssContent.main) return ssContent.main;
      
      // Method 5: Check previousElementSibling (works when not appended to body)
      if (ssContent.previousElementSibling && ssContent.previousElementSibling.classList.contains('ss-main')) {
        return ssContent.previousElementSibling;
      }
      
      // Method 6: Use lastClickedMain as fallback even if older
      if (lastClickedMain) {
        return lastClickedMain;
      }
      
      return null;
    };

    // Create a MutationObserver to watch for SlimSelect dropdowns opening
    const dropdownObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          
          // Check if this is a SlimSelect content element that just opened
          if (target.classList && target.classList.contains('ss-content') && target.classList.contains('ss-open')) {
            // Find the associated ss-main element using our helper
            const ssMain = findAssociatedMain(target);
            if (ssMain) {
              // Small delay to ensure dropdown is fully rendered
              requestAnimationFrame(() => {
                repositionDropdown(target, ssMain);
              });
            }
          }
        }
        
        // Also handle new dropdown elements being added to the DOM
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Check if this is a ss-content element
              if (node.classList && node.classList.contains('ss-content')) {
                const ssMain = findAssociatedMain(node);
                if (ssMain) {
                  requestAnimationFrame(() => {
                    repositionDropdown(node, ssMain);
                  });
                }
              }
              
              // Also check for ss-content elements inside the added node
              const ssContents = node.querySelectorAll ? node.querySelectorAll('.ss-content.ss-open') : [];
              ssContents.forEach((ssContent) => {
                const ssMain = findAssociatedMain(ssContent);
                if (ssMain) {
                  requestAnimationFrame(() => {
                    repositionDropdown(ssContent, ssMain);
                  });
                }
              });
            }
          });
        }
      });
    });

    // Start observing the document body for dropdown changes
    dropdownObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // Also reposition dropdowns on scroll within the properties panel
    document.addEventListener('scroll', (e) => {
      // Check if scroll happened inside a blockprops panel
      if (e.target && e.target.closest && e.target.closest('.blockprops')) {
        const openDropdowns = document.querySelectorAll('.ss-content.ss-open');
        openDropdowns.forEach((ssContent) => {
          const ssMain = findAssociatedMain(ssContent);
          if (ssMain) {
            repositionDropdown(ssContent, ssMain);
          }
        });
      }
    }, true); // Use capture to catch scroll events on nested elements

    // Reposition dropdowns on window resize
    window.addEventListener('resize', () => {
      const openDropdowns = document.querySelectorAll('.ss-content.ss-open');
      openDropdowns.forEach((ssContent) => {
        const ssMain = findAssociatedMain(ssContent);
        if (ssMain) {
          repositionDropdown(ssContent, ssMain);
        }
      });
    });

    // Store observer reference for cleanup
    this._dropdownObserver = dropdownObserver;
    
    console.log('✅ SlimSelect dropdown positioning fix initialized');
    // ========================================
    // END DROPDOWN POSITIONING FIX
    // ========================================

    let _this = this;

    // Define the addTagFunction for SlimSelect
    window.addTagFunction = function(value) {
      // Return the new tag in the format expected by SlimSelect
      return {
        text: value,
        value: value
      };
    };

    // Keep track of all tag SlimSelect instances
    window.tagSlimSelectInstances = [];
    
    // CRITICAL: Also maintain a direct selector-to-instance mapping for reliable access
    if (!window.tagSlimSelectInstancesBySelector) {
      window.tagSlimSelectInstancesBySelector = {};
    }

    // Helper function - SlimSelect is now always ready since it's imported
    window.whenSlimSelectReady = function(callback) {
      // SlimSelect is imported at module load time, so it's always ready
      callback();
    };

    // FIXED: Single, definitive function to update all tag SlimSelect instances
    // This function PRESERVES selected values when updating data
    window.updateAllTagSlimSelects = function() {
      if (!window.tagSlimSelectInstances || window.tagSlimSelectInstances.length === 0) {
        return;
      }
      
      const latestTagData = window.availableTaskTags || [];
      
      window.tagSlimSelectInstances.forEach((instance, index) => {
        try {
          // SlimSelect v1.x uses selected() method, NOT getSelected()
          if (instance && typeof instance.setData === 'function' && typeof instance.selected === 'function') {
            // CRITICAL: Save currently selected values BEFORE updating data
            const selectedValues = instance.selected() || [];
            console.log(`💾 Instance ${index + 1} - Saved ${selectedValues.length} selected values:`, selectedValues);

            // Update the data (this clears selections internally in SlimSelect)
            instance.setData(latestTagData);

            // CRITICAL: Restore selected values AFTER updating data
            if (selectedValues && selectedValues.length > 0) {
              // Small delay to ensure SlimSelect has fully processed the data update
              setTimeout(() => {
                instance.setSelected(selectedValues);
                console.log(`✅ Instance ${index + 1} - Restored ${selectedValues.length} selections`);
              }, 10);
            } else {
              console.log(`ℹ️ Instance ${index + 1} - No selections to restore`);
            }
          }
        } catch (error) {
          console.error(`❌ Error updating SlimSelect instance ${index + 1}:`, error);
        }
      });
    };
    window.createTaggableSlimSelect = function(selector, data, placeholder) {
      // Ensure SlimSelect is ready before creating instance
      window.whenSlimSelectReady(() => {
        try {
          // Ensure we have valid data
          const tagData = data || window.availableTaskTags || [];
          
          // CRITICAL: Declare instance variable BEFORE new SlimSelect()
          // This allows the addable callback to reference it via closure
          let instance;
          
          instance = new SlimSelect({
            select: selector,
            data: tagData,
            placeholder: placeholder || 'Select or add tags...',
            allowDeselect: true,
            // FIXED: In SlimSelect v1.x, addable MUST be a SYNCHRONOUS function
            // It cannot be async because SlimSelect expects immediate return of the option object
            addable: function(value) {
              console.log('🏷️ SlimSelect addable function triggered with:', value);
              console.log('🔍 Looking up instance for selector:', selector);
              
              // CRITICAL: Direct lookup by selector - guaranteed to be the right instance
              const slimInstance = window.tagSlimSelectInstancesBySelector ? window.tagSlimSelectInstancesBySelector[selector] : null;
              
              console.log('🔍 Found SlimSelect instance by selector:', !!slimInstance);
              console.log('🔍 Instance has getSelected:', slimInstance ? typeof slimInstance.getSelected : 'N/A');
              console.log('🔍 Instance has selected:', slimInstance ? typeof slimInstance.selected : 'N/A');
              console.log('🔍 Instance keys:', slimInstance ? Object.keys(slimInstance).slice(0, 10) : 'N/A');
              
              // CRITICAL: Persist tag to Firestore task-tags collection (async, non-blocking)
              // This happens in the background and doesn't block the return
              if (_this.siteID && value && value.trim()) {
                _this.$store.dispatch('tasks/addSiteTaskTag', {
                  siteID: _this.siteID,
                  tagName: value.trim()
                }).catch(error => {
                  console.error('❌ Error persisting tag to task-tags collection:', error);
                  // Don't block user if persistence fails - tag still added locally
                });
              }
              
              // KEEP: Add to locallyAddedTags for immediate availability (backwards compatibility)
              if (_this.locallyAddedTags.indexOf(value) === -1) {
                _this.locallyAddedTags.push(value);
              }
              
              // KEEP: Update window.availableTaskTags (backwards compatibility)
              const tagAlreadyExists = window.availableTaskTags.some(tag => tag.value === value);
              if (!tagAlreadyExists) {
                window.availableTaskTags.push({ text: value, value: value });
              }

              // CRITICAL FIX: Get current selections BEFORE updating other instances
              // Use the instance from window.tagSlimSelectInstances array (has working methods)
              let currentlySelected = [];
              let newSelected = [value];
              
              try {
                // SlimSelect v1.x API uses selected() method, NOT getSelected()!
                if (slimInstance && typeof slimInstance.selected === 'function') {
                  // selected() returns array of currently selected values
                  currentlySelected = slimInstance.selected() || [];
                  newSelected = currentlySelected.includes(value) ? currentlySelected : [...currentlySelected, value];
                } else {
                  console.error('SlimSelect instance missing selected() method');
                }
              } catch (error) {
                console.error('❌ Error getting current selections:', error);
              }

              // Update all OTHER tag SlimSelect instances with the new tag data
              // IMPORTANT: Do this AFTER we've captured the current selection
              if (!tagAlreadyExists && typeof window.updateAllTagSlimSelects === 'function') {
                // The updateAllTagSlimSelects function now preserves selections automatically
                window.updateAllTagSlimSelects();
              }

              // CRITICAL FIX: Auto-select the newly added tag in THIS instance
              // Use a slightly longer delay to ensure:
              // 1. SlimSelect's internal processing is complete
              // 2. The updateAllTagSlimSelects has finished (with its own 10ms delay)
              setTimeout(() => {
                try {
                  // Re-lookup the instance by selector
                  const foundInstance = window.tagSlimSelectInstancesBySelector ? window.tagSlimSelectInstancesBySelector[selector] : null;
                  
                  if (foundInstance && typeof foundInstance.setSelected === 'function') {
                    foundInstance.setSelected(newSelected);
                  } else {
                    console.error('Cannot auto-select: SlimSelect instance not available');
                  }
                } catch (error) {
                  console.error('❌ Error auto-selecting tag:', error);
                }
              }, 50); // Increased from 0ms to 50ms to ensure proper timing

              // CRITICAL: Return the new option IMMEDIATELY (SYNCHRONOUS)
              // SlimSelect v1.x requires immediate return, not a Promise
              console.log('🔙 Returning new option to SlimSelect:', { text: value, value: value });
              return { text: value, value: value };
            }
          });

          // Add this instance to our tracking array
          if (!window.tagSlimSelectInstances) {
            window.tagSlimSelectInstances = [];
          }
          window.tagSlimSelectInstances.push(instance);
          
          // CRITICAL: Also store by selector for direct lookup in addable callback
          if (!window.tagSlimSelectInstancesBySelector) {
            window.tagSlimSelectInstancesBySelector = {};
          }
          window.tagSlimSelectInstancesBySelector[selector] = instance;
          
          return instance;
        } catch (error) {
          console.error('Error creating taggable SlimSelect:', error);
          // Return a fallback instance with same addable function pattern
          return new SlimSelect({
            select: selector,
            data: [],
            placeholder: placeholder || 'Select or add tags...',
            allowDeselect: true,
            addable: window.addTagFunction || function(value) { 
              return { text: value, value: value }; 
            }
          });
        }
      }); // End of whenSlimSelectReady
    };

    var rightcard = false;
    var tempblock;
    var tempblock2;
    var currentblock;
    var currentblockid;
    var selectedblock;
    var addMoreIndexForSendEmail = 0;
    var addMoreIndexForAssignTask = 0;
    var addMoreIndexForSendSms = 0;
    var uniqueid;

    var counterArray = [];  // array of counters for email, sms, etc..

    var dueDateOptions = [
        { value: 'immediately', text: "Immediately" },
        { value: '1day', text: "1 Day After Appointment is created" },
        { value: '2days', text: "2 Days After Appointment is created" },
        { value: '1dayb', text: "1 Day Before Appointment Date" },
        { value: '2daysb', text: "2 Days After Appointment Date" },
        { value: '1weekb', text: "1 Week Before Appointment Date" },
    ];

    var smsSendOptions = [
        { value: "immediately", text: "Immediately" },
        { value: '1dayb', text: "1 Day Before the Appointment Day" },
        { value: '2daysb', text: "2 Days Before the Appointment Day" },
        { value: '3daysb', text: "3 Days Before the Appointment Day" },
        { value: '1weekb', text: "1 Week Before the Appointment Day" },
    ];

    var emailSendOptions = [
        { value: null, text: "Please select an option" },
        { value: "immediately", text: "Immediately" },
        { value: '1dayb', text: "1 Day Before the Appointment Day" },
        { value: '2daysb', text: "2 Days Before the Appointment Day" },
        { value: '3daysb', text: "3 Days Before the Appointment Day" },
        { value: '1weekb', text: "1 Week Before the Appointment Day" },
    ];

    var sendFormOptions = [
        { value: null, text: "Please select an option" },
        { value: "immediately", text: "Immediately" },
        { value: '1dayb', text: "1 Day Before the Appointment Day" },
        { value: '2daysb', text: "2 Days Before the Appointment Day" },
        { value: '3daysb', text: "3 Days Before the Appointment Day" },
        { value: '1weekb', text: "1 Week Before the Appointment Day" },
    ];

    var sendViaOptions = [
        { text: 'SMS', value: 'SMS'},
        { text: 'Email', value: 'Email'}
    ];

    if(!window.employees) {
      window.employees = [];
      for (let i = 0; i < this.activeEmployees.length; i++) {
        let emp = this.activeEmployees[i];
        window.employees.push(
          {
            text: emp.Name,
            value: emp.EmployeeID,
            html: emp.Name
          }
        );
      }
    }

    let blocks = [
      {
        id: 1,
        type: "triggers",
        name: "New Patient",
        img: "eye", // image to show when block is not selected
        imgSelected: "eyeblue", // image to show when block is selected
        desc: "Triggers when a new patient is entered into Open Dental",
        selectedDesc:
          "When a <span>new patient</span> is entered into Open Dental</span>",
        propertiesDivPrefix: "newpatient",
        enabled: false
      },
      {
        id: 2,
        type: "triggers",
        name: "Appointment Scheduled",
        img: "action",
        imgSelected: "actionblue",
        desc: "Triggers when a new appointment is scheduled",
        selectedDesc: "When <span>Appointment</span> is scheduled",
        propertiesDivPrefix: "",
        enabled: true
      },
      {
        id: 3,
        type: "triggers",
        name: "Appointment Broken",
        img: "appointment",
        imgSelected: "appointment",
        desc: "Triggers when an appointment is cancelled",
        selectedDesc: "When <span>appointment</span> is cancelled",
        propertiesDivPrefix: "",
        enabled: true
      },
      {
        id: 4,
        type: "triggers",
        name: "Appointment Completed",
        img: "appointment",
        imgSelected: "appointment",
        desc: "Triggers when an appointment is marked completed",
        selectedDesc:
          "When <span>appointment</span> is mark completed with <span>CDT code</span>",
        propertiesDivPrefix: "",
        enabled: true
      },
      {
        id: 5,
        type: "triggers",
        name: "Pre-Auth Marked As Received",
        img: "appointment",
        imgSelected: "appointment",
        desc: "Triggers when a Pre-Auth claim is marked as Received in Open Dental",
        selectedDesc: "When a Pre-Auth claim is marked as Received",
        propertiesDivPrefix: "",
        enabled: false
      },
      {
        id: 6,
        type: "triggers",
        name: "# Teamio Followups Completed",
        img: "appointment",
        imgSelected: "appointment",
        desc: "Triggers when an X number of followups for a patient completed",
        selectedDesc: "When <span>X</span> Followups are done",
        propertiesDivPrefix: "xFollowupsCompleted",
        params: true, // requires extra parameter input from user
        enabled: true
      },

      {
        id: 7,
        type: "triggers",
        name: "A Procedure Is Marked As Referral",
        img: "appointment",
        imgSelected: "appointment",
        desc: "Triggers when a code is marked as Referral in Open Dental",
        selectedDesc: "When a referral code is entered",
        propertiesDivPrefix: "",
        enabled: false
      },
      {
        id: 8,
        type: "triggers",
        name: "New Website Form Submission",
        img: "appointment",
        imgSelected: "appointment",
        desc: "Triggers when website form is submitted",
        selectedDesc: "When website form is submitted",
        propertiesDivPrefix: "",
        enabled: false
      },
      {
        id: 9,
        type: "actions",
        name: "Send Text Message",
        img: "smartphone-and-speech-bubble",
        imgSelected: "smartphone-and-speech-bubble",
        desc: "Send a text message to a contact",
        selectedDesc: "Send <span>text message</span> to <span>contact</span>",
        propertiesDivPrefix: "sms",
        enabled: true
      },
      {
        id: 10,
        type: "actions",
        name: "Send Email",
        img: "email",
        imgSelected: "email",
        desc: "Send email to a contact",
        selectedDesc: "Send <span>email</span> to <span>contact</span>",
        propertiesDivPrefix: "email",
        enabled: true
      },
      {
        id: 11,
        type: "actions",
        name: "Assign Teamio Task",
        img: "task",
        imgSelected: "task",
        desc: "Assign task to someone",
        selectedDesc: "Assign <span>task</span> to <span>someone</span>",
        propertiesDivPrefix: "assigntask",
        enabled: true
      },
      {
        id: 12,
        type: "actions",
        name: "Create an Open Dental Popup",
        img: "task",
        imgSelected: "task",
        desc: "Create a popup window in Open Dental",
        selectedDesc: "Create a popup window in Open Dental",
        propertiesDivPrefix: "popup",
        enabled: false
      },

      /*
      {
        id: 13,
        type: "actions",
        name: "Make Teamio Automated Followup",
        img: "phone",
        imgSelected: "timeblue",
        desc: "Create Automated Followup in Teamio",
        selectedDesc: "Create Automated Followup in Teamio",
        propertiesDivPrefix: "createfollowup",
        enabled: false
      },
      */

      {
        id: 14,
        type: "actions",
        name: "Mail Letter",
        img: "postbox",
        imgSelected: "timeblue",
        desc: "Mail a Letter to X",
        selectedDesc: "Mail a Letter to X",
        propertiesDivPrefix: "mailletter",
        enabled: false
      },
      {
        id: 15,
        type: "actions",
        name: "Wait",
        img: "postbox",
        imgSelected: "timeblue",
        desc: "Wait for a certain duration",
        selectedDesc: "Wait for a certain duration",
        propertiesDivPrefix: "wait",
        enabled: true
      },
      {
        id: 25,
        type: "actions",
        name: "Send Slack Message",
        img: "slack",
        imgSelected: "slack",
        desc: "Send a message to a Slack channel",
        selectedDesc: "Send <span>Slack message</span> to <span>channel</span>",
        propertiesDivPrefix: "slack",
        enabled: true
      },
      {
        id: 16,
        type: "triggers",
        name: "Facebook Lead Generated",
        img: "eye", // image to show when block is not selected
        imgSelected: "eyeblue", // image to show when block is selected
        desc: "Triggers when a new Facebook Lead is Generated",
        selectedDesc: "When a <span>new Facebook lead</span> is generated</span>",
        propertiesDivPrefix: "newfacebooklead",
        enabled: false
      },
      {
        id: 17,
        type: "triggers",
        name: "Google Lead Generated",
        img: "eye", // image to show when block is not selected
        imgSelected: "eyeblue", // image to show when block is selected
        desc: "Triggers when a new Google Lead is Generated",
        selectedDesc:
          "When a <span>new Google lead</span> is generated</span>",
        propertiesDivPrefix: "newgooglelead",
        enabled: false
      },
      {
        id: 18,
        type: "actions",
        name: "Create a Follow-up for Prospective Lead",
        img: "eye",
        imgSelected: "eye",
        desc: "Create a Follow-up for Prospective Lead",
        selectedDesc: "Create a Follow-up for Prospective Lead",
        propertiesDivPrefix: "prospectivelead",
        enabled: true
      },
      {
        id: 19,
        type: "actions",
        name: "Send a Form",
        img: "eye",
        imgSelected: "eye",
        desc: "Send a Form to the patient to digitally sign",
        selectedDesc: "Send a Form to the patient to digitally sign",
        propertiesDivPrefix: "sendform",
        enabled: true
      },
      {
        id: 20,
        type: "actions",
        name: "Kanban",
        img: "eye",
        imgSelected: "eye",
        desc: "Take an action related to Kanban board",
        selectedDesc: "Take an action related to Kanban board",
        propertiesDivPrefix: "kanban",
        enabled: false
      },

      /*
      {
        id: 16,
        type: "actions",
        name: "Fail",
        img: "postbox",
        imgSelected: "timeblue",
        desc: "Function that always fails",
        selectedDesc: "Function that always fails",
        propertiesDivPrefix: "fail",
      },
      {
        id: 17,
        type: "actions",
        name: "Timeout",
        img: "postbox",
        imgSelected: "timeblue",
        desc: "Function that always times out",
        selectedDesc: "Function that always times out",
        propertiesDivPrefix: "timeout",
      }
      */
    ];

    function disableActionsNotAllowed(b) {
      if(window.workflowTrigger) {
        let notAllowed;

        switch (window.workflowTrigger) {
          case 'Appointment Scheduled':
            notAllowed = ['Create a Follow-up for Prospective Lead', 'Mail Letter', 'Create an Open Dental Popup'];
            break;
          case 'Appointment Broken':
            notAllowed = ['Create a Follow-up for Prospective Lead', 'Mail Letter', 'Create an Open Dental Popup', 'Send a Form'];
            break;

          case 'Appointment Completed':
            notAllowed = ['Create a Follow-up for Prospective Lead', 'Mail Letter', 'Create an Open Dental Popup'];
            break;

          case '# Teamio Followups Completed':
            notAllowed = ['Create a Follow-up for Prospective Lead', 'Mail Letter', 'Create an Open Dental Popup', 'Send a Form'];
            break;

          default:
            break;
        }

        if (notAllowed.includes(b.name)) {
          b.enabled = false;
        }
      }

      return b;
    }

    function makeBlock(b) {

      // below I'm turning any action that may not be allowed for this workflow trigger to be disabled EVEN IF it's enabled in the config file
      b = disableActionsNotAllowed(b);

      let ret;

      ret = b.enabled ? `<div class="blockelem create-flowy noselect">` : `<div class="blockelem create-flowy noselect blockdisabled">`
      return ret +
        `
                        <input type="hidden" name="blockelemtype" class="blockelemtype" value="${
                          b.type
                        }">
                        <input type="hidden" name="blockelemid" class="blockelemid" value="${
                          b.id
                        }">
                        <input type="hidden" name="blockelemname" class="blockelemname" value="${
                          b.name
                        }">
                        <div class="grabme">
                            <img src="${require("../assets/img/grabme.svg")}">
                        </div>
                        <div class="blockin">
                            <div class="blockico">
                                <span></span>
                                <img src="` +
        require(`../assets/img/${b.img}.svg`) +
        `" width="24px" height="24px">
                            </div>
                            <div class="blocktext">
                                <p class="blocktitle">${b.name}</p>
                                <p class="blockdesc">${b.desc}</p>
                            </div>
                        </div>
                    </div>`;
      return ret;
    }

    function makeSnappingBlock(b) {
      let ret;
      
      // Delete button for all blocks
      const deleteBtn = `<div class='block-delete-btn' title='Delete this block'>×</div>`;

      if(b.type === "triggers") {
        ret = `${deleteBtn}<div class='blockyleft'>
                          <img src="` +
          require(`../assets/img/${b.imgSelected}.svg`) +
          `" width="28px" height="28px">
                          <p class='blockyname'>${b.name}</p>
                      </div>`;

        if(b.params) {
          ret = ret + `<div class='blockyright'>
                          <img src="${require("../assets/img/more.svg")}">
                      </div>`;
        }

        ret = ret + `
                      <div class='blockydiv'>
                      </div>
                      <div class='blockyinfo'>${b.selectedDesc}</div>
        `;
      } else {
        ret = `${deleteBtn}<div class='blockyleft'>
                          <img src="` +
          require(`../assets/img/${b.imgSelected}.svg`) +
          `" width="28px" height="28px">
                          <p class='blockyname'>${b.name}</p>
                      </div>
                      <div class='blockyright'>
                          <img src="${require("../assets/img/more.svg")}">
                      </div>
                      <div class='blockydiv'>
                      </div>
                      <div class='blockyinfo'>${b.selectedDesc}</div>
        `;
      }
      return ret;
    }

    function getSnappingBlock(id) {
      return blocks.filter((o) => o.id === parseInt(id, 10))[0];
    }

    function getBlocksByType(type) {
      return blocks.filter((o) => o.type === type);
    }

    function makeAllBlocks(_blocks) {
      let blockHtml = "";
      _blocks.forEach(function (b) {
        blockHtml += makeBlock(b);
      });
      return blockHtml;
    }

    /* This function saves all the block level properties back onto the DIV element with DATA attribute because that's what the FLOWY library outputs */

    function savePropertiesToDivData() {
      //console.log(`saving properties...`);
      selectedblock.setAttribute("data-saumil", "2");
    }

    //document.getElementById("blocklist").innerHTML = '<div class="blockelem create-flowy noselect"><input type="hidden" name="blockelemtype" class="blockelemtype" value="1"><div class="grabme"><img src="' + require(`../assets/img/grabme.svg`) + '"></div><div class="blockin">                  <div class="blockico"><span></span><img src="' + require(`../assets/img/eye.svg`) + '"></div><div class="blocktext">                        <p class="blocktitle">New visitor</p><p class="blockdesc">Triggers when somebody visits a specified page</p>        </div></div></div><div class="blockelem create-flowy noselect"><input type="hidden" name="blockelemtype" class="blockelemtype" value="2"><div class="grabme"><img src="' + require(`../assets/img/grabme.svg`) + '"></div><div class="blockin">                    <div class="blockico"><span></span><img src="' + require(`../assets/img/action.svg`) + '"></div><div class="blocktext">                        <p class="blocktitle">Action is performed</p><p class="blockdesc">Triggers when somebody performs a specified action</p></div></div></div><div class="blockelem create-flowy noselect"><input type="hidden" name="blockelemtype" class="blockelemtype" value="3"><div class="grabme"><img src="' + require(`../assets/img/grabme.svg`) + '"></div><div class="blockin">                    <div class="blockico"><span></span><img src="' + require(`../assets/img/time.svg`) + '"></div><div class="blocktext">                        <p class="blocktitle">Time has passed</p><p class="blockdesc">Triggers after a specified amount of time</p>          </div></div></div><div class="blockelem create-flowy noselect"><input type="hidden" name="blockelemtype" class="blockelemtype" value="4"><div class="grabme"><img src="' + require(`../assets/img/grabme.svg`) + '"></div><div class="blockin">                    <div class="blockico"><span></span><img src="' + require(`../assets/img/time.svg`) + '"></div><div class="blocktext">                        <p class="blocktitle">Error prompt</p><p class="blockdesc">Triggers when a specified error happens</p>              </div></div></div>';
    document.getElementById("blocklist").innerHTML = makeAllBlocks(
      getBlocksByType("triggers")
    );

    window.flowy(document.getElementById("canvas"), drag, release, snapping);

    // CRITICAL FIX: Clean up any stuck drag classes from all blocks
    // This ensures blocks that were left in a dragging state are clickable
    function cleanupAllBlockDragClasses() {
      const allBlocks = document.querySelectorAll(".block");
      allBlocks.forEach(function(block) {
        if (block.classList) {
          block.classList.remove("dragging", "dragging-block", "being-dragged");
        }
      });
    }
    
    // Inject delete buttons into all blocks that don't have one
    function injectDeleteButtons() {
      const allBlocks = document.querySelectorAll("#canvas .block");
      allBlocks.forEach(function(block) {
        // Check if block already has a delete button
        if (!block.querySelector('.block-delete-btn')) {
          const deleteBtn = document.createElement('div');
          deleteBtn.className = 'block-delete-btn';
          deleteBtn.title = 'Delete this block';
          deleteBtn.innerHTML = '×';
          block.insertBefore(deleteBtn, block.firstChild);
        }
      });
    }
    
    // Run cleanup on initialization
    cleanupAllBlockDragClasses();
    
    // Also run cleanup whenever blocks are imported (when loading a saved workflow)
    const originalFlowyImport = window.flowy.import;
    window.flowy.import = function() {
      const result = originalFlowyImport.apply(this, arguments);
      setTimeout(function() {
        cleanupAllBlockDragClasses();
        injectDeleteButtons(); // Add delete buttons to imported blocks
      }, 100); // Small delay to ensure DOM is updated
      return result;
    };
    
    // Also inject after a short delay on initial load
    setTimeout(injectDeleteButtons, 500);

    function addEventListenerMulti(type, listener, capture, selector) {
      var nodes = document.querySelectorAll(selector);
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].addEventListener(type, listener, capture);
      }
    }

    // Flag to track if we should reject the block being added
    var rejectBlock = false;
    var blockToReject = null;
    var needsCanvasReset = false;
    
    function snapping(drag, first) {
      console.log(`in snapping, first: ${first}`);
      
      // If we previously rejected a block and need canvas reset, force a full reset
      if (needsCanvasReset && first) {
        console.log(`Canvas needs reset after previous rejection, forcing deleteBlocks`);
        window.flowy.deleteBlocks();
        needsCanvasReset = false;
      }
      
      // Reset the reject flag
      rejectBlock = false;
      blockToReject = null;
      
      // Check if this is a trigger block and if it's a duplicate BEFORE allowing the snap
      // Use querySelector to get the block type and name reliably
      var blockTypeInput = drag.querySelector(".blockelemtype");
      var blockNameInput = drag.querySelector(".blockelemname");
      
      console.log(`blockTypeInput:`, blockTypeInput);
      console.log(`blockNameInput:`, blockNameInput);
      
      if (blockTypeInput && blockTypeInput.value === "triggers" && blockNameInput) {
        var triggerType = blockNameInput.value;
        console.log(`Checking trigger type: ${triggerType}`);
        
        var workflowExistsWithSameTrigger = window.workflows && window.workflows.filter(w => w.TriggerOn === triggerType).length > 0;
        console.log(`workflowExistsWithSameTrigger: ${workflowExistsWithSameTrigger}`);
        
        if (workflowExistsWithSameTrigger) {
          alert('You already have a workflow with the same trigger. You can not create a new workflow. Please go back and edit the existing workflow');
          // Set flag to reject this block and store reference
          rejectBlock = true;
          blockToReject = drag;
          console.log(`Set rejectBlock flag to true`);
          
          // Schedule removal and cleanup after Flowy adds it
          setTimeout(function() {
            if (blockToReject && blockToReject.parentNode) {
              console.log(`Removing rejected block and resetting canvas`);
              
              // Remove from DOM
              blockToReject.parentNode.removeChild(blockToReject);
              
              // Clear all blocks to reset Flowy's internal state
              // This is necessary because Flowy's blocks array is now out of sync
              window.flowy.deleteBlocks();
              
              blockToReject = null;
              rejectBlock = false;
              window.workflowTrigger = null;
              needsCanvasReset = false;
            }
          }, 10);
          
          // Still return true because Flowy doesn't respect false in firstBlock scenario
          // But we'll remove it right after via setTimeout
        } else {
          // Set the workflow trigger since it's valid
          window.workflowTrigger = triggerType;
          console.log(`Set window.workflowTrigger to: ${triggerType}`);
        }
      }
      
      var grab = drag.querySelector(".grabme");
      if (grab && grab.parentNode) {
        grab.parentNode.removeChild(grab);
      }
      var blockin = drag.querySelector(".blockin");
      if (blockin && blockin.parentNode) {
        blockin.parentNode.removeChild(blockin);
      }

      //let blockID = drag.querySelector(".blockelemtype").value;
      let blockID = drag.querySelector(".blockelemid").value;
      //console.log(`blockID: ${blockID}`);
      let dragHtml = makeSnappingBlock(getSnappingBlock(blockID));
      //console.log(`dragHtml: ${dragHtml}`);
      drag.innerHTML += dragHtml;
      return true;
    }
    function drag(block) {
      //console.log(`in drag`);
      block.classList.add("blockdisabled");
      tempblock2 = block;
    }
    function release() {
      //console.log(`in release`);
      if (tempblock2) {
        //console.dir(tempblock2);
        tempblock2.classList.remove("blockdisabled");
      }
    }
    var disabledClick = function () {
      //console.log(`in disabledClick, trigger: ${window.workflowTrigger}`);
      document.querySelector(".navactive").classList.add("navdisabled");
      document.querySelector(".navactive").classList.remove("navactive");
      this.classList.add("navactive");
      this.classList.remove("navdisabled");
      document.getElementById("blocklist").innerHTML = makeAllBlocks(
        getBlocksByType(this.getAttribute("id"))
      );
    };

    addEventListenerMulti("click", disabledClick, false, ".side");

    // Event delegation for block delete buttons
    document.addEventListener("click", function(e) {
      if (e.target && e.target.classList && e.target.classList.contains("block-delete-btn")) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the block element and its ID
        const blockElem = e.target.closest('.blockelem');
        if (!blockElem) {
          console.warn('[Workflow] Delete button clicked but no blockelem found');
          return;
        }
        
        const blockIdInput = blockElem.querySelector('.blockid');
        if (!blockIdInput) {
          console.warn('[Workflow] Delete button clicked but no blockid found');
          return;
        }
        
        const blockId = parseInt(blockIdInput.value);
        
        // Confirm deletion
        if (confirm('Are you sure you want to delete this block? This will also delete any connected child blocks.')) {
          if (window.flowy && typeof window.flowy.deleteBlock === 'function') {
            window.flowy.deleteBlock(blockId);
          } else {
            console.error('flowy.deleteBlock is not available');
          }
        }
      }
    });

    // Create event listeners for close and save buttons for the properties

    /*
    blocks.forEach(function (b) {
      if (document.getElementById(`${b.propertiesDivPrefix}close`)) {
        document
          .getElementById(`${b.propertiesDivPrefix}close`)
          .addEventListener("click", function () {
            console.log(`close clicked: ${b}`);
            if (rightcard) {
              rightcard = false;
              selectedblock = undefined;
              document
                .getElementById(`${b.propertiesDivPrefix}properties`)
                .classList.remove("expanded");
              setTimeout(function () {
                document
                  .getElementById(`${b.propertiesDivPrefix}wrap`)
                  .classList.remove("itson");
              }, 300);
              //console.log(tempblock);
              //tempblock.classList.remove("selectedblock");
              //console.log(tempblock);
            } else {
              console.error(
                `This case should not happen. If it did then look into it`
              );
            }
          });
      }
    });
    */

    function uid() {
      return (performance.now().toString(36)+Math.random().toString(36)).replace(/\./g,"");
    };

    function isFunctionDefined(functionName) {
      /*
      console.log(`typeof(functionName)`, typeof functionName);
      console.log(typeof(assigntaskLoad));
      console.log(typeof(globalThis[functionName]));
      console.log(typeof(globalThis[`${functionName}`]));
      console.log(typeof(window[functionName]));
      console.log(typeof(window[`${functionName}`]));
      */

      if (typeof(window[functionName]) === "function") {
        return true;
      }
    }

    function xFollowupsCompletedLoad(block, uniqueid) {
      //console.log('xFollowupsCompletedLoad called');
      if(!window[`xFollowupsCompletedPropertiesLoaded-${uniqueid}`]) {
        if(block.attributes[`data-xFollowupNumber`]) {
          let xFollowupNumber = block.attributes[`data-xFollowupNumber`].nodeValue;
          let e1 = document.getElementById(`xFollowupNumber-${uniqueid}`);
          e1.value = xFollowupNumber;
          window[`xFollowupsCompletedPropertiesLoaded-${uniqueid}`] = true;
        }
      }
    }

    function emailLoad(block, uniqueid) {

      const addMoreBtnEmail = document.getElementById(`addMoreCodesForEmail-${uniqueid}`);
      if (addMoreBtnEmail) {
        addMoreBtnEmail.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
          eventListenerForAddMoreCodesForEmail();
        });
      }

      if(!window[`emailPropertiesLoaded-${uniqueid}`]) {
        let triggerType = block.parentElement.childNodes[0].children[2].defaultValue;
        //console.log(`TriggerType: ${triggerType}`);
        window.triggerType = triggerType;

        if(triggerType === 'New Website Form Submission') {

          let procCodeTable = document.getElementById(`send-email-proccode-properties-${uniqueid}`);
          procCodeTable.style.display = 'none';

          let select1 = new SlimSelect({
            select: `#send-email-webform-elmname-${uniqueid}`,
            data: window.websiteFormElements,
            valuesUseText: true,
            showSearch: false,
          });

          let select2 = new SlimSelect({
            select: `#send-email-webform-elmval-${uniqueid}`,
            data: window.websiteFormElementValues,
            valuesUseText: true,
            showSearch: false,
          });

          let select3 = new SlimSelect({
            select: `#send-email-webform-template-${uniqueid}`,
            data: window.emailTemplates,
            valuesUseText: true
          });

          /*
          let select4 = new SlimSelect({
            select: `#send-email-when-${uniqueid}`,
            data: emailSendOptions,
            valuesUseText: true
          });
          */

          if (block.attributes[`data-send-email-properties`]) {
            let results = JSON.parse(block.attributes[`data-send-email-properties`].nodeValue);
            counterArray[uniqueid] = 0;

            let e0 = document.getElementById(`emailFromName-${uniqueid}`);
            let e1 = document.getElementById(`emailFrom-${uniqueid}`);
            let e2 = document.getElementById(`onlyIfPreviousUnopened-${uniqueid}`);

            e0.value = block.attributes[`data-emailfromname`].nodeValue;
            e1.value = block.attributes[`data-emailfromemail`].nodeValue;

            /*
            let onlyIfPreviousUnopened = block.attributes[`data-onlyIfPreviousUnopened`].nodeValue;
            //console.log(onlyIfPreviousUnopened);

            if(onlyIfPreviousUnopened.toUpperCase() === 'TRUE') {
              e2.checked = true;
              //console.log(`set checkbox to true`);
            }
            */

            for(let i= 0; i <results.length; i++) {
              let item = results[i];
              //console.dir(item);
              // The reason to do the logic below this way is because the 1st row is already defined in the mounted function
              if(i === 0) {
                let nodes = document.querySelectorAll(`[id^='send-email-webform-row-${uniqueid}']`);
                nodes[0].children[0].children[0].slim.setSelected(item.formElmName);
                nodes[0].children[1].children[0].slim.setSelected(item.formElmVal);
                nodes[0].children[2].children[0].slim.setSelected(item.emailTemplateID);
                //nodes[0].children[3].children[0].slim.setSelected(item.emailWhenID);
              } else {
                counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;

                let trID = `send-email-webform-row-${uniqueid}-${counterArray[uniqueid]}`;
                let formElmID = `send-email-task-webform-elmname-${uniqueid}-${counterArray[uniqueid]}`;
                let formElmValID = `send-email-webform-elmval-${uniqueid}-${counterArray[uniqueid]}`;
                let emailTemplateID = `send-email-webform-email-template-${uniqueid}-${counterArray[uniqueid]}`;
                //let emailWhenID = `send-email-webform-email-when-${uniqueid}-${counterArray[uniqueid]}`;
                let deleteID = `send-email-webform-delete-${uniqueid}-${counterArray[uniqueid]}`;

                let temp = `<td><select id="${formElmID}" multiple/></td>`;
                temp = `<td><select id="${formElmValID}" multiple/></td>`;
                temp = temp + `<td><select id="${emailTemplateID}"/></td>`;
                //temp = temp + `<td><select id="${emailWhenID}"/></td>`;
                temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

                let newNode = document.createElement('tr');
                newNode.setAttribute('id', trID);
                newNode.innerHTML = temp;
                let table = document.getElementById(`send-email-website-form-table-body-${uniqueid}`);
                table.appendChild(newNode);

                document.getElementById(deleteID).addEventListener("click", function (e) {
                  let temp = e.target.getAttribute("id").split('-');
                  let rowID = temp[temp.length - 1];
                  removeProcCode(`send-email-webform-row-${uniqueid}-${counterArray[uniqueid]}`);
                });

                let select1, select2, select3;

                if(!document.getElementById(`${formElmID}`).slim) {
                  select1 = new SlimSelect({
                    select: `#${formElmID}`,
                    data: window.websiteFormElements,
                    valuesUseText: true,
                    showSearch: false,
                  });
                } else
                  select1 = document.getElementById(`${formElmID}`).slim;

                select1.setSelected(item.formElmName);

                if(!document.getElementById(`${formElmValID}`).slim) {
                  select2 = new SlimSelect({
                    select: `#${formElmValID}`,
                    data: window.websiteFormElementValues,
                    valuesUseText: true,
                    showSearch: false,
                  });
                } else
                  select2 = document.getElementById(`${formElmID}`).slim;

                select2.setSelected(item.formElmVal);

                if(!document.getElementById(`${emailTemplateID}`).slim) {
                  select3 = new SlimSelect({
                    select: `#${emailTemplateID}`,
                    data: window.emailTemplateID,
                    valuesUseText: true
                  });
                } else
                  select3 = document.getElementById(`${emailTemplateID}`).slim;
                select3.setSelected(item.emailTemplateID);

                /*
                if(!document.getElementById(`${emailWhenID}`).slim) {
                  select4 = new SlimSelect({
                    select: `#${emailWhenID}`,
                    data: window.emailWhenID,
                    valuesUseText: true
                  });
                } else
                  select4 = document.getElementById(`${emailWhenID}`).slim;
                select4.setSelected(item.emailWhenID);
                */

              }
            }
          }

        } else {
          // trigger type is not website form submission
          let websiteFormTable = document.getElementById(`send-email-website-form-properties-${uniqueid}`);
          if(websiteFormTable)
            websiteFormTable.style.display = 'none';

          counterArray[uniqueid] = 0;

          let select1 = new SlimSelect({
            select: `#send-email-proc-code-${uniqueid}`,
            data: window.procCodes,
            valuesUseText: true
          });

          let select2 = new SlimSelect({
            select: `#send-email-template-${uniqueid}`,
            data: window.emailTemplates,
            valuesUseText: true
          });

          /*
          let select3 = new SlimSelect({
            select: `#send-email-when-${uniqueid}`,
            data: emailSendOptions,
            valuesUseText: true
          });
          */

          if (block.attributes[`data-send-email-properties`]) {
            let results = JSON.parse(block.attributes[`data-send-email-properties`].nodeValue);
            //console.dir(results);

            let e0 = document.getElementById(`emailFromName-${uniqueid}`);
            let e1 = document.getElementById(`emailFrom-${uniqueid}`);
            let e2 = document.getElementById(`onlyIfPreviousUnopened-${uniqueid}`);

            // Add null checks before setting values
            if (e0 && block.attributes[`data-emailfromname`]) {
              e0.value = block.attributes[`data-emailfromname`].nodeValue;
            } else {
              console.warn(`emailFromName element not found or attribute missing for uniqueid: ${uniqueid}`);
            }
            
            if (e1 && block.attributes[`data-emailfromemail`]) {
              e1.value = block.attributes[`data-emailfromemail`].nodeValue;
            } else {
              console.warn(`emailFrom element not found or attribute missing for uniqueid: ${uniqueid}`);
            }

            /*
            let onlyIfPreviousUnopened = block.attributes[`data-onlyIfPreviousUnopened`].nodeValue;
            //console.log(onlyIfPreviousUnopened);

            if(onlyIfPreviousUnopened.toUpperCase() === 'TRUE') {
              e2.checked = true;
              //console.log(`set checkbox to true`);
            }
            */

            for(let i= 0; i <results.length; i++) {
              let item = results[i];
              //console.dir(item);
              // The reason to do the logic below this way is because the 1st row is already defined in the mounted function
              if(i === 0) {
                let nodes = document.querySelectorAll(`[id^='send-email-row-${uniqueid}']`);
                nodes[0].children[0].children[0].slim.setSelected(item.codeNum);
                nodes[0].children[1].children[0].slim.setSelected(item.emailTemplateID);
                //nodes[0].children[2].children[0].slim.setSelected(item.emailWhenID);

              } else {
                counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;

                let trID = `send-email-row-${uniqueid}-${counterArray[uniqueid]}`;
                let procID = `send-email-proc-code-${uniqueid}-${counterArray[uniqueid]}`;
                let emailTemplateID = `send-email-email-template-${uniqueid}-${counterArray[uniqueid]}`;
                //let emailWhenID = `send-email-email-when-${uniqueid}-${counterArray[uniqueid]}`;
                let deleteID = `send-email-delete-${uniqueid}-${counterArray[uniqueid]}`;

                let temp = `<td><select id="${procID}" multiple/></td>`;
                temp = temp + `<td><select id="${emailTemplateID}"/></td>`;
                //temp = temp + `<td><select id="${emailWhenID}"/></td>`;
                temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

                let newNode = document.createElement('tr');
                newNode.setAttribute('id', trID);
                newNode.innerHTML = temp;
                let table = document.getElementById(`send-email-proc-table-body-${uniqueid}`);
                table.appendChild(newNode);

                document.getElementById(deleteID).addEventListener("click", function (e) {
                  let temp = e.target.getAttribute("id").split('-');
                  let rowID = temp[temp.length - 1];
                  removeProcCode(`send-email-row-${uniqueid}-${rowID}`);
                });

                let select1, select2;

                if(!document.getElementById(`${procID}`).slim) {
                  select1 = new SlimSelect({
                    select: `#${procID}`,
                    data: window.procCodes,
                    valuesUseText: true
                  });
                } else
                  select1 = document.getElementById(`${procID}`).slim;
                select1.setSelected(item.codeNum);

                if(!document.getElementById(`${emailTemplateID}`).slim) {
                  select2 = new SlimSelect({
                    select: `#${emailTemplateID}`,
                    data: window.emailTemplates,
                    valuesUseText: true
                  });
                } else
                  select2 = document.getElementById(`${emailTemplateID}`).slim;
                select2.setSelected(item.emailTemplateID);

                /*
                if(!document.getElementById(`${emailWhenID}`).slim) {
                  select2 = new SlimSelect({
                    select: `#${emailWhenID}`,
                    data: emailSendOptions,
                    valuesUseText: true
                  });
                } else
                  select2 = document.getElementById(`${emailWhenID}`).slim;
                select2.setSelected(item.emailWhenID);
                */
              }
            }
          }
        }
        window[`emailPropertiesLoaded-${uniqueid}`] = true;
      }
    }

    function smsLoad(block, uniqueid) {

      const addMoreBtnSms = document.getElementById(`addMoreCodesForSms-${uniqueid}`);
      if (addMoreBtnSms && addMoreBtnSms.__listenerAttached !== true) {
        addMoreBtnSms.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
          eventListenerForAddMoreCodesForSms();
        });
        addMoreBtnSms.__listenerAttached = true;
      }

      const smsAttrNode = block && block.attributes ? block.attributes[`data-send-sms-properties`] : null;
      const smsAttrValue = smsAttrNode ? smsAttrNode.nodeValue : null;
      let cachedSmsProps = [];
      let smsAttrParseError = null;

      if (smsAttrValue) {
        try {
          const parsed = JSON.parse(smsAttrValue);
          cachedSmsProps = Array.isArray(parsed) ? parsed : [];
        } catch (err) {
          smsAttrParseError = err.message;
          cachedSmsProps = [];
        }
      }

      if(!window[`smsPropertiesLoaded-${uniqueid}`]) {
        // Safely get trigger type with null checks
        let triggerType = '';
        try {
          if (block && block.parentElement && block.parentElement.childNodes && 
              block.parentElement.childNodes[0] && block.parentElement.childNodes[0].children &&
              block.parentElement.childNodes[0].children[2]) {
            triggerType = block.parentElement.childNodes[0].children[2].defaultValue;
          } else {
            console.warn('Unable to determine trigger type from block structure, defaulting to empty string');
          }
        } catch (error) {
          console.error('Error getting trigger type:', error);
        }
        window.triggerType = triggerType;

        if(triggerType === 'New Website Form Submission') {
          // hide proc code table from properties as it's not needed for this action
          let procCodeTable = document.getElementById(`send-sms-proccode-properties-${uniqueid}`);
          procCodeTable.style.display = 'none';

          let select1 = new SlimSelect({
            select: `#send-sms-webform-elmname-${uniqueid}`,
            data: window.websiteFormElements,
            valuesUseText: true,
            showSearch: false,
          });

          let select2 = new SlimSelect({
            select: `#send-sms-webform-elmval-${uniqueid}`,
            data: window.websiteFormElementValues,
            valuesUseText: true,
            showSearch: false,
          });

          let select3 = new SlimSelect({
            select: `#send-sms-webform-template-${uniqueid}`,
            data: window.smsTemplates,
            valuesUseText: true
          });

          let select4 = new SlimSelect({
            select: `#send-sms-webform-when-${uniqueid}`,
            data: smsSendOptions,
            valuesUseText: true
          });

          if (smsAttrValue && cachedSmsProps.length) {
            let results = cachedSmsProps;
            counterArray[uniqueid] = 0;

            for(let i= 0; i <results.length; i++) {
              let item = results[i];
              //console.dir(item);
              // The reason to do the logic below this way is because the 1st row is already defined in the mounted function
              if(i === 0) {
                let nodes = document.querySelectorAll(`[id^='send-sms-webform-row-${uniqueid}']`);
                const firstRow = nodes[0];
                if (firstRow && firstRow.children.length >= 3) {
                  const normalizedFormElmName = normalizeSlimSelectValue(item.formElmName, null);
                  const normalizedFormElmVal = normalizeSlimSelectValue(item.formElmVal, null);
                  const normalizedTemplateId = normalizeSlimSelectValue(item.smsTemplateID, null);

                  if (normalizedFormElmName) {
                    firstRow.children[0].children[0].slim.setSelected(normalizedFormElmName);
                  }
                  if (normalizedFormElmVal) {
                    firstRow.children[1].children[0].slim.setSelected(normalizedFormElmVal);
                  }
                  if (normalizedTemplateId) {
                    firstRow.children[2].children[0].slim.setSelected(normalizedTemplateId);
                  }
                }
              } else {
                counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;

                let trID = `send-sms-webform-row-${uniqueid}-${counterArray[uniqueid]}`;
                let formElmID = `send-sms-task-webform-elmname-${uniqueid}-${counterArray[uniqueid]}`;
                let formElmValID = `send-sms-webform-elmval-${uniqueid}-${counterArray[uniqueid]}`;
                let smsTemplateID = `send-sms-webform-email-template-${uniqueid}-${counterArray[uniqueid]}`;
                let deleteID = `send-sms-webform-delete-${uniqueid}-${counterArray[uniqueid]}`;

                let temp = `<td><select id="${formElmID}" multiple/></td>`;
                temp = `<td><select id="${formElmValID}" multiple/></td>`;
                temp = temp + `<td><select id="${smsTemplateID}"/></td>`;
                temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

                let newNode = document.createElement('tr');
                newNode.setAttribute('id', trID);
                newNode.innerHTML = temp;
                let table = document.getElementById(`send-sms-website-form-table-body-${uniqueid}`);
                table.appendChild(newNode);

                document.getElementById(deleteID).addEventListener("click", function (e) {
                  let temp = e.target.getAttribute("id").split('-');
                  let rowID = temp[temp.length - 1];
                  removeProcCode(`send-sms-webform-row-${uniqueid}-${counterArray[uniqueid]}`);
                });

                let select1, select2, select3;

                if(!document.getElementById(`${formElmID}`).slim) {
                  select1 = new SlimSelect({
                    select: `#${formElmID}`,
                    data: window.websiteFormElements,
                    valuesUseText: true,
                    showSearch: false,
                  });
                } else
                  select1 = document.getElementById(`${formElmID}`).slim;

                const normalizedFormElmName = normalizeSlimSelectValue(item.formElmName, null);
                if (normalizedFormElmName) {
                  select1.setSelected(normalizedFormElmName);
                }

                if(!document.getElementById(`${formElmValID}`).slim) {
                  select2 = new SlimSelect({
                    select: `#${formElmValID}`,
                    data: window.websiteFormElementValues,
                    valuesUseText: true,
                    showSearch: false,
                  });
                } else
                  select2 = document.getElementById(`${formElmValID}`).slim;

                const normalizedFormElmVal = normalizeSlimSelectValue(item.formElmVal, null);
                if (normalizedFormElmVal) {
                  select2.setSelected(normalizedFormElmVal);
                }

                if(!document.getElementById(`${smsTemplateID}`).slim) {
                  select3 = new SlimSelect({
                    select: `#${smsTemplateID}`,
                    data: window.smsTemplates,
                    valuesUseText: true
                  });
                } else
                  select3 = document.getElementById(`${smsTemplateID}`).slim;
                const normalizedTemplateId = normalizeSlimSelectValue(item.smsTemplateID, null);
                if (normalizedTemplateId) {
                  select3.setSelected(normalizedTemplateId);
                }
              }
            }
          }
        } else {
          // if the trigger is not website form submission

          let websiteFormTable = document.getElementById(`send-sms-website-form-properties-${uniqueid}`);
          if(websiteFormTable)
            websiteFormTable.style.display = 'none';

          counterArray[uniqueid] = 0;

          let select1 = new SlimSelect({
            select: `#send-sms-proc-code-${uniqueid}`,
            data: window.procCodes,
            valuesUseText: true
          });

          let select2 = new SlimSelect({
            select: `#send-sms-template-${uniqueid}`,
            data: window.smsTemplates,
            valuesUseText: true
          });

          if(window.workflowTrigger) {
            //alert(window.workflowTrigger);
            switch(window.workflowTrigger) {
              case 'Appointment Completed':
                                            smsSendOptions = [
                                                              { value: "immediately", text: "Immediately" },
                                                              { value: '1day', text: "1 Day After the Appointment is completed" },
                                                              { value: '2days', text: "2 Days After the Appointment is completed" }
                                                            ];
                                            break;

              case 'Appointment Scheduled':
                                            break;
              case 'Appointment Broken':    break;
            }
          }

          let select3 = new SlimSelect({
            select: `#send-sms-when-${uniqueid}`,
            data: smsSendOptions,
            valuesUseText: true
          });

          if (smsAttrValue && cachedSmsProps.length) {
            let results = cachedSmsProps;

            counterArray[uniqueid] = 0;

            for(let i= 0; i <results.length; i++) {
              let item = results[i];
              //console.dir(item);
              // The reason to do the logic below this way is because the 1st row is already defined in the mounted function
              if(i === 0) {
                let nodes = document.querySelectorAll(`[id^='send-sms-row-${uniqueid}']`);
                const normalizedCodeNums = normalizeSlimSelectValues(item.codeNum, []);
                const normalizedTemplateId = normalizeSlimSelectValue(item.smsTemplateID, null);
                const normalizedScheduleWhen = normalizeSlimSelectValue(item.scheduleWhen, null);

                if (normalizedCodeNums.length) {
                  nodes[0].children[0].children[0].slim.setSelected(normalizedCodeNums);
                }

                if (normalizedTemplateId) {
                  nodes[0].children[1].children[0].slim.setSelected(normalizedTemplateId);
                }

                if (normalizedScheduleWhen) {
                  nodes[0].children[2].children[0].slim.setSelected(normalizedScheduleWhen);
                }

              } else {
                counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;
                let trID = `send-sms-row-${uniqueid}-${counterArray[uniqueid]}`;
                let procID = `send-sms-proc-code-${uniqueid}-${counterArray[uniqueid]}`;
                let smsTemplateID = `send-sms-sms-template-${uniqueid}-${counterArray[uniqueid]}`;
                let scheduleWhen = `send-sms-when-${uniqueid}-${counterArray[uniqueid]}`;
                let deleteID = `send-sms-delete-${uniqueid}-${counterArray[uniqueid]}`;

                let temp = `<td><select id="${procID}" multiple/></td>`;
                temp = temp + `<td><select id="${smsTemplateID}"/></td>`;
                temp = temp + `<td><select id="${scheduleWhen}"/></td>`;
                temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

                let newNode = document.createElement('tr');
                newNode.setAttribute('id', trID);
                newNode.innerHTML = temp;
                let table = document.getElementById(`send-sms-proc-table-body-${uniqueid}`);
                table.appendChild(newNode);

                document.getElementById(deleteID).addEventListener("click", function (e) {
                  let temp = e.target.getAttribute("id").split('-');
                  let rowID = temp[temp.length - 1];
                  removeProcCode(`send-sms-row-${uniqueid}-${rowID}`);
                });

                let select1, select2, select3;

                if(!document.getElementById(`${procID}`).slim) {
                  select1 = new SlimSelect({
                    select: `#${procID}`,
                    data: window.procCodes,
                    valuesUseText: true
                  });
                } else
                  select1 = document.getElementById(`${procID}`).slim;
                const normalizedCodeNums = normalizeSlimSelectValues(item.codeNum, []);
                if (normalizedCodeNums.length) {
                  select1.setSelected(normalizedCodeNums);
                }

                if(!document.getElementById(`${smsTemplateID}`).slim) {
                  select2 = new SlimSelect({
                    select: `#${smsTemplateID}`,
                    data: window.smsTemplates,
                    valuesUseText: true
                  });
                } else
                  select2 = document.getElementById(`${smsTemplateID}`).slim;
                const normalizedTemplateId = normalizeSlimSelectValue(item.smsTemplateID, null);
                if (normalizedTemplateId) {
                  select2.setSelected(normalizedTemplateId);
                }

                if(!document.getElementById(`${scheduleWhen}`).slim) {
                  select3 = new SlimSelect({
                    select: `#${scheduleWhen}`,
                    data: smsSendOptions,
                    valuesUseText: true
                  });
                } else
                  select3 = document.getElementById(`${scheduleWhen}`).slim;
                const normalizedScheduleWhen = normalizeSlimSelectValue(item.scheduleWhen, null);
                if (normalizedScheduleWhen) {
                  select3.setSelected(normalizedScheduleWhen);
                }

              }
            }
          }
        }
        window[`smsPropertiesLoaded-${uniqueid}`] = true;
      }
    }

    function waitLoad(block, uniqueid) {
      if(!window[`waitPropertiesLoaded-${uniqueid}`]) {
        if(block.attributes[`data-waitFor`]) {
          let waitFor = block.attributes[`data-waitFor`].nodeValue;
          let waitUntilCondition = block.attributes[`data-waitUntilCondition`].nodeValue;
          if(waitFor.toUpperCase() === 'TRUE') {
            let e1 = document.getElementById(`waitFor-${uniqueid}`);
            e1.checked = true;
            document.getElementById(`waitForFirstOption-${uniqueid}`).style.display = 'block';
            let e3 = document.getElementById(`waitForDurationNum-${uniqueid}`);
            e3.value = block.attributes[`data-waitForDurationNum`].nodeValue;
            let e4 = document.getElementById(`waitForDurationOptionSelected-${uniqueid}`);
            e4.value = block.attributes[`data-waitForDurationOptionSelected`].nodeValue;
          } else if(waitUntilCondition.toUpperCase() === 'TRUE') {
            document.getElementById(`waitForThirdOption-${uniqueid}`).style.display = 'block';
            let e2 = document.getElementById(`waitUntilCondition-${uniqueid}`);
            e2.checked = true;
            let e5 = document.getElementById(`waitUntilConditionOptionSelected-${uniqueid}`);
            e5.value = block.attributes[`data-waitUntilConditionOptionSelected`].nodeValue;
          } else {
          }
          window[`waitPropertiesLoaded-${uniqueid}`] = true;
        }
      }
    }

    async function slackLoad(block, uniqueid) {
      if(!window[`slackPropertiesLoaded-${uniqueid}`]) {
        try {
          // Check Slack connection status
          const statusResponse = await axios.get('/slack/status', {
            params: { siteID: window.siteID }
          });
          
          const warningEl = document.getElementById(`slack-not-connected-warning-${uniqueid}`);
          const contentEl = document.getElementById(`slack-connected-content-${uniqueid}`);
          
          if (statusResponse.data && statusResponse.data.connected) {
            // Slack is connected - show the form
            if (warningEl) warningEl.style.display = 'none';
            if (contentEl) contentEl.style.display = 'block';
            
            // Fetch channels
            const channelsResponse = await axios.get('/slack/channels', {
              params: { siteID: window.siteID }
            });
            
            const channelSelect = document.getElementById(`slackChannel-${uniqueid}`);
            if (channelSelect && channelsResponse.data && channelsResponse.data.channels) {
              // Clear existing options except the placeholder
              channelSelect.innerHTML = '<option value="">-- Select a channel --</option>';
              
              // Add channels
              channelsResponse.data.channels.forEach(channel => {
                const option = document.createElement('option');
                option.value = channel.id;
                option.textContent = (channel.is_private ? '🔒 ' : '#') + channel.name;
                channelSelect.appendChild(option);
              });
              
              // If block has saved channel, select it
              if (block.attributes['data-slackChannelId']) {
                channelSelect.value = block.attributes['data-slackChannelId'].nodeValue;
              }
            }
            
            // Load saved message if exists
            const messageEl = document.getElementById(`slackMessage-${uniqueid}`);
            if (messageEl && block.attributes['data-slackMessage']) {
              messageEl.value = block.attributes['data-slackMessage'].nodeValue;
            }
          } else {
            // Slack not connected - show warning
            if (warningEl) warningEl.style.display = 'block';
            if (contentEl) contentEl.style.display = 'none';
          }
          
          window[`slackPropertiesLoaded-${uniqueid}`] = true;
        } catch (err) {
          console.error('Error loading Slack data:', err);
          const warningEl = document.getElementById(`slack-not-connected-warning-${uniqueid}`);
          const contentEl = document.getElementById(`slack-connected-content-${uniqueid}`);
          if (warningEl) warningEl.style.display = 'block';
          if (contentEl) contentEl.style.display = 'none';
        }
      }
    }

    function sendformLoad(block, uniqueid) {
      //console.log('In sendformLoad, now loading block', block);

      const addMoreBtnSendForm = document.getElementById(`addMoreCodesForSendForm-${uniqueid}`);
      if (addMoreBtnSendForm) {
        addMoreBtnSendForm.addEventListener("click", function(e) {
          e.preventDefault();
          e.stopPropagation();
          eventListenerForAddMoreCodesForSendForm();
        });
      }

      document.getElementById(`sendForNewPatientsCheck-${uniqueid}`).addEventListener("click", function() {
        if(this.checked) {
          document.getElementById(`sendForNewPatientsOnly-${uniqueid}`).style.display='block';
        }
        else
          document.getElementById(`sendForNewPatientsOnly-${uniqueid}`).style.display='none';
      });

      document.getElementById(`sendFormNewPatientsEmail-${uniqueid}`).addEventListener("click", function() {
        if(!this.checked) {
          block.removeAttribute('data-sendformnewpatientemail');
        }
      });

      document.getElementById(`sendFormNewPatientsText-${uniqueid}`).addEventListener("click", function() {
        if(!this.checked) {
          block.removeAttribute('data-sendformnewpatienttext');
        }
      });


      if(!window[`sendFormPropertiesLoaded-${uniqueid}`]) {

        const sendFormChoices = Array.isArray(window.forms) ? window.forms : [];

        let select1 = new SlimSelect({
          select: `#send-form-new-patient-send-with-email-template-${uniqueid}`,
          data: window.formEmailMessageTemplates || window.formEmailTemplates || [],
          valuesUseText: true
        });

        let select2 = new SlimSelect({
          select: `#send-form-new-patient-send-with-text-template-${uniqueid}`,
          data: window.formSmsMessageTemplates || window.formSmsTemplates || [],
          valuesUseText: true
        });

        let select3 = new SlimSelect({
          select: `#send-form-new-patient-send-with-email-when-${uniqueid}`,
          data: sendFormOptions,
          valuesUseText: true
        });

        let select4 = new SlimSelect({
          select: `#send-form-new-patient-send-with-text-when-${uniqueid}`,
          data: sendFormOptions,
          valuesUseText: true
        });

        let select5 = new SlimSelect({
            select: `#send-form-proc-code-${uniqueid}`,
            data: window.procCodes,
            valuesUseText: true
        });

        let select6 = new SlimSelect({
          select: `#send-form-send-via-${uniqueid}`,
          data: sendViaOptions,
          valuesUseText: true
        });

        let select7 = new SlimSelect({
          select: `#send-form-template-${uniqueid}`,
          data: sendFormChoices,
          valuesUseText: true
        });

        let select8 = new SlimSelect({
          select: `#send-form-when-${uniqueid}`,
          data: sendFormOptions,
          valuesUseText: true
        });

        if(block.attributes['data-sendformnewpatientonly']) {
          let emailTemplateID, smsTemplateID, emailSendWhen, smsSendWhen;
          let newPatientOnly = block.attributes['data-sendformnewpatientonly'].nodeValue;

          if(newPatientOnly === "true") {
            document.getElementById(`sendForNewPatientsCheck-${uniqueid}`).checked = true;
            document.getElementById(`sendForNewPatientsOnly-${uniqueid}`).style.display='block';

            if(block.attributes['data-sendformnewpatientemail'] && block.attributes['data-sendformnewpatientemail'].nodeValue === "true") {
              //console.log('email is true. now loading email templates');
              document.getElementById(`sendFormNewPatientsEmail-${uniqueid}`).checked = true;
              emailTemplateID = block.attributes['data-sendformnewpatientemailtemplateid'].nodeValue;
              emailSendWhen = block.attributes['data-sendformnewpatientemailsendwhen'].nodeValue;
              select1.setData(window.emailTemplates);
              select1.setSelected(emailTemplateID);
              select3.setSelected(emailSendWhen);
            }

            if(block.attributes['data-sendformnewpatienttext'] && block.attributes['data-sendformnewpatienttext'].nodeValue === "true") {
              //console.log('text is true. now loading sms templates');
              document.getElementById(`sendFormNewPatientsText-${uniqueid}`).checked = true;
              smsTemplateID = block.attributes['data-sendformnewpatientsmstemplateid'].nodeValue;
              smsSendWhen = block.attributes['data-sendformnewpatientsmssendwhen'].nodeValue;
              select2.setData(window.smsTemplates);
              select2.setSelected(smsTemplateID);
              select4.setSelected(smsSendWhen);
            }

          }
        }

        if (block.attributes[`data-send-form-properties`]) {
          let results = JSON.parse(block.attributes[`data-send-form-properties`].nodeValue);
          //console.log('data-send-form-properties', results);
          counterArray[uniqueid] = 0;

          for(let i= 0; i <results.length; i++) {
            let item = results[i];
            //console.log('item', item);
            // The reason to do the logic below this way is because the 1st row is already defined in the mounted function
            if(i === 0) {
              let nodes = document.querySelectorAll(`[id^='send-form-row-${uniqueid}']`);
              nodes[0].children[0].children[0].slim.setSelected(item.codeNum);
              nodes[0].children[1].children[0].slim.setSelected(item.sendVia);

              // Send Form must always use actual forms list
              nodes[0].children[2].children[0].slim.setData(sendFormChoices);

              nodes[0].children[1].children[0].addEventListener("change", function () {
                nodes[0].children[2].children[0].slim.setData(sendFormChoices);
              });


              nodes[0].children[2].children[0].slim.setSelected(item.templateID);
              nodes[0].children[3].children[0].slim.setSelected(item.scheduleWhen);

            } else {
              counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;
              let trID = `send-form-row-${uniqueid}-${counterArray[uniqueid]}`;
              let procID = `send-form-proc-code-${uniqueid}-${counterArray[uniqueid]}`;
              let sendVia = `send-form-send-via-${uniqueid}-${counterArray[uniqueid]}`;
              let templateID = `send-form-templateid-${uniqueid}-${counterArray[uniqueid]}`;
              let scheduleWhen = `send-form-when-${uniqueid}-${counterArray[uniqueid]}`;
              let deleteID = `send-form-delete-${uniqueid}-${counterArray[uniqueid]}`;

              let temp = `<td><select id="${procID}" multiple/></td>`;
              temp = temp + `<td><select id="${sendVia}"/></td>`;
              temp = temp + `<td><select id="${templateID}"/></td>`;
              temp = temp + `<td><select id="${scheduleWhen}"/></td>`;
              temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

              let newNode = document.createElement('tr');
              newNode.setAttribute('id', trID);
              newNode.innerHTML = temp;
              let table = document.getElementById(`send-form-proc-table-body-${uniqueid}`);
              table.appendChild(newNode);

              document.getElementById(deleteID).addEventListener("click", function (e) {
                let temp = e.target.getAttribute("id").split('-');
                let rowID = temp[temp.length - 1];
                removeProcCode(`send-form-row-${uniqueid}-${rowID}`);
              });

              let select1, select2, select3, select4;

              if(!document.getElementById(`${procID}`).slim) {
                select1 = new SlimSelect({
                  select: `#${procID}`,
                  data: window.procCodes,
                  valuesUseText: true
                });
              } else
                select1 = document.getElementById(`${procID}`).slim;
              select1.setSelected(item.codeNum);

              if(!document.getElementById(`${sendVia}`).slim) {
                select2 = new SlimSelect({
                  select: `#${sendVia}`,
                  data: sendViaOptions,
                  valuesUseText: true,
                  showSearch: false,
                });
              } else
                select2 = document.getElementById(`${sendVia}`).slim;
              select2.setSelected(item.sendVia);

              document.getElementById(`${sendVia}`).addEventListener("change", function (e) {
                //console.log(e.target);
                let selectedVia = e.target.options[e.target.selectedIndex].text;
                //console.log(`selectedVia: ${selectedVia}`);
                // Send Via should not alter the list of forms
                select3.setData(sendFormChoices);
              });

              if(!document.getElementById(`${templateID}`).slim) {
                select3 = new SlimSelect({
                  select: `#${templateID}`,
                  data: sendFormChoices,
                  valuesUseText: true
                });
              } else
                select3 = document.getElementById(`${templateID}`).slim;
              select3.setSelected(item.templateID);

              if(!document.getElementById(`${scheduleWhen}`).slim) {
                select4 = new SlimSelect({
                  select: `#${scheduleWhen}`,
                  data: sendFormOptions,
                  valuesUseText: true,
                  showSearch: false,
                });
              } else
                select4 = document.getElementById(`${scheduleWhen}`).slim;
              select4.setSelected(item.scheduleWhen);
            }
          }
        }
      }

      window[`sendFormPropertiesLoaded-${uniqueid}`] = true;
    }

    function assigntaskLoad(block, uniqueid) {
      //console.log('in assign task load', block, uniqueid);

      if (!window[`assigntaskPropertiesLoaded-${uniqueid}`]) {
        // FIXED: Move event listener setup inside the guard to prevent duplicate listeners
        const addMoreBtnProc = document.getElementById(`addMoreCodesForAssignTask-${uniqueid}`);
        if (addMoreBtnProc) {
          addMoreBtnProc.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            eventListenerForAddMoreCodesForAssignTask();
          });
        }

        const addMoreBtnWebform = document.getElementById(`addMoreCodesForAssignTaskWebform-${uniqueid}`);
        if (addMoreBtnWebform) {
          addMoreBtnWebform.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            eventListenerForAddMoreCodesForAssignTaskWebform();
          });
        }
        _this.$nextTick(() => { // Wrap DOM manipulation in $nextTick
          let triggerTypeInput = block.parentElement?.childNodes[0]?.children[2]; // Safer access
          let triggerType = triggerTypeInput ? triggerTypeInput.defaultValue : null; // Get safely
          window.triggerType = triggerType;

          // Common SlimSelect Data (ensure window.availableTaskTags is ready)
          const slimTagData = window.availableTaskTags || [];
          //console.log(`Using ${slimTagData.length} tags for SlimSelect in assigntaskLoad (uniqueid: ${uniqueid})`);

          // SlimSelect is now always ready (imported from npm)
          window.whenSlimSelectReady(() => {
            try {
            if (triggerType === 'New Website Form Submission') {
            // hide proc code table from properties as it's not needed for this action
            let procCodeTable = document.getElementById(`assign-task-proccode-properties-${uniqueid}`);
            if (procCodeTable) procCodeTable.style.display = 'none'; // Add null check

            // Initialize SlimSelect for existing elements
            new SlimSelect({ select: `#assign-task-webform-elmname-${uniqueid}`, data: window.websiteFormElements || [], valuesUseText: true, showSearch: false });
            new SlimSelect({ select: `#assign-task-webform-elmval-${uniqueid}`, data: window.websiteFormElementValues || [], valuesUseText: true, showSearch: false });
            new SlimSelect({ select: `#assign-task-webform-employee-${uniqueid}`, data: window.employees || [], valuesUseText: true });
            new SlimSelect({ select: `#assign-task-webform-wiki-${uniqueid}`, data: window.wikisWithoutTemplates || [], valuesUseText: true, placeholder: 'Select a template' });
            new SlimSelect({ select: `#assign-task-webform-duedate-${uniqueid}`, data: dueDateOptions, valuesUseText: true, showSearch: false });

            // --- MODIFIED: Initialize Tag SlimSelect for Web Form ---
            window.createTaggableSlimSelect(
              `#assign-task-webform-tag-${uniqueid}`,
              slimTagData,
              'Select or add tags...'
            );
            // --- END MODIFICATION ---


            const attributeName = `data-assign-task-properties-${uniqueid}`; // Use correct attribute name
            if (block.attributes[attributeName]) {
              try {
                let results = JSON.parse(block.attributes[attributeName].nodeValue);
                counterArray[uniqueid] = 0;

                for (let i = 0; i < results.length; i++) {
                  let item = results[i];
                  if (!item) continue;

                  // Logic for first row vs dynamically added rows
                  let isFirstRow = (i === 0);
                  let currentSuffix = isFirstRow ? '' : `-${counterArray[uniqueid]}`; // Suffix for the element we're currently processing

                  if (!isFirstRow) {
                      counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;
                      currentSuffix = `-${counterArray[uniqueid]}`; // Update suffix for the NEWLY added row IDs
                      let trID = `assign-task-webform-row-${uniqueid}${currentSuffix}`; // Use updated suffix
                      let formElmID = `assign-task-webform-elmname-${uniqueid}${currentSuffix}`;
                      let formElmValID = `assign-task-webform-elmval-${uniqueid}${currentSuffix}`;
                      let empID = `assign-task-webform-employee-${uniqueid}${currentSuffix}`;
                      let taskID = `assign-task-webform-desc-${uniqueid}${currentSuffix}`;
                      let taskdueID = `assign-task-webform-duedate-${uniqueid}${currentSuffix}`;
                      let wikiID = `assign-task-webform-wiki-${uniqueid}${currentSuffix}`;
                      let tagID = `assign-task-webform-tag-${uniqueid}${currentSuffix}`; // Tag select ID
                      let deleteID = `assign-task-webform-delete-${uniqueid}${currentSuffix}`;

                      // --- MODIFIED: Include <select> for tag and textarea for description ---
                      let temp = `<td><select id="${formElmID}"></select></td>`; // Removed multiple where not needed
                      temp += `<td><select id="${formElmValID}"></select></td>`;
                      temp += `<td><select id="${empID}" multiple></select></td>`; // Keep multiple
                      temp += `<td><textarea class="workflowTextbox task-description-textarea" id="${taskID}" rows="2" placeholder="Enter task description..."></textarea></td>`;
                      temp += `<td><select id="${taskdueID}"></select></td>`;
                      temp += `<td><select id="${wikiID}" multiple></select></td>`; // Keep multiple
                      temp += `<td><select multiple id="${tagID}"></select></td>`; // Tag select
                      temp += `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;
                      // --- END MODIFICATION ---

                      let newNode = document.createElement('tr');
                      newNode.setAttribute('id', trID);
                      newNode.innerHTML = temp;
                      let table = document.getElementById(`assign-task-website-form-table-body-${uniqueid}`);
                      if (table) table.appendChild(newNode);

                      const deleteBtn = document.getElementById(deleteID);
                      if (deleteBtn) {
                        deleteBtn.addEventListener("click", function (e) {
                          let tempIdParts = e.target.getAttribute("id").split('-');
                          let rowNum = tempIdParts[tempIdParts.length - 1]; // Get the row number suffix
                          removeProcCode(`assign-task-webform-row-${uniqueid}-${rowNum}`); // Use correct row ID
                        });
                      }

                      // Initialize SlimSelect for the new row
                      new SlimSelect({ select: `#${formElmID}`, data: window.websiteFormElements || [], valuesUseText: true, showSearch: false });
                      new SlimSelect({ select: `#${formElmValID}`, data: window.websiteFormElementValues || [], valuesUseText: true, showSearch: false });
                      new SlimSelect({ select: `#${empID}`, data: window.employees || [], valuesUseText: true });
                      new SlimSelect({ select: `#${wikiID}`, data: window.wikisWithoutTemplates || [], valuesUseText: true, placeholder: 'Select a template' });
                      new SlimSelect({ select: `#${taskdueID}`, data: dueDateOptions, valuesUseText: true, showSearch: false });
                      // --- MODIFIED: Initialize Tag SlimSelect for new Web Form row ---
                      window.createTaggableSlimSelect(
                          `#${tagID}`,
                          slimTagData,
                          'Select or add tags...'
                      );
                      // --- END MODIFICATION ---
                  }

                  // Get elements using the correct suffix (either '' or the incremented counter)
                  const suffixToUse = isFirstRow ? '' : currentSuffix;
                  let formElmNameEl = document.getElementById(`assign-task-webform-elmname-${uniqueid}${suffixToUse}`);
                  let formElmValEl = document.getElementById(`assign-task-webform-elmval-${uniqueid}${suffixToUse}`);
                  let employeeEl = document.getElementById(`assign-task-webform-employee-${uniqueid}${suffixToUse}`);
                  let descEl = document.getElementById(`assign-task-webform-desc-${uniqueid}${suffixToUse}`);
                  let dueDateEl = document.getElementById(`assign-task-webform-duedate-${uniqueid}${suffixToUse}`);
                  let wikiEl = document.getElementById(`assign-task-webform-wiki-${uniqueid}${suffixToUse}`);
                  let tagEl = document.getElementById(`assign-task-webform-tag-${uniqueid}${suffixToUse}`); // Get tag select element

                  // Set values for the current row (first or added)
                  if (formElmNameEl?.slim) formElmNameEl.slim.setSelected(item.formElmName ? [item.formElmName] : []); // Handle potential undefined/null
                  if (formElmValEl?.slim) formElmValEl.slim.setSelected(item.formElmVal ? [item.formElmVal] : []);
                  if (employeeEl?.slim) employeeEl.slim.setSelected(item.assignedToEmpID || []);
                  if (descEl) descEl.value = item.task || '';
                  if (dueDateEl?.slim) dueDateEl.slim.setSelected(item.taskDueDate ? [item.taskDueDate] : []);
                  if (wikiEl?.slim) wikiEl.slim.setSelected(item.wikiPageID || []);

                  // --- MODIFIED: Set selected tags ---
                  // Use setTimeout to ensure SlimSelect instance is fully initialized before setting values
                  if (tagEl) {
                      const tagsToSet = Array.isArray(item.tags) ? item.tags : (item.tag ? [item.tag] : []); // Prefer 'tags', fallback to 'tag'
                      
                      // Wait for SlimSelect to be fully initialized
                      setTimeout(() => {
                          if (tagEl.slim && tagsToSet.length > 0) {
                              tagEl.slim.setSelected(tagsToSet);
                          }
                      }, 100); // Small delay to ensure SlimSelect is ready
                  }
                  // --- END MODIFICATION ---
                }
              } catch (e) {
                console.error("Error parsing or processing assign task properties (web form):", e, block.attributes[attributeName]?.nodeValue);
              }
            }

          } else { // Trigger is NOT New Website Form Submission
            // if the trigger is not website form submission
            let websiteFormTable = document.getElementById(`assign-task-website-form-properties-${uniqueid}`);
            if (websiteFormTable) websiteFormTable.style.display = 'none'; // Add null check

            // Initialize SlimSelect for existing elements
            console.log(`Initializing assign-task-proc-code SlimSelect with data:`, window.procCodes);
            console.log(`window.procCodes length:`, window.procCodes ? window.procCodes.length : 0);
            new SlimSelect({ select: `#assign-task-proc-code-${uniqueid}`, data: window.procCodes || [], valuesUseText: true });

            // Update employees list if needed for Appointment Completed trigger
            let currentEmployees = [...(window.employees || [])]; // Clone employee list
            console.log('Available employees for dropdown:', currentEmployees.length, currentEmployees);
            console.log('window.employees at createTemplate time:', window.employees);
            console.log('window.employees type:', typeof window.employees);
            
            // If no employees are available, try to get them from Vuex store
            if (currentEmployees.length === 0) {
              console.log('No employees in window.employees, checking Vuex store...');
              const storeEmployees = this.$store.state.customer.employees || [];
              console.log('Vuex store employees:', storeEmployees.length, storeEmployees);
              
              if (storeEmployees.length > 0) {
                // Format employees from Vuex store
                currentEmployees = storeEmployees.map(emp => ({
                  text: emp.Name,
                  value: emp.EmployeeID,
                  html: emp.Name
                }));
                window.employees = currentEmployees;
                console.log('Formatted employees from Vuex store:', currentEmployees.length, currentEmployees);
              }
            }
            
            if (window.workflowTrigger === 'Appointment Completed') {
              let whoeverMarkedExists = currentEmployees.find(e => e.value === 'Whoever marked Apt Complete'); // Check by value
              if (!whoeverMarkedExists) {
                currentEmployees.push({ text: 'Whoever marked Apt Complete', value: 'Whoever marked Apt Complete', html: 'Whoever marked Apt Complete' });
              }
            }

            // Initialize employee SlimSelect with error handling
            try {
              const selectElement = document.getElementById(`assign-task-employee-${uniqueid}`);
              console.log('Employee select element found:', selectElement);
              
              if (!selectElement) {
                console.error('Employee select element not found:', `#assign-task-employee-${uniqueid}`);
                return;
              }
              
              // If still no employees, wait a bit and try again
              if (currentEmployees.length === 0) {
                console.log('Still no employees, waiting 500ms and retrying...');
                setTimeout(() => {
                  const retryEmployees = [...(window.employees || [])];
                  console.log('Retry employees:', retryEmployees.length, retryEmployees);
                  
                  if (retryEmployees.length > 0) {
                    const employeeSelectInstance = new SlimSelect({ 
                      select: `#assign-task-employee-${uniqueid}`, 
                      data: retryEmployees, 
                      valuesUseText: true 
                    });
                    selectElement.slim = employeeSelectInstance;
                    console.log('Employee SlimSelect created on retry with', retryEmployees.length, 'employees');
                  } else {
                    console.error('Still no employees available after retry');
                  }
                }, 500);
                return;
              }
              
              const employeeSelectInstance = new SlimSelect({ 
                select: `#assign-task-employee-${uniqueid}`, 
                data: currentEmployees, 
                valuesUseText: true 
              });
              
              // Verify the instance was created properly
              console.log('Employee SlimSelect instance created:', employeeSelectInstance);
              console.log('Employee SlimSelect data:', employeeSelectInstance.data);
              
              // Store reference for later use
              selectElement.slim = employeeSelectInstance;
              
            } catch (error) {
              console.error('Error creating employee SlimSelect:', error);
              // Create a fallback basic select
              const selectElement = document.getElementById(`assign-task-employee-${uniqueid}`);
              if (selectElement) {
                selectElement.innerHTML = '<option value="">Select employee...</option>';
                currentEmployees.forEach(emp => {
                  selectElement.innerHTML += `<option value="${emp.value}">${emp.text}</option>`;
                });
                console.log('Created fallback employee select with', currentEmployees.length, 'options');
              }
            }
            new SlimSelect({ select: `#assign-task-wiki-${uniqueid}`, data: window.wikisWithoutTemplates || [], valuesUseText: true, placeholder: 'Select a template' });

            // Adjust dueDateOptions based on trigger
            let currentDueDateOptions = [...dueDateOptions]; // Start with default
            if (window.workflowTrigger) {
              switch (window.workflowTrigger) {
                case 'Appointment Completed':
                  currentDueDateOptions = [ { value: 'immediately', text: "Immediately" }, { value: '1day', text: "1 Day After Appointment is completed" }, { value: '2days', text: "2 Days After Appointment is completed" }, { value: '1week', text: "1 Week After Appointment is completed" } ]; break;
                case 'Appointment Scheduled':
                  currentDueDateOptions = [ { value: 'immediately', text: "Immediately" }, { value: 'odoa', text: "On the Day of Appointment" }, { value: '1dayb', text: "1 Day Before the Appointment Date" }, { value: '2daysb', text: "2 Days Before the Appointment Date" }, { value: '1weekb', text: "1 Week Before the Appointment Date" } ]; break;
              }
            }
            new SlimSelect({ select: `#assign-task-duedate-${uniqueid}`, data: currentDueDateOptions, valuesUseText: true, showSearch: false });

            // --- MODIFIED: Initialize Tag SlimSelect for Proc Code ---
            window.createTaggableSlimSelect(
              `#assign-task-tag-${uniqueid}`,
              window.availableTaskTags || [],
              'Select or add tags...'
            );
            // --- END MODIFICATION ---


            const attributeName = `data-assign-task-properties`; // Use correct attribute name
            if (block.attributes[attributeName]) {
              try {
                let results = JSON.parse(block.attributes[attributeName].nodeValue);
                counterArray[uniqueid] = 0;

                for (let i = 0; i < results.length; i++) {
                  let item = results[i];
                  if (!item) continue;

                  // Logic for first row vs dynamically added rows
                  let isFirstRow = (i === 0);
                  let currentSuffix = isFirstRow ? '' : `-${counterArray[uniqueid]}`; // Suffix for the element we're currently processing

                  if (!isFirstRow) {
                      counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;
                      currentSuffix = `-${counterArray[uniqueid]}`; // Update suffix for NEW row IDs
                      let trID = `assign-task-row-${uniqueid}${currentSuffix}`; // Corrected row ID generation
                      let procID = `assign-task-proc-code-${uniqueid}${currentSuffix}`;
                      let empID = `assign-task-employee-${uniqueid}${currentSuffix}`;
                      let taskID = `assign-task-desc-${uniqueid}${currentSuffix}`;
                      let taskdueID = `assign-task-duedate-${uniqueid}${currentSuffix}`;
                      let wikiID = `assign-task-wiki-${uniqueid}${currentSuffix}`;
                      let tagID = `assign-task-tag-${uniqueid}${currentSuffix}`; // Tag select ID
                      let deleteID = `assign-task-delete-${uniqueid}${currentSuffix}`;

                      // --- MODIFIED: Include <select> for tag and textarea for description ---
                      let temp = `<td><select id="${procID}" multiple></select></td>`; // Keep multiple
                      temp += `<td><select id="${empID}" multiple></select></td>`; // Keep multiple
                      temp += `<td><textarea class="workflowTextbox task-description-textarea" id="${taskID}" rows="2" placeholder="Enter task description..."></textarea></td>`;
                      temp += `<td><select id="${taskdueID}"></select></td>`;
                      temp += `<td><select id="${wikiID}" multiple></select></td>`; // Keep multiple
                      temp += `<td><select multiple id="${tagID}"></select></td>`; // Tag select
                      temp += `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;
                      // --- END MODIFICATION ---

                      let newNode = document.createElement('tr');
                      newNode.setAttribute('id', trID);
                      newNode.innerHTML = temp;
                      let table = document.getElementById(`assign-task-proc-table-body-${uniqueid}`);
                      if (table) table.appendChild(newNode);

                      const deleteBtn = document.getElementById(deleteID);
                      if (deleteBtn) {
                        deleteBtn.addEventListener("click", function (e) {
                          let tempIdParts = e.target.getAttribute("id").split('-');
                          let rowNum = tempIdParts[tempIdParts.length - 1]; // Get the row number suffix
                          removeProcCode(`assign-task-row-${uniqueid}-${rowNum}`); // Use correct row ID
                        });
                      }

                      // Initialize SlimSelect for the new row
                      new SlimSelect({ select: `#${procID}`, data: window.procCodes || [], valuesUseText: true });

                      // Update employees list if needed for Appointment Completed trigger
                      let dynamicEmployees = [...(window.employees || [])]; // Clone
                      if (window.workflowTrigger === 'Appointment Completed') {
                          let whoeverMarkedExistsDyn = dynamicEmployees.find(e => e.value === 'Whoever marked Apt Complete'); // Check by value
                          if (!whoeverMarkedExistsDyn) {
                              dynamicEmployees.push({ text: 'Whoever marked Apt Complete', value: 'Whoever marked Apt Complete', html: 'Whoever marked Apt Complete' });
                          }
                      }
                      new SlimSelect({ select: `#${empID}`, data: dynamicEmployees, valuesUseText: true });
                      new SlimSelect({ select: `#${wikiID}`, data: window.wikisWithoutTemplates || [], valuesUseText: true, placeholder: 'Select a template' });

                      // Adjust dueDateOptions based on trigger for dynamic rows as well
                      let dynamicDueDateOptions = [...dueDateOptions]; // Start with default
                      if (window.workflowTrigger) {
                          switch (window.workflowTrigger) {
                          case 'Appointment Completed': dynamicDueDateOptions = [ { value: 'immediately', text: "Immediately" }, { value: '1day', text: "1 Day After Appointment is completed" }, { value: '2days', text: "2 Days After Appointment is completed" }, { value: '1week', text: "1 Week After Appointment is completed" } ]; break;
                          case 'Appointment Scheduled': dynamicDueDateOptions = [ { value: 'immediately', text: "Immediately" }, { value: 'odoa', text: "On the Day of Appointment" }, { value: '1dayb', text: "1 Day Before the Appointment Date" }, { value: '2daysb', text: "2 Days Before the Appointment Date" }, { value: '1weekb', text: "1 Week Before the Appointment Date" } ]; break;
                          }
                      }
                      new SlimSelect({ select: `#${taskdueID}`, data: dynamicDueDateOptions, valuesUseText: true, showSearch: false });
                      // --- MODIFIED: Initialize Tag SlimSelect for new Proc Code row ---
                      window.createTaggableSlimSelect(
                          `#${tagID}`,
                          slimTagData,
                          'Select or add tags...'
                      );
                      // --- END MODIFICATION ---
                  }

                  // Get elements using the correct suffix
                  const suffixToUse = isFirstRow ? '' : currentSuffix;
                  let procCodeEl = document.getElementById(`assign-task-proc-code-${uniqueid}${suffixToUse}`);
                  let employeeEl = document.getElementById(`assign-task-employee-${uniqueid}${suffixToUse}`);
                  let descEl = document.getElementById(`assign-task-desc-${uniqueid}${suffixToUse}`);
                  let dueDateEl = document.getElementById(`assign-task-duedate-${uniqueid}${suffixToUse}`);
                  let wikiEl = document.getElementById(`assign-task-wiki-${uniqueid}${suffixToUse}`);
                  let tagEl = document.getElementById(`assign-task-tag-${uniqueid}${suffixToUse}`); // Get tag select element

                  // Set values for the current row (first or added)
                  if (procCodeEl?.slim) procCodeEl.slim.setSelected(item.codeNum || []); // Handle potential undefined/null
                  if (employeeEl?.slim) employeeEl.slim.setSelected(item.assignedToEmpID || []);
                  if (descEl) descEl.value = item.task || '';
                  if (dueDateEl?.slim) dueDateEl.slim.setSelected(item.taskDueDate ? [item.taskDueDate] : []);
                  if (wikiEl?.slim) wikiEl.slim.setSelected(item.wikiPageID || []);

                  // --- MODIFIED: Set selected tags ---
                  // Use setTimeout to ensure SlimSelect instance is fully initialized before setting values
                  if (tagEl) {
                      const tagsToSet = Array.isArray(item.tags) ? item.tags : (item.tag ? [item.tag] : []); // Prefer 'tags', fallback to 'tag'
                      
                      // Wait for SlimSelect to be fully initialized
                      setTimeout(() => {
                          if (tagEl.slim && tagsToSet.length > 0) {
                              tagEl.slim.setSelected(tagsToSet);
                          }
                      }, 100); // Small delay to ensure SlimSelect is ready
                  }
                  // --- END MODIFICATION ---
                }
              } catch (e) {
                console.error("Error parsing or processing assign task properties (proc code):", e, block.attributes[attributeName]?.nodeValue);
              }
            }
          }
          window[`assigntaskPropertiesLoaded-${uniqueid}`] = true;
          } catch (error) {
            console.error('❌ ERROR in assigntaskLoad:', error);
            console.error('❌ Error stack:', error.stack);
          }
          }); // End of whenSlimSelectReady
        }); // End of $nextTick
      }
    }

    async function kanbanLoad(block, uniqueid) {
      console.log('kanbanLoad called with uniqueid:', uniqueid);
      console.log('Looking for element with ID:', `addMoreCodesForKanban-${uniqueid}`);
      
      // Wait a bit for DOM to be ready
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Try multiple approaches to find the element
      let addMoreBtn = document.getElementById(`addMoreCodesForKanban-${uniqueid}`);
      console.log('kanbanLoad: addMoreBtn found (attempt 1):', addMoreBtn);
      
      if (!addMoreBtn) {
        // Try finding by partial ID match
        const allAddMore = document.querySelectorAll('[id*="addMoreCodesForKanban"]');
        console.log('All addMoreCodesForKanban elements:', allAddMore);
        addMoreBtn = Array.from(allAddMore).find(el => el.id.includes(uniqueid));
        console.log('kanbanLoad: addMoreBtn found (attempt 2):', addMoreBtn);
      }
      
      if (!addMoreBtn) {
        // Try finding within the kanban properties container
        const kanbanContainer = document.getElementById(`kanbanproperties-${uniqueid}`);
        console.log('Kanban container found:', kanbanContainer);
        if (kanbanContainer) {
          addMoreBtn = kanbanContainer.querySelector('a[href="#"]');
          console.log('kanbanLoad: addMoreBtn found (attempt 3):', addMoreBtn);
        }
      }
      
      console.log('All elements with addMore in ID:', document.querySelectorAll('[id*="addMore"]'));
      
      if (addMoreBtn) {
        // Remove any existing event listeners first
        addMoreBtn.removeEventListener("click", eventListenerForAddMoreCodesForKanban);
        
        // Add multiple event types to catch the click
        ['click', 'mouseup', 'touchend'].forEach(eventType => {
          addMoreBtn.addEventListener(eventType, function(e) {
            console.log(`${eventType} event triggered on Add More button`);
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            // Only proceed on click events to avoid duplicate calls
            if (eventType === 'click') {
              eventListenerForAddMoreCodesForKanban();
            }
            
            return false;
          }, true); // Use capture phase
        });
        
        // Also add a direct onclick handler as backup
        addMoreBtn.onclick = function(e) {
          console.log('onclick handler triggered');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          eventListenerForAddMoreCodesForKanban();
          return false;
        };
      }

      if(!window[`kanbanPropertiesLoaded-${uniqueid}`]) {

        let _this2 = _this;
        let selectedBoardID, selectedColumnID;
        let select5;

        let select1 = new SlimSelect({
          select: `#kanban-proc-code-${uniqueid}`,
          data: window.procCodes,
          valuesUseText: true
        });

        let select4 = new SlimSelect({
          select: `#kanban-board-card-action-${uniqueid}`,
          data: [
            { placeholder: true, text: 'Select action'},
            { text: 'Add a new Card', value: 'addcard' },
            { text: 'Update a Card', value: 'updatecard' },
            { text: 'Move Card to Column', value: 'movecardtocolumn' }
          ],
          valuesUseText: true,
          showSearch: false,
          events: {
            afterChange(newval) {
              let action = newval[0].value;
              console.log('action', action);
              switch (action) {
                case 'addcard':
                  // Re-enable column selection for add card action
                  select3.enable();
                  document.querySelector(`#kanban-board-column-${uniqueid}`).parentElement.style.opacity = '1';
                  
                  // Hide card selection dropdown for add card (we're creating new, not selecting existing)
                  if(select5) {
                    select5.destroy();
                    document.getElementById(`kanban-board-card-${uniqueid}`).style.display = "none";
                    select5 = null;
                  }
                  
                  // Show update properties for creating new card
                  document.getElementById(`kanban-card-update-properties-${uniqueid}`).style.display = "block";
                  
                  // Clear and prepare fields for new card creation
                  let titleField = document.getElementById(`kanban-card-new-title-${uniqueid}`);
                  let descField = document.getElementById(`kanban-card-new-description-${uniqueid}`);
                  let tagsField = document.getElementById(`kanban-card-new-tags-${uniqueid}`);
                  
                  if(titleField) {
                    titleField.value = '';
                    titleField.placeholder = 'Enter new card title (required)';
                  }
                  if(descField) {
                    descField.value = '';
                    descField.placeholder = 'Enter card description (optional)';
                  }
                  if(tagsField) {
                    tagsField.value = '';
                    tagsField.placeholder = 'Enter tags, comma-separated (optional)';
                  }
                  
                  // Show all fields for new card creation (unlike move which hides some)
                  document.getElementById(`kanban-card-new-title-${uniqueid}`).parentElement.style.display = "block";
                  document.getElementById(`kanban-card-new-description-${uniqueid}`).parentElement.style.display = "block";
                  document.getElementById(`kanban-card-new-tags-${uniqueid}`).parentElement.style.display = "block";
                  
                  // For add card, we can optionally allow selecting a different column than the trigger column
                  let columns = _this2.getColumnsByBoardId(_this2.selectedBoardID);
                  if(columns) {
                    let moveToColumnSelect = document.getElementById(`kanban-board-move-to-column-${uniqueid}`);
                    if(moveToColumnSelect) {
                      moveToColumnSelect.innerHTML = '<option value="">Add to trigger column</option>';
                      columns.forEach(column => {
                        let option = document.createElement('option');
                        option.value = column.id;
                        option.textContent = column.name;
                        // Mark trigger column as default
                        if(column.id === _this2.selectedColumnID) {
                          option.textContent += ' (trigger column - default)';
                          option.selected = true;
                        }
                        moveToColumnSelect.appendChild(option);
                      });
                      moveToColumnSelect.style.display = "block";
                    }
                  }
                  break;

                case 'updatecard':
                      // Re-enable column selection for update card action
                      select3.enable();
                      document.querySelector(`#kanban-board-column-${uniqueid}`).parentElement.style.opacity = '1';
                      
                      let cards = _this2.getCardsByFbboardIdAndColumnId(_this2.selectedBoardID, _this2.selectedColumnID);
                      console.log('cards', cards);
                      // now convert them into slim select data
                      if(cards) {
                        let slimSelectData = [{
                          placeholder: true,
                          text: 'Select a card',
                        }];
                        for(let card of cards) {
                          slimSelectData.push({
                            text: card.name,
                            value: card.id,
                            html: card.name
                          });
                        }

                        // Always destroy and recreate select5 to avoid conflicts
                        if(select5) {
                          select5.destroy();
                          select5 = null;
                        }
                        
                        document.getElementById(`kanban-board-card-${uniqueid}`).style.display = 'flex';
                        select5 = new SlimSelect({
                          select: `#kanban-board-card-${uniqueid}`,
                          data: slimSelectData,
                          valuesUseText: true,
                          events: {
                            afterChange(newval) {
                              if(newval && newval.length > 0 && newval[0].value) {
                                // Card selected - show update properties and populate with existing data
                                let selectedCardID = newval[0].value;
                                let selectedCard = cards.find(c => c.id === selectedCardID);
                                
                                if(selectedCard) {
                                  // Show update properties container
                                  document.getElementById(`kanban-card-update-properties-${uniqueid}`).style.display = "block";
                                  
                                  // Show all fields for update action
                                  document.getElementById(`kanban-card-new-title-${uniqueid}`).parentElement.style.display = "block";
                                  document.getElementById(`kanban-card-new-description-${uniqueid}`).parentElement.style.display = "block";
                                  document.getElementById(`kanban-card-new-tags-${uniqueid}`).parentElement.style.display = "block";
                                  
                                  // Populate fields with existing card data
                                  let titleField = document.getElementById(`kanban-card-new-title-${uniqueid}`);
                                  let descField = document.getElementById(`kanban-card-new-description-${uniqueid}`);
                                  let tagsField = document.getElementById(`kanban-card-new-tags-${uniqueid}`);
                                  
                                  if(titleField) {
                                    titleField.value = selectedCard.name || '';
                                    titleField.placeholder = `Current: ${selectedCard.name || 'No title'}`;
                                  }
                                  if(descField) {
                                    descField.value = selectedCard.description || '';
                                    descField.placeholder = `Current: ${selectedCard.description || 'No description'}`;
                                  }
                                  if(tagsField) {
                                    let currentTags = selectedCard.tags ? selectedCard.tags.join(', ') : '';
                                    tagsField.value = currentTags;
                                    tagsField.placeholder = `Current: ${currentTags || 'No tags'}`;
                                  }
                                  
                                  // Populate move-to-column dropdown with available columns
                                  let columns = _this2.getColumnsByBoardId(_this2.selectedBoardID);
                                  if(columns) {
                                    let moveToColumnSelect = document.getElementById(`kanban-board-move-to-column-${uniqueid}`);
                                    if(moveToColumnSelect) {
                                      moveToColumnSelect.innerHTML = '<option value="">Keep in current column</option>';
                                      columns.forEach(column => {
                                        let option = document.createElement('option');
                                        option.value = column.id;
                                        option.textContent = column.name;
                                        // Mark current column as selected by default
                                        if(column.id === _this2.selectedColumnID) {
                                          option.selected = true;
                                          option.textContent += ' (current)';
                                        }
                                        moveToColumnSelect.appendChild(option);
                                      });
                                      moveToColumnSelect.style.display = "block";
                                    }
                                  }
                                }
                              } else {
                                // No card selected - hide update properties
                                document.getElementById(`kanban-card-update-properties-${uniqueid}`).style.display = "none";
                              }
                            }
                          }
                        });
                        select5.enable();
                        
                        // Initially hide update properties until a card is selected
                        document.getElementById(`kanban-card-update-properties-${uniqueid}`).style.display = "none";
                      }
                  break;

                case 'movecardtocolumn':
                      // Visual indication that source column is just for reference
                      select3.disable();
                      document.querySelector(`#kanban-board-column-${uniqueid}`).parentElement.style.opacity = '0.7';
                      
                      let cardsForMove = _this2.getCardsByFbboardIdAndColumnId(_this2.selectedBoardID, _this2.selectedColumnID);
                      console.log('cards for move', cardsForMove);
                      // now convert them into slim select data
                      if(cardsForMove) {
                        let slimSelectData = [{
                          placeholder: true,
                          text: 'Select a card',
                        }];
                        for(let card of cardsForMove) {
                          slimSelectData.push({
                            text: card.name,
                            value: card.id,
                            html: card.name
                          });
                        }

                        // Always destroy and recreate select5 to avoid conflicts
                        if(select5) {
                          select5.destroy();
                          select5 = null;
                        }
                        
                        document.getElementById(`kanban-board-card-${uniqueid}`).style.display = 'flex';
                        select5 = new SlimSelect({
                          select: `#kanban-board-card-${uniqueid}`,
                          data: slimSelectData,
                          valuesUseText: true,
                          events: {
                            afterChange(newval) {
                              if(newval && newval.length > 0 && newval[0].value) {
                                // Card selected for move - show only move-to-column dropdown
                                let selectedCardID = newval[0].value;
                                let selectedCard = cardsForMove.find(c => c.id === selectedCardID);
                                
                                if(selectedCard) {
                                  // Show update properties container
                                  document.getElementById(`kanban-card-update-properties-${uniqueid}`).style.display = "block";
                                  
                                  // Hide other update fields for move action
                                  document.getElementById(`kanban-card-new-title-${uniqueid}`).parentElement.style.display = "none";
                                  document.getElementById(`kanban-card-new-description-${uniqueid}`).parentElement.style.display = "none";
                                  document.getElementById(`kanban-card-new-tags-${uniqueid}`).parentElement.style.display = "none";
                                  
                                  // Get current column name for better UX
                                  let currentColumnName = _this2.getColumnsByBoardId(_this2.selectedBoardID)?.find(col => col.id === _this2.selectedColumnID)?.name || 'Current Column';
                                  
                                  // Update label to show move context
                                  let moveLabel = document.getElementById(`kanban-move-column-label-${uniqueid}`);
                                  if(moveLabel) {
                                    moveLabel.innerHTML = `<i class="fa fa-arrow-right text-primary"></i> Move to Column: <small class="text-muted">(from ${currentColumnName})</small>`;
                                    moveLabel.classList.add('text-primary');
                                  }
                                  
                                  // Show and populate move-to-column dropdown
                                  let columnsForMove = _this2.getColumnsByBoardId(_this2.selectedBoardID);
                                  if(columnsForMove) {
                                    let moveToColumnSelect = document.getElementById(`kanban-board-move-to-column-${uniqueid}`);
                                    if(moveToColumnSelect) {
                                      moveToColumnSelect.innerHTML = '<option value="">Choose destination column...</option>';
                                      columnsForMove.forEach(column => {
                                        let option = document.createElement('option');
                                        option.value = column.id;
                                        option.textContent = column.name;
                                        // Mark current column for reference
                                        if(column.id === _this2.selectedColumnID) {
                                          option.textContent += ' (current - cannot move here)';
                                          option.disabled = true; // Can't move to same column
                                        }
                                        moveToColumnSelect.appendChild(option);
                                      });
                                      moveToColumnSelect.style.display = "block";
                                    }
                                  }
                                }
                              } else {
                                // No card selected - hide update properties
                                document.getElementById(`kanban-card-update-properties-${uniqueid}`).style.display = "none";
                              }
                            }
                          }
                        });
                        select5.enable();
                        
                        // Initially hide update properties until a card is selected
                        document.getElementById(`kanban-card-update-properties-${uniqueid}`).style.display = "none";
                      }
                  break;

                default:
                  // Re-enable column selection for default state
                  select3.enable();
                  document.querySelector(`#kanban-board-column-${uniqueid}`).parentElement.style.opacity = '1';
                  
                  // Hide both card selection and update properties for default/no action
                  if(select5) {
                    select5.destroy();
                    document.getElementById(`kanban-board-card-${uniqueid}`).style.display = "none";
                    select5 = null;
                  }
                  document.getElementById(`kanban-card-update-properties-${uniqueid}`).style.display = "none";
                  break;
              }
            },
          }
        });
        select4.disable();

        let select3 = new SlimSelect({
          select: `#kanban-board-column-${uniqueid}`,
          data: [],
          valuesUseText: true,
          events: {
            afterChange(newval) {
              //console.log('afterChange', newval);
              _this2.selectedColumnID = newval[0].value;
              //console.log('selected column', _this2.selectedColumnID);
              select4.enable();
            },
          }
        });
        select3.disable();

        let select2 = new SlimSelect({
          select: `#kanban-board-${uniqueid}`,
          data: _this.boardOptions,
          valuesUseText: true,
          events: {
            afterChange: (newval) => {
              //console.log('afterChange', newval);
              _this2.selectedBoardID = newval[0].value;
              //console.log('selected board', _this2.selectedBoardID);
              let columns = _this2.getColumnsByFbboardId(_this2.selectedBoardID);
              //console.log('columns', columns);
              // now convert them into slim select data
              let slimSelectData = [];
              for(let column of columns) {
                slimSelectData.push({
                  text: column.name,
                  value: column.id,
                  html: column.name
                });
              }
              select3.setData(slimSelectData);
              select3.enable();
            },
          }
        });

        select2.setSelected(select2.getSelected());

        if (block.attributes[`data-kanban-properties`]) {
          console.log('existing properties there. now loading them');
          let results = JSON.parse(block.attributes[`data-kanban-properties`].nodeValue);
          counterArray[uniqueid] = 0;
          for(let i= 0; i <results.length; i++) {
            let item = results[i];
            //console.dir(item);
            // The reason to do the logic below this way is because the 1st row is already defined in the mounted function
            if(i === 0) {
              let nodes = document.querySelectorAll(`[id^='kanban-row-${uniqueid}']`);
                nodes[0].children[0].children[0].slim.setSelected(item.codeNum);
                nodes[0].children[1].children[0].slim.setSelected(item.kanbanBopardID);
                nodes[0].children[2].children[0].slim.setSelected(item.kanbanBoardColumn);
            } else {
              counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;
              let trID = `kanban-row-${uniqueid}-${counterArray[uniqueid]}`;
              let procID = `kanban-proc-code-${uniqueid}-${counterArray[uniqueid]}`;
              let kanbanBoardID = `kanban-board-${uniqueid}-${counterArray[uniqueid]}`;
              let kanbanBoardColumn = `kanban-board-column-${uniqueid}-${counterArray[uniqueid]}`;
              let deleteID = `kanban-delete-${uniqueid}-${counterArray[uniqueid]}`;

              let temp = `<td><select id="${procID}" multiple/></td>`;
              temp = temp + `<td><select id="${kanbanBoardID}"/></td>`;
              temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

              let newNode = document.createElement('tr');
              newNode.setAttribute('id', trID);
              newNode.innerHTML = temp;
              let table = document.getElementById(`kanban-table-body-${uniqueid}`);
              table.appendChild(newNode);

              document.getElementById(deleteID).addEventListener("click", function (e) {
                let temp = e.target.getAttribute("id").split('-');
                let rowID = temp[temp.length - 1];
                removeProcCode(`kanban-row-${uniqueid}-${rowID}`);
              });

              let select1, select2, select3;

              if (!document.getElementById(`${procID}`).slim) {
                select1 = new SlimSelect({
                  select: `#${procID}`,
                  data: window.procCodes,
                  valuesUseText: true
                });
              } else
                select1 = document.getElementById(`${procID}`).slim;
              select1.setSelected(item.codeNum);

              if (!document.getElementById(`${kanbanBoardID}`).slim) {
                select2 = new SlimSelect({
                  select: `#${smsTemplateID}`,
                  data: window.smsTemplates,
                  valuesUseText: true
                });
              } else
                select2 = document.getElementById(`${kanbanBoardID}`).slim;
              select2.setSelected(item.kanbanBoardID);

              if (!document.getElementById(`${kanbanBoardColumn}`).slim) {
                select3 = new SlimSelect({
                  select: `#${kanbanBoardColumn}`,
                  data: smsSendOptions,
                  valuesUseText: true
                });
              } else
                select3 = document.getElementById(`${kanbanBoardColumn}`).slim;
              select3.setSelected(item.kanbanColumn);
            }
          }
        }
        window[`kanbanPropertiesLoaded-${uniqueid}`] = true;
      }
    }

    window.xFollowupsCompletedSave = xFollowupsCompletedSave;
    window.emailSave = emailSave;
    window.smsSave = smsSave;
    // Global helper function for safe SlimSelect operations
    window.safeGetSelected = function(slimSelectInstance, fallback = []) {
      try {
        if (!slimSelectInstance) {
          console.warn('SlimSelect instance is null/undefined, returning fallback');
          return fallback;
        }
        
        // Try different methods to get selected values
        let result = null;
        
        // Method 1: Try getSelected (standard SlimSelect method)
        if (typeof slimSelectInstance.getSelected === 'function') {
          result = slimSelectInstance.getSelected();
          console.log('SlimSelect getSelected result:', result);
          // Ensure we always return an array for consistency
          if (typeof result === 'string') {
            result = [result];
          } else if (!Array.isArray(result)) {
            result = [];
          }
        }
        // Method 2: Try accessing data.selected (alternative approach)
        else if (slimSelectInstance.data && Array.isArray(slimSelectInstance.data.selected)) {
          result = slimSelectInstance.data.selected;
          console.log('SlimSelect data.selected result:', result);
        }
        // Method 3: Try accessing selected property directly
        else if (Array.isArray(slimSelectInstance.selected)) {
          result = slimSelectInstance.selected;
          console.log('SlimSelect selected property result:', result);
        }
        // Method 4: Try getSelectedData
        else if (typeof slimSelectInstance.getSelectedData === 'function') {
          result = slimSelectInstance.getSelectedData();
          console.log('SlimSelect getSelectedData result:', result);
          // Ensure we always return an array for consistency
          if (typeof result === 'string') {
            result = [result];
          } else if (!Array.isArray(result)) {
            result = [];
          }
        }
        // Method 5: Try data.main.selected (the actual SlimSelect method!)
        else if (slimSelectInstance.data && slimSelectInstance.data.main && typeof slimSelectInstance.data.main.selected === 'function') {
          result = slimSelectInstance.data.main.selected();
          console.log('SlimSelect data.main.selected() result:', result);
          // Ensure we always return an array for consistency
          if (typeof result === 'string') {
            result = [result];
          } else if (!Array.isArray(result)) {
            result = [];
          }
        }
        else {
          console.warn('SlimSelect: No known method to get selected values');
          console.log('SlimSelect instance:', slimSelectInstance);
          console.log('Available methods:', Object.getOwnPropertyNames(slimSelectInstance));
          console.log('Data object:', slimSelectInstance.data);
          console.log('Data object properties:', Object.getOwnPropertyNames(slimSelectInstance.data));
          console.log('Data object keys:', Object.keys(slimSelectInstance.data));
          
          // Try to find selected values in the data object
          if (slimSelectInstance.data) {
            const dataObj = slimSelectInstance.data;
            console.log('Checking data object for selected values...');
            console.log('data.selected:', dataObj.selected);
            console.log('data.selectedValues:', dataObj.selectedValues);
            console.log('data.selectedItems:', dataObj.selectedItems);
            console.log('data.value:', dataObj.value);
            console.log('data.values:', dataObj.values);
            console.log('data.items:', dataObj.items);
            console.log('data.selectedData:', dataObj.selectedData);
            
            // Check nested data property
            console.log('data.data:', dataObj.data);
            if (dataObj.data) {
              console.log('data.data properties:', Object.getOwnPropertyNames(dataObj.data));
              console.log('data.data.selected:', dataObj.data.selected);
              console.log('data.data.selectedValues:', dataObj.data.selectedValues);
              console.log('data.data.value:', dataObj.data.value);
            }
            
            // Check main property
            console.log('data.main:', dataObj.main);
            if (dataObj.main) {
              console.log('data.main properties:', Object.getOwnPropertyNames(dataObj.main));
              console.log('data.main.selected:', dataObj.main.selected);
              console.log('data.main.selectedValues:', dataObj.main.selectedValues);
              console.log('data.main.value:', dataObj.main.value);
            }
            
            // Check filtered property
            console.log('data.filtered:', dataObj.filtered);
            if (dataObj.filtered) {
              console.log('data.filtered properties:', Object.getOwnPropertyNames(dataObj.filtered));
            }
          }
          
          return fallback;
        }
        
        return result || fallback;
      } catch (error) {
        console.error('Error getting selected values from SlimSelect:', error);
        return fallback;
      }
    };

    function ensureSlimSelectInstance(selectElement, config = {}) {
      if (!selectElement) {
        console.warn('ensureSlimSelectInstance called without a select element reference');
        return null;
      }

      if (selectElement.slim) {
        if (typeof selectElement.slim.getSelected !== 'function' && selectElement.slim.data && typeof selectElement.slim.data.getSelected === 'function') {
          selectElement.slim.getSelected = selectElement.slim.data.getSelected.bind(selectElement.slim.data);
        }

        return selectElement.slim;
      }

      const selectId = selectElement.id;
      if (!selectId) {
        console.warn('Select element is missing an id attribute, cannot initialize SlimSelect.', selectElement);
        return null;
      }

      if (typeof SlimSelect !== 'function') {
        console.error('SlimSelect constructor is not available globally, cannot initialize select', selectId);
        return null;
      }

      const escapedId = typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? CSS.escape(selectId)
        : selectId;

      try {
        const instance = new SlimSelect({
          select: `#${escapedId}`,
          valuesUseText: true,
          ...config
        });
        console.info(`SlimSelect lazily initialized for ${selectId}`);
        return instance;
      } catch (error) {
        console.error(`Failed to initialize SlimSelect for ${selectId}`, error);
        return null;
      }
    }

    function normalizeSlimSelectValues(rawValues, fallback = []) {
      if (rawValues === undefined || rawValues === null) {
        return fallback.slice();
      }

      const asArray = Array.isArray(rawValues) ? rawValues : [rawValues];
      const normalized = [];

      asArray.forEach(entry => {
        if (entry === undefined || entry === null || entry === '') {
          return;
        }

        if (Array.isArray(entry)) {
          normalized.push(...normalizeSlimSelectValues(entry, []));
          return;
        }

        if (typeof entry === 'object') {
          if (entry.value !== undefined && entry.value !== null && entry.value !== '') {
            normalized.push(String(entry.value));
            return;
          }

          if (entry.text !== undefined && entry.text !== null && entry.text !== '') {
            normalized.push(String(entry.text));
            return;
          }

          return;
        }

        normalized.push(String(entry));
      });

      if (!normalized.length) {
        return fallback.slice();
      }

      return Array.from(new Set(normalized));
    }

    function normalizeSlimSelectValue(rawValue, fallback = null) {
      const normalized = normalizeSlimSelectValues(rawValue, []);
      return normalized.length ? normalized[0] : fallback;
    }

    function getSelectedValuesFromSelect(selectElement, config = {}, fallback = []) {
      if (!selectElement) {
        return fallback;
      }

      const instance = ensureSlimSelectInstance(selectElement, config);
      if (instance) {
        const values = window.safeGetSelected ? window.safeGetSelected(instance, fallback) : fallback;
        const normalized = normalizeSlimSelectValues(values, fallback);
        if (normalized && normalized.length) {
          return normalized;
        }
      }

      if (selectElement.selectedOptions && selectElement.selectedOptions.length) {
        const nativeValues = Array.from(selectElement.selectedOptions)
          .map(option => (option.value !== undefined && option.value !== null ? option.value : option.text))
          .filter(value => value !== undefined && value !== null && value !== '');
        const normalizedNative = normalizeSlimSelectValues(nativeValues, fallback);
        if (normalizedNative.length) {
          return normalizedNative;
        }
      } else if (selectElement.value) {
        return normalizeSlimSelectValues([selectElement.value], fallback);
      }

      return fallback;
    }

    window.assigntaskSave = assigntaskSave;
    window.waitSave = waitSave;
    window.slackSave = slackSave;
    window.emailSave = emailSave;
    window.sendformSave = sendformSave;
    window.kanbanSave = kanbanSave;

    window.xFollowupsCompletedLoad = xFollowupsCompletedLoad;
    window.emailLoad = emailLoad;
    window.smsLoad = smsLoad;
    window.waitLoad = waitLoad;
    window.slackLoad = slackLoad;
    window.sendformLoad = sendformLoad;
    window.assigntaskLoad = assigntaskLoad;
    window.kanbanLoad = kanbanLoad;

    // Helper function to close the properties sidebar
    function closeSidebar(blockPrefix, blockUniqueId) {
      const propertiesEl = document.getElementById(`${blockPrefix}properties-${blockUniqueId}`);
      const wrapEl = document.getElementById(`${blockPrefix}wrap-${blockUniqueId}`);
      
      if (propertiesEl) {
        propertiesEl.classList.remove("expanded");
      }
      
      setTimeout(function () {
        if (wrapEl) {
          wrapEl.classList.remove("itson");
        }
      }, 300);
    }
    window.closeSidebar = closeSidebar;

    function createfollowupLoad() {}

    function mailletterLoad() {}

    function removeProcCode(id) {
      //console.log(`in removeProcCode, id: ${id}`);
      document.getElementById(id).remove();
      counterArray[uniqueid] = counterArray[uniqueid] - 1;
    }

    function createTemplate(currentblock, uniqueid) {
      if (!currentblock || !currentblock.propertiesDivPrefix) {
        console.error('createTemplate: currentblock or propertiesDivPrefix is missing');
        return;
      }
      
      let tplBlockName = `${currentblock.propertiesDivPrefix}wrap`;
      let tplBlock = document.getElementById(tplBlockName);
      
      if (!tplBlock) {
        console.error(`createTemplate: template element not found for ID: ${tplBlockName}`);
        return;
      }
      
      // Get the html template and replace all "id=**" with uniquid appended to make it unique
      let temp = tplBlock.outerHTML.replace(/id="(.*?)"/gm, `id="$1-${uniqueid}"`);
      //console.log(temp);
      let main = document.getElementById('main');
      if (main) {
        main.insertAdjacentHTML('beforeend', temp);
      } else {
        console.error('createTemplate: main element not found');
      }
    }

    function eventListenerForCloseProperties(e) {
      if (rightcard) {
        rightcard = false;
        selectedblock = undefined;
        document
          .getElementById(`${currentblock.propertiesDivPrefix}properties-${uniqueid}`).classList.remove("expanded");
        setTimeout(function () {
          document
            .getElementById(`${currentblock.propertiesDivPrefix}wrap-${uniqueid}`).classList.remove("itson");
        }, 300);
      } else {
        console.error(`This case should not happen. If it did then look into it`);
      }
    }

    function xFollowupsCompletedSave(e) {
      //console.log('xFollowupsCompletedSave called', e);
      const originalText = e.target.innerHTML; // Store original text
      e.target.innerHTML = "Saving...";
      let eID = `xFollowupNumber-${uniqueid}`;
      let e1 = document.getElementById(eID);

      if(isNaN(e1.value)) {
        alert(`Please enter a valid number for the number of followups`);
        e.target.innerHTML = originalText; // Restore original text
        return false;
      }

      tempblock.setAttribute(`data-xFollowupNumber`, e1.value);

      setTimeout(() => {
        e.target.innerHTML = "Saved!"
      }, 1000);

      setTimeout(() => {
        e.target.innerHTML = originalText; // Restore original text
      }, 1000);
    }

    function emailSave(e) {
      const originalText = e.target.innerHTML; // Store original text
      let e1 = document.getElementById(`emailFrom-${uniqueid}`);
      if(!e1 || !e1.options) {
        // Use toast notification instead of alert
        if (window.vueInstance && window.vueInstance.$toast) {
          window.vueInstance.$toast.error('Email verification required! Please set up verified email addresses to send workflow emails. Contact our team for assistance.');
        } else {
          alert('You do not have your email address verified to be able to send emails yet. Please contact teamio support');
        }
        window.error = 'Email verification required';
        return false;
      }

      e.target.innerHTML = "Saving...";

      tempblock.setAttribute("data-uniqueid", uniqueid);
      tempblock.setAttribute("data-blocktype", "email");
      tempblock.setAttribute("data-workflowtrigger", window.workflowTrigger);
      tempblock.setAttribute("data-siteid", window.siteID);
      tempblock.setAttribute("data-workflowid", window.workflowID);
      tempblock.setAttribute("data-timezone", window.timezone);

      let e0 = document.getElementById(`emailFromName-${uniqueid}`);
      let e2 = document.getElementById(`onlyIfPreviousUnopened-${uniqueid}`);

      let emailFrom = e1.options[e1.selectedIndex].value;

      tempblock.setAttribute(`data-emailfromname`, e0.value);
      tempblock.setAttribute(`data-emailfromemail`, emailFrom);
      //tempblock.setAttribute(`data-onlyIfPreviousUnopened`, e2.checked);

      let results = [];
      let nodes;

      if(window.triggerType === 'New Website Form Submission') {
        nodes = document.querySelectorAll(`[id^='send-email-webform-row-${uniqueid}']`);
        //console.dir(nodes);
        for(let i = 0; i < nodes.length; i++) {
          let node = nodes[i];
          //console.dir(node);
          let o = {
            formElmName: node.children[0].children[0].slim.getSelected()[0],
            formElmVal: node.children[1].children[0].slim.getSelected()[0],
            emailTemplateID: node.children[2].children[0].slim.getSelected()[0],
            //emailWhenID: node.children[3].children[0].slim.getSelected(),
          }
          //console.log(`object so far: ${JSON.stringify(o)}`);
          results.push(o);
        }
      } else {
        nodes = document.querySelectorAll(`[id^='send-email-row-${uniqueid}']`);

        for(let i = 0; i < nodes.length; i++) {
          let node = nodes[i];
          //console.dir(node);
          let o = {
            codeNum: node.children[0].children[0].slim.getSelected()[0],
            emailTemplateID: node.children[1].children[0].slim.getSelected()[0],
            //emailWhenID: node.children[2].children[0].slim.getSelected(),
          }
          //console.log(`object so far: ${JSON.stringify(o)}`);
          results.push(o);
        }
      }

      //console.dir(results);

      tempblock.setAttribute(`data-send-email-properties`, JSON.stringify(results));

      setTimeout(() => {
        e.target.innerHTML = "Saved!"
      }, 1000);

      setTimeout(() => {
        e.target.innerHTML = originalText; // Restore original text
      }, 1000);
    }


    function smsSave(e) {
      // Get the save button - e might be undefined when called from doneTouch without event
      let saveButton = null;
      if (e && e.target) {
        saveButton = e.target;
      } else {
        // Fallback: try to find the save button by ID
        saveButton = document.getElementById(`smssave-${uniqueid}`) || document.getElementById(`smssaveclose-${uniqueid}`);
      }
      
      let originalText = 'Save';
      if (saveButton) {
        if (!saveButton.dataset.originalText) {
          saveButton.dataset.originalText = saveButton.innerHTML || 'Save';
        }
        originalText = saveButton.dataset.originalText;

        if (saveButton.dataset.isSaving === 'true') {
          console.warn('smsSave already running for button', saveButton.id);
          return false;
        }
      }

      if(!window.smsFrom || window.smsFrom === '') {
        // Use toast notification instead of alert
        if (window.vueInstance && window.vueInstance.$toast) {
          window.vueInstance.$toast.error('SMS phone number required! Please configure a phone number to send workflow SMS messages. Contact our team for setup assistance.');
        } else {
          alert('No SMS number found. Please contact teamio support');
        }
        window.error = 'SMS phone number required';
        return false;
      }

      if (saveButton) {
        saveButton.dataset.isSaving = 'true';
        saveButton.innerHTML = "Saving...";
      }

      tempblock.setAttribute("data-uniqueid", uniqueid);
      tempblock.setAttribute("data-blocktype", "sms");
      tempblock.setAttribute("data-workflowtrigger", window.workflowTrigger);
      tempblock.setAttribute("data-siteid", window.siteID);
      tempblock.setAttribute("data-workflowid", window.workflowID);
      tempblock.setAttribute("data-smsfrom", window.smsFrom);

      let results = [];
      let nodes;
      let hasUninitializedFields = false;

      const getCellSelect = (row, index) => {
        if (!row || !row.children || !row.children[index]) {
          return null;
        }
        const cell = row.children[index];
        if (!cell || !cell.children || !cell.children.length) {
          return null;
        }
        return cell.children[0];
      };

      const getMultiValues = (selectElement, config = {}) => getSelectedValuesFromSelect(selectElement, config, []);
      const getSingleValue = (selectElement, config = {}) => {
        const values = getSelectedValuesFromSelect(selectElement, config, []);
        return values.length ? values[0] : null;
      };

      const buildSmsTextFromTemplate = (templateId, trimMethod = 'trimEnd') => {
        if (!templateId) {
          return null;
        }

        if (!window.wikiPages || !Array.isArray(window.wikiPages)) {
          console.error('wikiPages is not properly initialized');
          return null;
        }

        if (window.wikiPages.length === 0) {
          console.error('wikiPages is empty, possibly not loaded yet');
          return null;
        }

        const match = window.wikiPages.find(w => w.WikiPageID === templateId);
        if (!match) {
          console.error(`No template found for SMS template ID: ${templateId}`);
          return null;
        }

        if (!match.Content) {
          console.error(`Template found but has no Content for SMS template ID: ${templateId}`);
          return null;
        }

        try {
          const jsonContent = JSON.parse(match.Content);
          const allpara = Array.isArray(jsonContent.blocks) ? jsonContent.blocks.filter(b => b.type === 'paragraph') : [];
          let smsText = '';

          allpara.forEach(function(b) {
            const tmp = document.createElement("DIV");
            tmp.innerHTML = b.data.text;
            const tmpText = tmp.textContent || tmp.innerText || "";
            smsText = smsText + tmpText;
          });

          if (trimMethod === 'trimRight' && typeof smsText.trimRight === 'function') {
            return smsText.trimRight();
          }

          if (typeof smsText.trimEnd === 'function') {
            return smsText.trimEnd();
          }

          return smsText.trim();
        } catch (error) {
          console.error(`Error parsing SMS template ID ${templateId}`, error);
          return null;
        }
      };

      if(window.triggerType === 'New Website Form Submission') {
        nodes = document.querySelectorAll(`[id^='send-sms-webform-row-${uniqueid}']`);
        for(let i = 0; i < nodes.length; i++) {
          const node = nodes[i];

          const formElmNameSelect = getCellSelect(node, 0);
          const formElmValSelect = getCellSelect(node, 1);
          const templateSelect = getCellSelect(node, 2);
          const scheduleSelect = getCellSelect(node, 3);

          const formElmName = getSingleValue(formElmNameSelect, {
            data: window.websiteFormElements || [],
            showSearch: false
          });
          const formElmVal = getSingleValue(formElmValSelect, {
            data: window.websiteFormElementValues || [],
            showSearch: false
          });
          const smsTemplateID = getSingleValue(templateSelect, {
            data: window.smsTemplates || []
          });
          const scheduleWhen = scheduleSelect
            ? getSingleValue(scheduleSelect, { data: smsSendOptions || [] })
            : null;

          if (!formElmName || !formElmVal || !smsTemplateID || (scheduleSelect && !scheduleWhen)) {
            console.warn('SMS webform row has incomplete selections', {
              rowIndex: i,
              hasFormElmName: !!formElmName,
              hasFormElmVal: !!formElmVal,
              hasTemplate: !!smsTemplateID,
              hasSchedule: scheduleSelect ? !!scheduleWhen : 'N/A'
            });
            hasUninitializedFields = true;
            continue;
          }

          const smsText = buildSmsTextFromTemplate(smsTemplateID, 'trimEnd');
          if (smsText === null) {
            hasUninitializedFields = true;
            continue;
          }

          results.push({
            formElmName,
            formElmVal,
            smsTemplateID,
            scheduleWhen,
            smsText
          });
        }
      } else {
        nodes = document.querySelectorAll(`[id^='send-sms-row-${uniqueid}']`);
        for(let i = 0; i < nodes.length; i++) {
          const node = nodes[i];

          const procSelect = getCellSelect(node, 0);
          const templateSelect = getCellSelect(node, 1);
          const scheduleSelect = getCellSelect(node, 2);

          const codeNum = getMultiValues(procSelect, { data: window.procCodes || [] });
          const smsTemplateID = getSingleValue(templateSelect, { data: window.smsTemplates || [] });
          const scheduleWhen = getSingleValue(scheduleSelect, { data: smsSendOptions || [] });

          if (!codeNum.length || !smsTemplateID || !scheduleWhen) {
            console.warn('SMS row missing selections', {
              rowIndex: i,
              hasCodes: codeNum.length > 0,
              hasTemplate: !!smsTemplateID,
              hasSchedule: !!scheduleWhen
            });
            hasUninitializedFields = true;
            continue;
          }

          const smsText = buildSmsTextFromTemplate(smsTemplateID, 'trimRight');
          if (smsText === null) {
            hasUninitializedFields = true;
            continue;
          }

          results.push({
            codeNum,
            smsTemplateID,
            scheduleWhen,
            smsText
          });
        }
      }

      console.log('smsSave summary:', {
        totalResults: results.length,
        hasUninitializedFields: hasUninitializedFields,
        saveButton: saveButton ? 'found' : 'not found'
      });

  tempblock.setAttribute(`data-send-sms-properties`, JSON.stringify(results));
      //console.dir(tempblock);

      // Show warning if fields weren't initialized
      if (hasUninitializedFields) {
        console.warn('SMS fields not fully initialized - showing warning to user');
        if (window.vueInstance && window.vueInstance.$toast) {
          window.vueInstance.$toast.warning('Please select procedure codes and SMS template before saving.', {
            timeout: 4000
          });
        } else {
          alert('Please select procedure codes and SMS template before saving.');
        }
      }

      if (saveButton) {
        setTimeout(() => {
          if (hasUninitializedFields) {
            saveButton.innerHTML = "⚠️ Please Fill Fields";
          } else {
            saveButton.innerHTML = "✓ Saved!";
          }
        }, 100);

        setTimeout(() => {
          saveButton.innerHTML = originalText; // Restore original text
          saveButton.dataset.isSaving = 'false';
        }, hasUninitializedFields ? 3000 : 1500);
      }
    }

    function assigntaskSave(e) {
      const originalText = e.target.innerHTML; // Store original text
      e.target.innerHTML = "Saving...";

      if (!tempblock) {
          console.error("tempblock is not defined in assigntaskSave");
          e.target.innerHTML = originalText; // Restore original text
          return false;
      }

      tempblock.setAttribute("data-uniqueid", uniqueid);
      tempblock.setAttribute("data-blocktype", "assigntask");
      tempblock.setAttribute("data-workflowtrigger", window.workflowTrigger || '');
      tempblock.setAttribute("data-siteid", window.siteID || '');
      tempblock.setAttribute("data-workflowid", window.workflowID || '');
      tempblock.setAttribute("data-timezone", window.timezone || '');

      let results = [];
      let nodes;
      let attributeName;
      let hasError = false; // Validation flag

      if (window.triggerType === 'New Website Form Submission') {
        nodes = document.querySelectorAll(`[id^="assign-task-webform-row-${uniqueid}"]`);
        attributeName = `data-assign-task-properties-${uniqueid}`; // Correct attribute for web forms

        for (let i = 0; i < nodes.length; i++) {
          let node = nodes[i];
          const descInput = node.children[3]?.children[0];
          const employeeSelect = node.children[2]?.children[0]?.slim;
          const tagSelect = node.children[6]?.children[0]?.slim; // Get tag select instance

          console.log(`Validating row ${i + 1}:`, {
            hasDescInput: !!descInput,
            descValue: descInput?.value,
            hasEmployeeSelect: !!employeeSelect,
            hasTagSelect: !!tagSelect,
            employeeSelectType: typeof employeeSelect,
            employeeSelectMethods: employeeSelect ? Object.getOwnPropertyNames(employeeSelect) : 'N/A'
          });

          // Skip validation for completely empty rows
          const hasDescription = descInput && descInput.value.trim() !== '';
          const hasEmployee = employeeSelect && window.safeGetSelected(employeeSelect, []).length > 0;
          const hasTag = tagSelect && window.safeGetSelected(tagSelect, []).length > 0;
          
          console.log(`Row ${i + 1} data check:`, {
            hasDescription,
            hasEmployee,
            hasTag,
            shouldSkip: !hasDescription && !hasEmployee && !hasTag
          });
          
          // If row has no data at all, skip it
          if (!hasDescription && !hasEmployee && !hasTag) {
            console.log(`Skipping empty row ${i + 1}`);
            continue;
          }

          console.log(`Row ${i + 1} has data, proceeding with validation`);

          // Only validate rows that have some data entered
          if (hasDescription) {
            console.log(`Row ${i + 1} has description, checking employee requirement`);
            // If description is entered, employee is required
            if (!employeeSelect) {
               console.error('Employee select not found for row', i + 1);
               alert(`Please select an employee to assign task to for row ${i + 1}.`);
               hasError = true; break;
            }
            const selectedEmployees = window.safeGetSelected(employeeSelect, []);
            console.log(`Row ${i + 1} selected employees:`, selectedEmployees);
            if (selectedEmployees.length === 0) {
               alert(`Please select an employee to assign task to for row ${i + 1}.`);
               hasError = true; break;
            }
          } else {
            console.log(`Row ${i + 1} has no description, skipping employee validation`);
          }

          let o = {
            formElmName: window.safeGetSelected(node.children[0]?.children[0]?.slim, [])[0] || null,
            formElmVal: window.safeGetSelected(node.children[1]?.children[0]?.slim, [])[0] || null,
            createdByEmpID: window.userID || '',
            createdByEmpName: window.userName || '',
            assignedToEmpID: window.safeGetSelected(employeeSelect, []), // Already validated
            task: descInput.value.trim(), // Use validated input
            taskDueDate: (() => {
              const dueDateSelect = node.children[4]?.children[0]?.slim;
              const dueDateValue = window.safeGetSelected(dueDateSelect, []);
              console.log(`Row ${i + 1} due date collection (webform):`, {
                dueDateSelect,
                dueDateValue,
                firstValue: dueDateValue[0] || null
              });
              return dueDateValue[0] || null;
            })(),
            wikiPageID: window.safeGetSelected(node.children[5]?.children[0]?.slim, []) || [],
            // --- MODIFIED: Get tags from SlimSelect ---
            tags: window.safeGetSelected(tagSelect, []) || [], // Get array of selected tags, default empty
            // tag: undefined // Remove the old 'tag' property explicitly if needed, though omitting is fine
            // --- END MODIFICATION ---
          };
          //console.log(`object so far: ${JSON.stringify(o)}`);
          results.push(o);
        }
      } else {
        nodes = document.querySelectorAll(`[id^="assign-task-row-${uniqueid}"]`);
        attributeName = `data-assign-task-properties`; // Correct attribute for proc codes

        for (let i = 0; i < nodes.length; i++) {
          let node = nodes[i];
          const descInput = node.children[2]?.children[0];
          const employeeSelect = node.children[1]?.children[0]?.slim;
          const tagSelect = node.children[5]?.children[0]?.slim; // Get tag select instance

          console.log(`Validating row ${i + 1} (non-webform):`, {
            hasDescInput: !!descInput,
            descValue: descInput?.value,
            hasEmployeeSelect: !!employeeSelect,
            hasTagSelect: !!tagSelect,
            employeeSelectType: typeof employeeSelect,
            employeeSelectMethods: employeeSelect ? Object.getOwnPropertyNames(employeeSelect) : 'N/A'
          });

          // Skip validation for completely empty rows
          const hasDescription = descInput && descInput.value.trim() !== '';
          const hasEmployee = employeeSelect && window.safeGetSelected(employeeSelect, []).length > 0;
          const hasTag = tagSelect && window.safeGetSelected(tagSelect, []).length > 0;
          
          console.log(`Row ${i + 1} data check (non-webform):`, {
            hasDescription,
            hasEmployee,
            hasTag,
            shouldSkip: !hasDescription && !hasEmployee && !hasTag
          });
          
          // If row has no data at all, skip it
          if (!hasDescription && !hasEmployee && !hasTag) {
            console.log(`Skipping empty row ${i + 1} (non-webform)`);
            continue;
          }

          console.log(`Row ${i + 1} has data, proceeding with validation (non-webform)`);

          // Only validate rows that have some data entered
          if (hasDescription) {
            console.log(`Row ${i + 1} has description, checking employee requirement (non-webform)`);
            // If description is entered, employee is required
            if (!employeeSelect) {
               console.error('Employee select not found for row', i + 1);
               alert(`Please select an employee to assign task to for row ${i + 1}.`);
               hasError = true; break;
            }
            const selectedEmployees = window.safeGetSelected(employeeSelect, []);
            console.log(`Row ${i + 1} selected employees (non-webform):`, selectedEmployees);
            if (selectedEmployees.length === 0) {
               alert(`Please select an employee to assign task to for row ${i + 1}.`);
               hasError = true; break;
            }
          } else {
            console.log(`Row ${i + 1} has no description, skipping employee validation (non-webform)`);
          }

          let o = {
            codeNum: window.safeGetSelected(node.children[0]?.children[0]?.slim, []) || [],
            createdByEmpID: window.userID || '',
            createdByEmpName: window.userName || '',
            assignedToEmpID: window.safeGetSelected(employeeSelect, []), // Already validated
            task: descInput.value.trim(), // Use validated input
            taskDueDate: (() => {
              const dueDateSelect = node.children[3]?.children[0]?.slim;
              const dueDateValue = window.safeGetSelected(dueDateSelect, []);
              console.log(`Row ${i + 1} due date collection:`, {
                dueDateSelect,
                dueDateValue,
                firstValue: dueDateValue[0] || null
              });
              return dueDateValue[0] || null;
            })(),
            wikiPageID: window.safeGetSelected(node.children[4]?.children[0]?.slim, []) || [],
            // --- MODIFIED: Get tags from SlimSelect ---
            tags: window.safeGetSelected(tagSelect, []) || [], // Get array of selected tags, default empty
            // tag: undefined // Remove old property
            // --- END MODIFICATION ---
          };
          //console.log(`object so far: ${JSON.stringify(o)}`);
          results.push(o);
        }
      }

       if (hasError) {
          e.target.innerHTML = originalText; // Restore original text
          return false;
       }

      console.log(`Saving task properties (${attributeName}):`, results);
      console.log(`Detailed task data being saved:`, results.map((r, idx) => ({
        row: idx + 1,
        taskDueDate: r.taskDueDate,
        task: r.task,
        assignedToEmpID: r.assignedToEmpID
      })));
      tempblock.setAttribute(attributeName, JSON.stringify(results)); // Use the determined attribute name

      setTimeout(() => {
        e.target.innerHTML = "Saved!"
      }, 1000); // Shortened delay

      setTimeout(() => {
        e.target.innerHTML = originalText; // Restore original text
      }, 2000); // Keep save visible longer
    }
    window.assigntaskSave = assigntaskSave; // Re-assign to window context

    function waitSaveOnSelect(e) {
      //console.dir(e.target.id);

      if(e.target.id.includes('waitUntilCondition') ) {
        // Check if the option is disabled (coming soon feature)
        const waitUntilConditionEl = document.getElementById(`waitUntilCondition-${uniqueid}`);
        if (waitUntilConditionEl && waitUntilConditionEl.disabled) {
          // Prevent selection of disabled option and show a message
          e.preventDefault();
          e.stopPropagation();
          
          // Reset to duration option
          document.getElementById(`waitFor-${uniqueid}`).checked = true;
          document.getElementById(`waitForFirstOption-${uniqueid}`).style.display = 'block';
          document.getElementById(`waitForThirdOption-${uniqueid}`).style.display = 'none';
          
          // Show a brief notification
          const badge = document.querySelector('.coming-soon-badge');
          if (badge) {
            badge.style.animation = 'pulse 0.5s ease-in-out';
            setTimeout(() => {
              badge.style.animation = '';
            }, 500);
          }
          return;
        }
        
        // Original logic for when feature is enabled
        document.getElementById(`waitForThirdOption-${uniqueid}`).style.display = 'block';
        document.getElementById(`waitFor-${uniqueid}`).checked = false;
        //document.getElementById(`waitForTime-${uniqueid}`).checked = false;
        document.getElementById(`waitForFirstOption-${uniqueid}`).style.display = 'none';
        //document.getElementById(`waitForSecondOption-${uniqueid}`).style.display = 'none';
      } else if(e.target.id.includes('waitForTime') ) {
        // 2nd option selected
        /*
        document.getElementById(`waitForSecondOption-${uniqueid}`).style.display = 'block';
        document.getElementById(`waitFor-${uniqueid}`).checked = false;
        document.getElementById(`waitUntilCondition-${uniqueid}`).checked = false;
        document.getElementById(`waitForThirdOption-${uniqueid}`).style.display = 'none';
        document.getElementById(`waitForFirstOption-${uniqueid}`).style.display = 'none';
        */
      } else {
        // first option selected
        document.getElementById(`waitForFirstOption-${uniqueid}`).style.display = 'block';
        //document.getElementById(`waitForTime-${uniqueid}`).checked = false;
        document.getElementById(`waitUntilCondition-${uniqueid}`).checked = false;
        //document.getElementById(`waitForSecondOption-${uniqueid}`).style.display = 'none';
        document.getElementById(`waitForThirdOption-${uniqueid}`).style.display = 'none';
      }

    }

    function waitSave(e) {
      const originalText = e.target.innerHTML; // Store original text
      e.target.innerHTML = "Saving...";

      let triggerType = tempblock.parentElement.childNodes[0].children[2].defaultValue;
      window.triggerType = triggerType;

      tempblock.setAttribute("data-uniqueid", uniqueid);
      tempblock.setAttribute("data-blocktype", "wait");
      tempblock.setAttribute("data-workflowtrigger", window.workflowTrigger);
      tempblock.setAttribute("data-siteid", window.siteID);
      tempblock.setAttribute("data-workflowid", window.workflowID);
      tempblock.setAttribute("data-timezone", window.timezone);

      let e1 = document.getElementById(`waitFor-${uniqueid}`);
      let e2 = document.getElementById(`waitUntilCondition-${uniqueid}`);
      //let e3 = document.getElementById(`waitForTime-${uniqueid}`);

      tempblock.setAttribute(`data-waitFor`, e1.checked);
      tempblock.setAttribute(`data-waitUntilCondition`, e2.checked);
      //tempblock.setAttribute(`data-waitForTime`, e3.checked);

      if(e1.checked) {
        let e4 = document.getElementById(`waitForDurationNum-${uniqueid}`);
        let e5 = document.getElementById(`waitForDurationOptionSelected-${uniqueid}`);
        let waitForDurationOptionSelected = e5.options[e5.selectedIndex].value;

        if(isNaN(e4.value)) {
          alert(`Please enter a valid number for the duration and try again`);
          e.target.innerHTML = originalText; // Restore original text
          return false;
        }

        if(waitForDurationOptionSelected === '') {
          alert(`Please select Hours, Days or Months before saving`);
          e.target.innerHTML = originalText; // Restore original text
          return false;
        }

        tempblock.setAttribute(`data-waitForDurationNum`, e4.value);
        tempblock.setAttribute(`data-waitForDurationOptionSelected`, waitForDurationOptionSelected);

        // let's figure out how many seconds that is
        let secondsInHour = 3600;
        let secondsInDay = 86400;
        let secondsInMonth = secondsInDay * 30;
        let secondsInMinute = 60;
        let multiplyBy;

        switch(waitForDurationOptionSelected) {
          case 'minutes' : multiplyBy = secondsInMinute; break;
          case 'days' : multiplyBy = secondsInDay; break;
          case 'months' : multiplyBy = secondsInMonth; break;
          case 'hours' : multiplyBy = secondsInHour; break;
        }

        try {
          let totalSeconds = parseFloat(e4.value, 10) * multiplyBy;
          console.log(`Total Seconds: ${totalSeconds}`);
          if(totalSeconds <= 0) {
            alert(`Please enter valid Duration before saving`);
            e.target.innerHTML = "Save"
            return false;
          }
          tempblock.setAttribute(`data-totalseconds`, totalSeconds);
        } catch(error) {
          alert(`Please enter valid Duration before saving`);
          e.target.innerHTML = "Save"
          return false;
        }

      } else if(e2.checked) {
        let e6 = document.getElementById(`waitUntilConditionOptionSelected-${uniqueid}`);
        tempblock.setAttribute(`data-waitUntilConditionOptionSelected`, e6.options[e6.selectedIndex].value);
      }
      /*
      else if(e3.checked) {
        let waitForTimestamp = document.getElementById(`waitForTimestamp-${uniqueid}`).value;
        tempblock.setAttribute(`data-waitForTimestamp`, waitForTimestamp);
      }*/

      setTimeout(() => {
        e.target.innerHTML = "Saved!"
      }, 2000);

      setTimeout(() => {
        e.target.innerHTML = originalText; // Restore original text
      }, 2000);

    }

    function slackSave(e) {
      const originalText = e.target.innerHTML;
      e.target.innerHTML = "Saving...";

      let triggerType = tempblock.parentElement.childNodes[0].children[2].defaultValue;
      window.triggerType = triggerType;

      tempblock.setAttribute("data-uniqueid", uniqueid);
      tempblock.setAttribute("data-blocktype", "slack");
      tempblock.setAttribute("data-workflowtrigger", window.workflowTrigger);
      tempblock.setAttribute("data-siteid", window.siteID);
      tempblock.setAttribute("data-workflowid", window.workflowID);
      tempblock.setAttribute("data-timezone", window.timezone);

      // Get channel selection
      const channelSelect = document.getElementById(`slackChannel-${uniqueid}`);
      if (channelSelect) {
        const selectedOption = channelSelect.options[channelSelect.selectedIndex];
        if (!channelSelect.value) {
          alert('Please select a Slack channel before saving');
          e.target.innerHTML = originalText;
          return false;
        }
        tempblock.setAttribute('data-slackChannelId', channelSelect.value);
        tempblock.setAttribute('data-slackChannelName', selectedOption.textContent.replace(/^[🔒#]\s*/, ''));
      }

      // Get message
      const messageEl = document.getElementById(`slackMessage-${uniqueid}`);
      if (messageEl) {
        if (!messageEl.value.trim()) {
          alert('Please enter a message before saving');
          e.target.innerHTML = originalText;
          return false;
        }
        tempblock.setAttribute('data-slackMessage', messageEl.value);
      }

      setTimeout(() => {
        e.target.innerHTML = "Saved!";
      }, 500);

      setTimeout(() => {
        e.target.innerHTML = originalText;
      }, 2000);
    }

    function sendformSave(e) {
      const originalText = e.target.innerHTML; // Store original text
      e.target.innerHTML = "Saving...";

      tempblock.setAttribute("data-uniqueid", uniqueid);
      tempblock.setAttribute("data-blocktype", "sendform");
      tempblock.setAttribute("data-workflowtrigger", window.workflowTrigger);
      tempblock.setAttribute("data-siteid", window.siteID);
      tempblock.setAttribute("data-workflowid", window.workflowID);

      tempblock.setAttribute("data-sendformnewpatientonly", document.getElementById(`sendForNewPatientsCheck-${uniqueid}`).checked);

      let emailTemplateID, smsTemplateID, emailSendWhen, smsSendWhen;

      let sendViaEmailChecked = document.getElementById(`sendFormNewPatientsEmail-${uniqueid}`).checked;
      let sendViaTextChecked = document.getElementById(`sendFormNewPatientsText-${uniqueid}`).checked;

      if(sendViaEmailChecked) {
        emailTemplateID = document.getElementById(`send-form-new-patient-send-with-email-template-${uniqueid}`).slim.selected()[0];
        emailSendWhen = document.getElementById(`send-form-new-patient-send-with-email-when-${uniqueid}`).slim.selected()[0];

        if(emailSendWhen === "Please select an option") {
          let msg = `Please choose when to send the Email for a new Patient before exiting`;
          alert(msg);
          window.error = msg;
          e.target.innerHTML = "Save";
          return false;
        } else
          window.error = null;

        tempblock.setAttribute("data-sendformnewpatientemail", true);
        tempblock.setAttribute(`data-sendformnewpatientemailtemplateid`, emailTemplateID);
        tempblock.setAttribute(`data-sendformnewpatientemailsendwhen`, emailSendWhen);
      }

      if(sendViaTextChecked) {
        smsTemplateID = document.getElementById(`send-form-new-patient-send-with-text-template-${uniqueid}`).slim.selected()[0];
        smsSendWhen = document.getElementById(`send-form-new-patient-send-with-text-when-${uniqueid}`).slim.selected()[0];

        if(smsSendWhen === "Please select an option") {
          let msg = `Please choose when to send the Text for a New Patient before exiting`;
          alert(msg);
          window.error = msg;
          e.target.innerHTML = "Save"
          return false;
        } else
          window.error = null;

        tempblock.setAttribute("data-sendformnewpatienttext", true);
        tempblock.setAttribute("data-sendformnewpatientsmstemplateid", smsTemplateID);
        tempblock.setAttribute("data-sendformnewpatientsmssendwhen", smsSendWhen);
      }

      let results = [];
      let nodes;

      nodes = document.querySelectorAll(`[id^='send-form-row-${uniqueid}']`);
      //console.dir(nodes);

      // if the first thing which in this case is proc code if it's an empty array then just skip this
      if(nodes[0].children[0].children[0].slim.selected().length > 0) {
        for(let i = 0; i < nodes.length; i++) {
          let node = nodes[i];
          //console.log(node);

          if(node.children[0].children[0].slim) {
            let o = {
              codeNum: node.children[0].children[0].slim.selected(),
              sendVia: node.children[1].children[0].slim.selected()[0],
              templateID: node.children[2].children[0].slim.selected()[0],
              scheduleWhen: node.children[3].children[0].slim.selected()[0],
            }
            //console.log('object so far', o);
            results.push(o);
          }
        }

        tempblock.setAttribute(`data-send-form-properties`, JSON.stringify(results));
        //console.log('data-send-form-properties', results);
        //console.log('tempblock', tempblock);
      }

      setTimeout(() => {
        e.target.innerHTML = "Saved!"
      }, 1000);

      setTimeout(() => {
        e.target.innerHTML = originalText; // Restore original text
      }, 1000);

    }

    function eventListenerForAddMoreCodesForEmail() {
      counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;

      let procID = `send-email-proc-code-${uniqueid}-${counterArray[uniqueid]}`;
      let emailTemplateID = `send-email-template-${uniqueid}-${counterArray[uniqueid]}`;
      //let emailWhenID = `send-email-when-${uniqueid}-${counterArray[uniqueid]}`;
      let deleteID = `send-email-delete-${uniqueid}-${counterArray[uniqueid]}`;

      let temp = `<td><select id="${procID}" multiple/></td>`;
      temp = temp + `<td><select id="${emailTemplateID}"/></td>`;
      //temp = temp + `<td><select id="${emailWhenID}"/></td>`;
      temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

      let newNode = document.createElement('tr');
      newNode.setAttribute('id', `send-email-row-${uniqueid}-${counterArray[uniqueid]}`);
      newNode.innerHTML = temp;
      let table = document.getElementById(`send-email-proc-table-body-${uniqueid}`);
      table.appendChild(newNode);

      document.getElementById(deleteID).addEventListener("click", function (e) {
        let temp = e.target.getAttribute("id").split('-');
        let rowID = temp[temp.length - 1];
        removeProcCode(`send-email-row-${uniqueid}-${rowID}`);
      });

      let select1 = new SlimSelect({
        select: `#${procID}`,
        data: window.procCodes,
        valuesUseText: true
      });

      let select2 = new SlimSelect({
        select: `#${emailTemplateID}`,
        data: window.emailTemplates,
        valuesUseText: true
      });

      /*
      let select3 = new SlimSelect({
        select: `#${emailWhenID}`,
        data: emailSendOptions,
        valuesUseText: true
      });
      */
    }

    function eventListenerForAddMoreCodesForSms() {
      counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;

      let trID = `send-sms-row-${uniqueid}-${counterArray[uniqueid]}`;
      let procID = `send-sms-proc-code-${uniqueid}-${counterArray[uniqueid]}`;
      let smsTemplateID = `send-sms-template-${uniqueid}-${counterArray[uniqueid]}`;
      let scheduleWhen = `send-sms-when-${uniqueid}-${counterArray[uniqueid]}`;
      let deleteID = `send-sms-delete-${uniqueid}-${counterArray[uniqueid]}`;

      let temp = `<td><select id="${procID}" multiple/></td>`;
      temp = temp + `<td><select id="${smsTemplateID}"/></td>`;
      temp = temp + `<td><select id="${scheduleWhen}"/></td>`;
      temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

      let newNode = document.createElement('tr');
      newNode.setAttribute('id', trID);
      newNode.innerHTML = temp;
      let table = document.getElementById(`send-sms-proc-table-body-${uniqueid}`);
      table.appendChild(newNode);

      document.getElementById(deleteID).addEventListener("click", function (e) {
        let temp = e.target.getAttribute("id").split('-');
        let rowID = temp[temp.length - 1];
        removeProcCode(`send-sms-row-${uniqueid}-${rowID}`);
      });

      let select1 = new SlimSelect({
        select: `#${procID}`,
        data: window.procCodes,
        valuesUseText: true
      });

      let select2 = new SlimSelect({
        select: `#${smsTemplateID}`,
        data: window.smsTemplates,
        valuesUseText: true
      });

      let select3 = new SlimSelect({
        select: `#${scheduleWhen}`,
        data: smsSendOptions,
        valuesUseText: true
      });
    }

    function eventListenerForAddMoreCodesForSendForm() {
      counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;

      const sendFormChoices = Array.isArray(window.forms) ? window.forms : [];

      let trID = `send-form-row-${uniqueid}-${counterArray[uniqueid]}`;
      let procID = `send-form-proc-code-${uniqueid}-${counterArray[uniqueid]}`;
      let sendVia = `send-form-send-via-${uniqueid}-${counterArray[uniqueid]}`;
      let templateID = `send-form-templateid-${uniqueid}-${counterArray[uniqueid]}`;
      let scheduleWhen = `send-form-when-${uniqueid}-${counterArray[uniqueid]}`;
      let deleteID = `send-form-delete-${uniqueid}-${counterArray[uniqueid]}`;

      let temp = `<td><select id="${procID}" multiple/></td>`;
      temp = temp + `<td><select id="${sendVia}"/></td>`;
      temp = temp + `<td><select id="${templateID}"/></td>`;
      temp = temp + `<td><select id="${scheduleWhen}"/></td>`;
      temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

      let newNode = document.createElement('tr');
      newNode.setAttribute('id', trID);
      newNode.innerHTML = temp;
      let table = document.getElementById(`send-form-proc-table-body-${uniqueid}`);
      table.appendChild(newNode);

      document.getElementById(deleteID).addEventListener("click", function (e) {
        let temp = e.target.getAttribute("id").split('-');
        let rowID = temp[temp.length - 1];
        removeProcCode(`send-form-row-${uniqueid}-${rowID}`);
      });

      let select1 = new SlimSelect({
        select: `#${procID}`,
        data: window.procCodes,
        valuesUseText: true
      });

      let select2 = new SlimSelect({
        select: `#${sendVia}`,
        data: sendViaOptions,
        valuesUseText: true
      });

      let select3 = new SlimSelect({
        select: `#${templateID}`,
        data: sendFormChoices,
        valuesUseText: true
      });

      let select4 = new SlimSelect({
        select: `#${scheduleWhen}`,
        data: sendFormOptions,
        valuesUseText: true
      });

      document.getElementById(sendVia).addEventListener("change", function (e) {
        console.log(e.target);
        let selectedVia = e.target.options[e.target.selectedIndex].text;
        console.log(`selectedVia: ${selectedVia}`);
        select3.setData(sendFormChoices);
      });
    }

    function eventListenerForAddMoreCodesForAssignTask() {
      counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;

      let trID = `assign-task-row-${uniqueid}-${counterArray[uniqueid]}`;
      let procID = `assign-task-proc-code-${uniqueid}-${counterArray[uniqueid]}`;
      let empID = `assign-task-employee-${uniqueid}-${counterArray[uniqueid]}`;
      let taskID = `assign-task-desc-${uniqueid}-${counterArray[uniqueid]}`;
      let taskdueID = `assign-task-duedate-${uniqueid}-${counterArray[uniqueid]}`;
      let wikiID = `assign-task-wiki-${uniqueid}-${counterArray[uniqueid]}`;
      let tagID = `assign-task-tag-${uniqueid}-${counterArray[uniqueid]}`;
      let deleteID = `assign-task-delete-${uniqueid}-${counterArray[uniqueid]}`;

      // --- MODIFIED: Include <select> for tag and textarea for description ---
      let temp = `<td><select id="${procID}" multiple></select></td>`; // Keep multiple
      temp += `<td><select id="${empID}" multiple></select></td>`; // Keep multiple
      temp += `<td><textarea class="workflowTextbox task-description-textarea" id="${taskID}" rows="2" placeholder="Enter task description..."></textarea></td>`;
      temp += `<td><select id="${taskdueID}"></select></td>`;
      temp += `<td><select id="${wikiID}" multiple></select></td>`; // Keep multiple
      temp += `<td><select multiple id="${tagID}"></select></td>`; // Tag select
      temp += `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;
      // --- END MODIFICATION ---

      let newNode = document.createElement('tr');
      newNode.setAttribute('id', trID);
      newNode.innerHTML = temp;
      let table = document.getElementById(`assign-task-proc-table-body-${uniqueid}`);
      if (table) {
          table.appendChild(newNode); // Add null check

          // Attach delete listener
          const deleteBtn = document.getElementById(deleteID);
          if (deleteBtn) { // Null check
              deleteBtn.addEventListener("click", function (e) {
                  let tempIdParts = e.target.getAttribute("id").split('-');
                  let rowNum = tempIdParts[tempIdParts.length - 1];
                  removeProcCode(`assign-task-row-${uniqueid}-${rowNum}`); // Use correct row ID
              });
          }

          // Initialize SlimSelect for the new row
          new SlimSelect({ select: `#${procID}`, data: window.procCodes || [], valuesUseText: true });

          // Update employees list if needed
          let dynamicEmployees = [...(window.employees || [])];
          if (window.workflowTrigger === 'Appointment Completed') {
              let whoeverMarkedExistsDyn = dynamicEmployees.find(e => e.value === 'Whoever marked Apt Complete'); // Check by value
              if (!whoeverMarkedExistsDyn) {
                  dynamicEmployees.push({ text: 'Whoever marked Apt Complete', value: 'Whoever marked Apt Complete', html: 'Whoever marked Apt Complete' });
              }
          }
          new SlimSelect({ select: `#${empID}`, data: dynamicEmployees, valuesUseText: true });
          new SlimSelect({ select: `#${wikiID}`, data: window.wikisWithoutTemplates || [], valuesUseText: true, placeholder: 'Select a template' });

          // Adjust dueDateOptions based on trigger
          let dynamicDueDateOptions = [...dueDateOptions]; // Start with default
           if (window.workflowTrigger) {
              switch (window.workflowTrigger) {
                case 'Appointment Completed': dynamicDueDateOptions = [ { value: 'immediately', text: "Immediately" }, { value: '1day', text: "1 Day After Appointment is completed" }, { value: '2days', text: "2 Days After Appointment is completed" }, { value: '1week', text: "1 Week After Appointment is completed" } ]; break;
                case 'Appointment Scheduled': dynamicDueDateOptions = [ { value: 'immediately', text: "Immediately" }, { value: 'odoa', text: "On the Day of Appointment" }, { value: '1dayb', text: "1 Day Before the Appointment Date" }, { value: '2daysb', text: "2 Days Before the Appointment Date" }, { value: '1weekb', text: "1 Week Before the Appointment Date" } ]; break;
              }
          }
          new SlimSelect({ select: `#${taskdueID}`, data: dynamicDueDateOptions, valuesUseText: true, showSearch: false });

          // --- MODIFIED: Force an update of tag data before initializing the SlimSelect ---
          // Force availability of the latest tags
          if (typeof _this !== 'undefined' && _this && typeof _this.computedAvailableTags === 'function') {
            _this.computedAvailableTags; // Access computed property to ensure it's updated
            _this.$forceUpdate(); // Force a component update
          }
          
          // Get the most up-to-date tag data
          const slimTagData = window.availableTaskTags || [];
          console.log(`Initializing new tag select #${tagID} with ${slimTagData.length} tags`);
          window.createTaggableSlimSelect(
              `#${tagID}`,
              slimTagData,
              'Select or add tags...'
          );
          // --- END MODIFICATION ---

      } else {
          console.error(`Table body not found: assign-task-proc-table-body-${uniqueid}`);
      }
    }

        // --- START: Add this function definition ---
        function eventListenerForAddMoreCodesForAssignTaskWebform() {
      // Ensure uniqueid is accessible in this scope, or passed as an argument if needed
      if (typeof uniqueid === 'undefined') {
        console.error('uniqueid is not defined in eventListenerForAddMoreCodesForAssignTaskWebform');
        return;
      }
      // Ensure counterArray is accessible
      if (typeof counterArray === 'undefined') {
        console.error('counterArray is not defined in eventListenerForAddMoreCodesForAssignTaskWebform');
        return;
      }

      counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;

      let trID = `assign-task-webform-row-${uniqueid}-${counterArray[uniqueid]}`;
      let formElmID = `assign-task-webform-elmname-${uniqueid}-${counterArray[uniqueid]}`;
      let formElmValID = `assign-task-webform-elmval-${uniqueid}-${counterArray[uniqueid]}`;
      let empID = `assign-task-webform-employee-${uniqueid}-${counterArray[uniqueid]}`;
      let taskID = `assign-task-webform-desc-${uniqueid}-${counterArray[uniqueid]}`;
      let taskdueID = `assign-task-webform-duedate-${uniqueid}-${counterArray[uniqueid]}`;
      let wikiID = `assign-task-webform-wiki-${uniqueid}-${counterArray[uniqueid]}`;
      let tagID = `assign-task-webform-tag-${uniqueid}-${counterArray[uniqueid]}`;
      let deleteID = `assign-task-webform-delete-${uniqueid}-${counterArray[uniqueid]}`;

      let temp = `<td><select id="${formElmID}"></select></td>`;
      temp += `<td><select id="${formElmValID}"></select></td>`;
      temp += `<td><select id="${empID}" multiple></select></td>`;
      temp += `<td><textarea class="workflowTextbox task-description-textarea" id="${taskID}" rows="2" placeholder="Enter task description..."></textarea></td>`;
      temp += `<td><select id="${taskdueID}"></select></td>`;
      temp += `<td><select id="${wikiID}" multiple></select></td>`;
      temp += `<td><select multiple id="${tagID}"></select></td>`; // Tag select
      temp += `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

      let newNode = document.createElement('tr');
      newNode.setAttribute('id', trID);
      newNode.innerHTML = temp;
      let table = document.getElementById(`assign-task-website-form-table-body-${uniqueid}`);
      if (table) {
          table.appendChild(newNode);

          // Attach delete listener
          const deleteBtn = document.getElementById(deleteID);
          if (deleteBtn) {
              deleteBtn.addEventListener("click", function (e) {
                  let tempIdParts = e.target.getAttribute("id").split('-');
                  let rowNum = tempIdParts[tempIdParts.length - 1];
                  // Ensure removeProcCode is accessible or defined here
                  if (typeof removeProcCode === 'function') {
                    removeProcCode(`assign-task-webform-row-${uniqueid}-${rowNum}`);
                  } else {
                    console.error('removeProcCode function not found');
                  }
              });
          }

          // Initialize SlimSelect for the new row
          new SlimSelect({ select: `#${formElmID}`, data: window.websiteFormElements || [], valuesUseText: true, showSearch: false });
          new SlimSelect({ select: `#${formElmValID}`, data: window.websiteFormElementValues || [], valuesUseText: true, showSearch: false });
          new SlimSelect({ select: `#${empID}`, data: window.employees || [], valuesUseText: true });
          new SlimSelect({ select: `#${wikiID}`, data: window.wikisWithoutTemplates || [], valuesUseText: true, placeholder: 'Select a template' });
          new SlimSelect({ select: `#${taskdueID}`, data: dueDateOptions, valuesUseText: true, showSearch: false });
          
          // --- MODIFIED: Ensure we have the latest tag data by forcing a computed update ---
          // Force availability of the latest tags
          if (typeof _this !== 'undefined' && _this && typeof _this.computedAvailableTags === 'function') {
            _this.computedAvailableTags; // Access computed property to ensure it's updated
            _this.$forceUpdate(); // Force a component update
          }
          
          // Get the most up-to-date tag data (either from window or fall back to what's available)
          const slimTagData = window.availableTaskTags || [];
          console.log(`Initializing new tag select #${tagID} with ${slimTagData.length} tags`);
          window.createTaggableSlimSelect(
              `#${tagID}`,
              slimTagData,
              'Select or add tags...'
          );
          // --- END MODIFICATION ---
      } else {
          console.error(`Table body not found: assign-task-website-form-table-body-${uniqueid}`);
      }
    }
    // --- END: Add this function definition ---

    function eventListenerForAddMoreCodesForKanban() {
      console.log('eventListenerForAddMoreCodesForKanban called');
      console.log('Current uniqueid:', uniqueid);
      console.log('Current counterArray:', counterArray);
      
      counterArray[uniqueid] = counterArray[uniqueid] ? counterArray[uniqueid] + 1 : 1;
      console.log('Updated counterArray[uniqueid]:', counterArray[uniqueid]);

      let trID = `kanban-row-${uniqueid}-${counterArray[uniqueid]}`;
      let procID = `kanban-proc-code-${uniqueid}-${counterArray[uniqueid]}`;
      let boardID = `kanban-board-${uniqueid}-${counterArray[uniqueid]}`;
      let columnID = `kanban-column-${uniqueid}-${counterArray[uniqueid]}`;
      let actionID = `kanban-action-${uniqueid}-${counterArray[uniqueid]}`;
      let deleteID = `kanban-delete-${uniqueid}-${counterArray[uniqueid]}`;

      console.log('Generated IDs:', { trID, procID, boardID, columnID, actionID, deleteID });

      let cardID = `kanban-board-card-${uniqueid}-${counterArray[uniqueid]}`;
      let updatePropsID = `kanban-card-update-properties-${uniqueid}-${counterArray[uniqueid]}`;
      let titleID = `kanban-card-new-title-${uniqueid}-${counterArray[uniqueid]}`;
      let descID = `kanban-card-new-description-${uniqueid}-${counterArray[uniqueid]}`;
      let tagsID = `kanban-card-new-tags-${uniqueid}-${counterArray[uniqueid]}`;
      let moveToColumnID = `kanban-board-move-to-column-${uniqueid}-${counterArray[uniqueid]}`;

      let temp = `<td><select id="${procID}" multiple/></td>`;
      temp = temp + `<td><select id="${boardID}"/></td>`;
      temp = temp + `<td><select id="${columnID}"/></td>`;
      temp = temp + `<td><select id="${actionID}"/></td>`;
      temp = temp + `<td><select id="${cardID}" style="display: none;"/></td>`;
      temp = temp + `<td>
        <div id="${updatePropsID}" style="display: none;">
          <div class="card-update-field mb-2">
            <label class="small text-muted">Card Title:</label>
            <input type="text" id="${titleID}" class="form-control form-control-sm" placeholder="Select action first"/>
          </div>
          <div class="card-update-field mb-2">
            <label class="small text-muted">Card Description:</label>
            <textarea id="${descID}" class="form-control form-control-sm" rows="2" placeholder="Select action first"></textarea>
          </div>
          <div class="card-update-field mb-2">
            <label class="small text-muted" id="${moveToColumnID.replace('kanban-board-move-to-column', 'kanban-move-column-label')}">Column:</label>
            <select id="${moveToColumnID}" class="form-control form-control-sm" style="display: none;">
              <option value="">Select column</option>
            </select>
          </div>
          <div class="card-update-field">
            <label class="small text-muted">Card Tags:</label>
            <input type="text" id="${tagsID}" class="form-control form-control-sm" placeholder="Select action first"/>
          </div>
        </div>
      </td>`;
      temp = temp + `<td><i id="${deleteID}" class="glyphicon glyphicon-trash"/></td>`;

      console.log('Generated HTML:', temp);

      let newNode = document.createElement('tr');
      newNode.setAttribute('id', trID);
      newNode.innerHTML = temp;
      
      console.log('Looking for table with ID:', `kanban-table-body-${uniqueid}`);
      let table = document.getElementById(`kanban-table-body-${uniqueid}`);
      console.log('Table found:', table);
      
      if (table) {
        console.log('Appending new row to table');
        
        // Create a divider row first
        let dividerRow = document.createElement('tr');
        dividerRow.setAttribute('id', `divider-${trID}`);
        dividerRow.innerHTML = `<td colspan="7" style="padding: 0; border: none;"><hr style="margin: 15px 0; border: 1px solid #ddd; border-radius: 2px;"></td>`;
        
        table.appendChild(dividerRow); // Add divider first
        table.appendChild(newNode);    // Then add the actual row

        // Initialize SlimSelect for the new row with proper logic
        console.log('Initializing SlimSelect for new row...');
        
        // 1. Proc Code dropdown
        const procSelect = new SlimSelect({ 
          select: `#${procID}`, 
          data: window.procCodes || [], 
          valuesUseText: true 
        });
        
        // 2. Board dropdown with change event
        const boardSelect = new SlimSelect({ 
          select: `#${boardID}`, 
          data: _this.boardOptions || [], 
          valuesUseText: true,
          events: {
            afterChange: (newval) => {
              console.log('Board changed for new row:', newval);
              const selectedBoardID = newval[0].value;
              const columns = _this.getColumnsByFbboardId(selectedBoardID);
              console.log('Columns for board:', columns);
              
              // Update column dropdown with board's columns
              let columnData = [];
              if (columns && columns.length > 0) {
                for(let column of columns) {
                  columnData.push({
                    text: column.name,
                    value: column.id,
                    html: column.name
                  });
                }
              }
              columnSelect.setData(columnData);
              columnSelect.enable();
              
              // Enable action dropdown
              actionSelect.enable();
            }
          }
        });
        
        // 3. Column dropdown (initially disabled)
        const columnSelect = new SlimSelect({ 
          select: `#${columnID}`, 
          data: [], 
          valuesUseText: true,
          events: {
            afterChange: (newval) => {
              console.log('Column changed for new row:', newval);
              // Enable action dropdown when column is selected
              actionSelect.enable();
            }
          }
        });
        columnSelect.disable();
        
        // 4. Action dropdown with event handling (initially disabled)
        const actionSelect = new SlimSelect({ 
          select: `#${actionID}`, 
          data: [
            { placeholder: true, text: 'Select action'},
            { text: 'Add a new Card', value: 'addcard' },
            { text: 'Update a Card', value: 'updatecard' },
            { text: 'Move Card to Column', value: 'movecardtocolumn' }
          ], 
          valuesUseText: true,
          showSearch: false,
          events: {
            afterChange(newval) {
              let action = newval[0].value;
              console.log('Action changed for new row:', action);
              
              // Get the selected board and column for this row
              let selectedBoardID = boardSelect.getSelected()[0];
              let selectedColumnID = columnSelect.getSelected()[0];
              
              // Initialize card select variable for this row
              let cardSelect = null;
              
              switch (action) {
                case 'addcard':
                  // Hide card selection dropdown for add card
                  if(cardSelect) {
                    cardSelect.destroy();
                    cardSelect = null;
                  }
                  document.getElementById(cardID).style.display = "none";
                  
                  // Show update properties for creating new card
                  document.getElementById(updatePropsID).style.display = "block";
                  
                  // Clear and prepare fields for new card creation
                  let titleField = document.getElementById(titleID);
                  let descField = document.getElementById(descID);
                  let tagsField = document.getElementById(tagsID);
                  
                  if(titleField) {
                    titleField.value = '';
                    titleField.placeholder = 'Enter new card title (required)';
                  }
                  if(descField) {
                    descField.value = '';
                    descField.placeholder = 'Enter card description (optional)';
                  }
                  if(tagsField) {
                    tagsField.value = '';
                    tagsField.placeholder = 'Enter tags, comma-separated (optional)';
                  }
                  
                  // Show all fields for new card creation
                  document.getElementById(titleID).parentElement.style.display = "block";
                  document.getElementById(descID).parentElement.style.display = "block";
                  document.getElementById(tagsID).parentElement.style.display = "block";
                  
                  // Populate column dropdown for add card
                  let columns = _this.getColumnsByBoardId(selectedBoardID);
                  if(columns) {
                    let moveToColumnSelect = document.getElementById(moveToColumnID);
                    if(moveToColumnSelect) {
                      moveToColumnSelect.innerHTML = '<option value="">Add to trigger column</option>';
                      columns.forEach(column => {
                        let option = document.createElement('option');
                        option.value = column.id;
                        option.textContent = column.name;
                        if(column.id === selectedColumnID) {
                          option.textContent += ' (trigger column - default)';
                          option.selected = true;
                        }
                        moveToColumnSelect.appendChild(option);
                      });
                      moveToColumnSelect.style.display = "block";
                    }
                  }
                  break;

                case 'updatecard':
                case 'movecardtocolumn':
                  let cards = _this.getCardsByFbboardIdAndColumnId(selectedBoardID, selectedColumnID);
                  if(cards) {
                    let slimSelectData = [{
                      placeholder: true,
                      text: 'Select a card',
                    }];
                    for(let card of cards) {
                      slimSelectData.push({
                        text: card.name,
                        value: card.id,
                        html: card.name
                      });
                    }

                    // Always destroy and recreate card select
                    if(cardSelect) {
                      cardSelect.destroy();
                      cardSelect = null;
                    }
                    
                    document.getElementById(cardID).style.display = 'flex';
                    cardSelect = new SlimSelect({
                      select: `#${cardID}`,
                      data: slimSelectData,
                      valuesUseText: true,
                      events: {
                        afterChange(cardNewval) {
                          if(cardNewval && cardNewval.length > 0 && cardNewval[0].value) {
                            let selectedCardID = cardNewval[0].value;
                            let selectedCard = cards.find(c => c.id === selectedCardID);
                            
                            if(selectedCard) {
                              document.getElementById(updatePropsID).style.display = "block";
                              
                              if(action === 'updatecard') {
                                // Show all fields for update action
                                document.getElementById(titleID).parentElement.style.display = "block";
                                document.getElementById(descID).parentElement.style.display = "block";
                                document.getElementById(tagsID).parentElement.style.display = "block";
                                
                                // Populate fields with existing card data
                                let titleField = document.getElementById(titleID);
                                let descField = document.getElementById(descID);
                                let tagsField = document.getElementById(tagsID);
                                
                                if(titleField) {
                                  titleField.value = selectedCard.name || '';
                                  titleField.placeholder = `Current: ${selectedCard.name || 'No title'}`;
                                }
                                if(descField) {
                                  descField.value = selectedCard.description || '';
                                  descField.placeholder = `Current: ${selectedCard.description || 'No description'}`;
                                }
                                if(tagsField) {
                                  let currentTags = selectedCard.tags ? selectedCard.tags.join(', ') : '';
                                  tagsField.value = currentTags;
                                  tagsField.placeholder = `Current: ${currentTags || 'No tags'}`;
                                }
                                
                                // Populate move-to-column dropdown
                                let columns = _this.getColumnsByBoardId(selectedBoardID);
                                if(columns) {
                                  let moveToColumnSelect = document.getElementById(moveToColumnID);
                                  if(moveToColumnSelect) {
                                    moveToColumnSelect.innerHTML = '<option value="">Keep in current column</option>';
                                    columns.forEach(column => {
                                      let option = document.createElement('option');
                                      option.value = column.id;
                                      option.textContent = column.name;
                                      if(column.id === selectedColumnID) {
                                        option.selected = true;
                                        option.textContent += ' (current)';
                                      }
                                      moveToColumnSelect.appendChild(option);
                                    });
                                    moveToColumnSelect.style.display = "block";
                                  }
                                }
                              } else if(action === 'movecardtocolumn') {
                                // Hide other fields for move action
                                document.getElementById(titleID).parentElement.style.display = "none";
                                document.getElementById(descID).parentElement.style.display = "none";
                                document.getElementById(tagsID).parentElement.style.display = "none";
                                
                                // Get current column name for better UX
                                let currentColumnName = _this.getColumnsByBoardId(selectedBoardID)?.find(col => col.id === selectedColumnID)?.name || 'Current Column';
                                
                                // Update label to show move context
                                let moveLabelID = moveToColumnID.replace('kanban-board-move-to-column', 'kanban-move-column-label');
                                let moveLabel = document.getElementById(moveLabelID);
                                if(moveLabel) {
                                  moveLabel.innerHTML = `<i class="fa fa-arrow-right text-primary"></i> Move to Column: <small class="text-muted">(from ${currentColumnName})</small>`;
                                  moveLabel.classList.add('text-primary');
                                }
                                
                                // Show only move-to-column dropdown
                                let columns = _this.getColumnsByBoardId(selectedBoardID);
                                if(columns) {
                                  let moveToColumnSelect = document.getElementById(moveToColumnID);
                                  if(moveToColumnSelect) {
                                    moveToColumnSelect.innerHTML = '<option value="">Choose destination column...</option>';
                                    columns.forEach(column => {
                                      let option = document.createElement('option');
                                      option.value = column.id;
                                      option.textContent = column.name;
                                      if(column.id === selectedColumnID) {
                                        option.textContent += ' (current - cannot move here)';
                                        option.disabled = true;
                                      }
                                      moveToColumnSelect.appendChild(option);
                                    });
                                    moveToColumnSelect.style.display = "block";
                                  }
                                }
                              }
                            }
                          } else {
                            document.getElementById(updatePropsID).style.display = "none";
                          }
                        }
                      }
                    });
                    
                    // Initially hide update properties until a card is selected
                    document.getElementById(updatePropsID).style.display = "none";
                  }
                  break;

                default:
                  // Hide both card selection and update properties
                  if(cardSelect) {
                    cardSelect.destroy();
                    cardSelect = null;
                  }
                  document.getElementById(cardID).style.display = "none";
                  document.getElementById(updatePropsID).style.display = "none";
                  break;
              }
            }
          }
        });
        actionSelect.disable();

        // Attach delete listener
        document.getElementById(deleteID).addEventListener("click", function (e) {
          let tempIdParts = e.target.getAttribute("id").split('-');
          let rowNum = tempIdParts[tempIdParts.length - 1];
          removeProcCode(`kanban-row-${uniqueid}-${rowNum}`);
        });
        
        console.log('Successfully added new row to Kanban table');
      } else {
        console.error('Table not found! Looking for all kanban-related elements:');
        console.log('All elements with "kanban" in ID:', document.querySelectorAll('[id*="kanban"]'));
        console.log('All table elements:', document.querySelectorAll('table'));
        console.log('All tbody elements:', document.querySelectorAll('tbody'));
      }
    }

    function kanbanSave(e) { // Added event parameter
      const originalText = e.target.innerHTML; // Store original text
      e.target.innerHTML = "Saving...";
      let triggerType = tempblock.parentElement.childNodes[0].children[2].defaultValue;
      window.triggerType = triggerType;

      tempblock.setAttribute("data-uniqueid", uniqueid);
      tempblock.setAttribute("data-blocktype", "kanban");
      tempblock.setAttribute("data-workflowtrigger", window.workflowTrigger);
      tempblock.setAttribute("data-siteid", window.siteID);
      tempblock.setAttribute("data-workflowid", window.workflowID);

      let results = [];
      let nodes = document.querySelectorAll(`[id^='kanban-row-${uniqueid}']`);

      for(let i = 0; i < nodes.length; i++) {
        let node = nodes[i];
        
        // Get procedure codes from the first column
        let procCodes = node.children[0].children[0].slim.getSelected();
        
        // Get selected kanban board from the second column
        let kanbanBoardID = node.children[1].children[0].slim.getSelected()[0];
        
        // Get selected column from the third column
        let kanbanColumnID = node.children[2].children[0].slim.getSelected()[0];
        
        // Get card action from the fourth column
        let cardAction = node.children[3].children[0].slim.getSelected()[0];
        
        // If we have a card dropdown (for update/move actions), get the selected card
        let selectedCardID = null;
        if(node.children[4] && node.children[4].children[0] && 
           node.children[4].children[0].style.display !== 'none' &&
           node.children[4].children[0].slim) {
          selectedCardID = node.children[4].children[0].slim.getSelected()[0];
        }
        
        // If we have a move-to-column dropdown, get the target column
        let moveToColumnID = null;
        if(node.children[5] && node.children[5].children[0] && 
           node.children[5].children[0].style.display !== 'none' &&
           node.children[5].children[0].slim) {
          moveToColumnID = node.children[5].children[0].slim.getSelected()[0];
        }

        // Extract row number from node ID to get the correct element IDs
        let rowID = node.id; // e.g., "kanban-row-uniqueid-1" or "send-sms-row" for first row
        let rowSuffix = '';
        if(rowID.includes('-')) {
          let parts = rowID.split('-');
          if(parts.length > 2 && !isNaN(parts[parts.length - 1])) {
            // This is an additional row (has counter suffix)
            rowSuffix = `-${parts[parts.length - 1]}`;
          }
        }
        
        // Collect card update properties based on the action type
        let cardUpdateProperties = {};
        if(cardAction === 'addcard') {
          // For add card, collect all the new card properties
          let newTitle = document.getElementById(`kanban-card-new-title-${uniqueid}${rowSuffix}`)?.value || '';
          let newDescription = document.getElementById(`kanban-card-new-description-${uniqueid}${rowSuffix}`)?.value || '';
          let newTags = document.getElementById(`kanban-card-new-tags-${uniqueid}${rowSuffix}`)?.value || '';
          let addToColumn = document.getElementById(`kanban-board-move-to-column-${uniqueid}${rowSuffix}`)?.value || '';
          
          cardUpdateProperties = {
            newTitle: newTitle.trim(),
            newDescription: newDescription.trim(),
            newTags: newTags.trim(),
            addToColumnID: addToColumn || kanbanColumnID // Default to trigger column if not specified
          };
        } else if(cardAction === 'updatecard') {
          // Get the update property values
          let newTitle = document.getElementById(`kanban-card-new-title-${uniqueid}${rowSuffix}`)?.value || '';
          let newDescription = document.getElementById(`kanban-card-new-description-${uniqueid}${rowSuffix}`)?.value || '';
          let newTags = document.getElementById(`kanban-card-new-tags-${uniqueid}${rowSuffix}`)?.value || '';
          let moveToColumn = document.getElementById(`kanban-board-move-to-column-${uniqueid}${rowSuffix}`)?.value || '';
          
          cardUpdateProperties = {
            newTitle: newTitle.trim(),
            newDescription: newDescription.trim(),
            newTags: newTags.trim(),
            moveToColumnID: moveToColumn
          };
        } else if(cardAction === 'movecardtocolumn') {
          // For move action, only collect the target column
          let moveToColumn = document.getElementById(`kanban-board-move-to-column-${uniqueid}${rowSuffix}`)?.value || '';
          cardUpdateProperties = {
            moveToColumnID: moveToColumn
          };
        }

        let o = {
          codeNum: procCodes,
          kanbanBoardID: kanbanBoardID,
          kanbanColumnID: kanbanColumnID,
          cardAction: cardAction,
          selectedCardID: selectedCardID,
          moveToColumnID: moveToColumnID, // Keep for backward compatibility
          cardUpdateProperties: cardUpdateProperties // New structured update properties
        };
        
        results.push(o);
      }

      tempblock.setAttribute(`data-kanban-properties`, JSON.stringify(results));
      
      setTimeout(() => {
        e.target.innerHTML = "Saved!"
      }, 1000);

      setTimeout(() => {
        e.target.innerHTML = originalText; // Restore original text
      }, 1000);
    }

    this.$nextTick(() => {
      const createFollowupSaveBtn = document.getElementById("createfollowupsave");
      if (createFollowupSaveBtn) {
          createFollowupSaveBtn.addEventListener("click", function () {
            //console.log(`create followup saved called`);
            if (tempblock) { // Ensure tempblock is defined
                tempblock.setAttribute("data-blocktype", "assigntask");
            }
          });
      }

      const mailLetterSaveBtn = document.getElementById("maillettersave");
      if (mailLetterSaveBtn) {
          mailLetterSaveBtn.addEventListener("click", function () {
            //console.log(`mail letter saved called`);
            if (tempblock) { // Ensure tempblock is defined
                tempblock.setAttribute("data-blocktype", "maillettersave");
            }
          });
      }
    });

    /*
      document.getElementById("removeblock").addEventListener("click", function(){
          window.flowy.deleteBlocks();
      });
    */

    var aclick = false;
    var noinfo = false;
    var beginTouch = function (event) {
      //console.log(`in begin touch`);
      aclick = true;
      noinfo = false;

      if (event.target.closest(".create-flowy")) {
        noinfo = true;
      }
    };

    var checkTouch = function (event) {
      aclick = false;
    };

    var doneTouch = function (event) {
      //console.dir(event);
      //console.log(`doneTouch - event target id: ${event.target.id}, event type: ${event.type}, aclick: ${aclick}, noinfo: ${noinfo}`);
      //console.log(`aclick: ${aclick}, noinfo: ${noinfo}, rightcard: ${rightcard}`);

      if (event.type === "mouseup" && aclick && !noinfo) {
        const targetId = event.target.id;
        
        // Handle save buttons - check for both static IDs and IDs with uniqueid suffix
        const saveButtonPrefixes = {
          'xFollowupsCompletedsave': 'xFollowupsCompleted',
          'smssave': 'sms',
          'emailsave': 'email',
          'assigntasksave': 'assigntask',
          'kanbansave': 'kanban',
          'waitsave': 'wait',
          'slacksave': 'slack',
          'sendformsave': 'sendform'
        };
        
        const saveCloseButtonPrefixes = {
          'xFollowupsCompletedsaveclose': 'xFollowupsCompleted',
          'smssaveclose': 'sms',
          'emailsaveclose': 'email',
          'assigntasksaveclose': 'assigntask',
          'kanbansaveclose': 'kanban',
          'waitsaveclose': 'wait',
          'slacksaveclose': 'slack',
          'sendformsaveclose': 'sendform'
        };

        // Check if it's a regular save button (with or without uniqueid suffix)
        let matchedPrefix = null;
        for (let buttonId in saveButtonPrefixes) {
          if (targetId === buttonId || targetId.startsWith(buttonId + '-')) {
            matchedPrefix = saveButtonPrefixes[buttonId];
            if (window[`${matchedPrefix}Save`]) {
              console.log(`Calling ${matchedPrefix}Save`);
              window[`${matchedPrefix}Save`]();
            }
            return;
          }
        }
        
        // Special case for saveblock
        if (targetId === "saveblock" || targetId.startsWith("saveblock-")) {
          console.log('Saveblock clicked');
          savePropertiesToDivData();
          return;
        }
        
        // Check if it's a save & close button (with or without uniqueid suffix)
        for (let buttonId in saveCloseButtonPrefixes) {
          if (targetId === buttonId || targetId.startsWith(buttonId + '-')) {
            matchedPrefix = saveCloseButtonPrefixes[buttonId];
            if (window[`${matchedPrefix}Save`]) {
              window[`${matchedPrefix}Save`](event); // Pass the event object
              // Close the sidebar after save
              setTimeout(function() {
                // Find and close the expanded properties panel
                const expandedProps = document.querySelector('.blockprops.expanded');
                const openWrap = document.querySelector('.blockpropswrap.itson');
                
                if (expandedProps) {
                  expandedProps.classList.remove("expanded");
                }
                
                setTimeout(function() {
                  if (openWrap) {
                    openWrap.classList.remove("itson");
                  }
                }, 300);
              }, 100);
            }
            return;
          }
        }

        const closestBlock = event.target.closest(".block");

        if (
          closestBlock &&
          closestBlock.classList &&
          !closestBlock.classList.contains("dragging")
        ) {
          //console.log(`i am closest to block and not being dragged`);
          /*
                    if(selectedblock) {
                        tempblock.classList.remove("selectedblock");
                        selectedblock.classList.remove("selectedblock");
                        selectedblock = undefined;
                    }
                    */

          if (currentblock && currentblock.propertiesDivPrefix !== "") {
            document.getElementById(`${currentblock.propertiesDivPrefix}properties`).classList.remove("expanded");
            document.getElementById(`${currentblock.propertiesDivPrefix}wrap`).classList.remove("itson");
          }

          tempblock = closestBlock;
          // Find the blockelemid input by class name (not by index, since delete button shifts indices)
          const blockelemidInput = tempblock.querySelector('.blockelemid');
          currentblockid = blockelemidInput ? blockelemidInput.value : null;

          //currentblock = blocks[currentblockid - 1]; (this doesn't make sense because some blocks could be disabled)
          currentblock = getSnappingBlock(currentblockid); // this is better way of getting the right block


          /*
          console.log('blocks', blocks);
          console.log('currentblock', currentblock); // block object properties
          console.log('tempblock', tempblock); // html of the block
          console.log('blockelemidInput', blockelemidInput);
          */

          if (currentblock && currentblock.propertiesDivPrefix !== "") {

            if (tempblock.attributes['data-uniqueid']) {
              uniqueid = tempblock.attributes['data-uniqueid'].nodeValue;
              //console.log(`Found existing uniqueid: ${uniqueid}`);
            } else {
              uniqueid = uid();
              //console.log(`Created new uniqueid: ${uniqueid}`);
            }

            // Now check and see if the properties are loaded already
            let propertiesCheck = window[`${currentblock.propertiesDivPrefix}PropertiesLoaded-${uniqueid}`];
            //console.log('propertiesCheck', propertiesCheck);

            if(!propertiesCheck) {
              //console.log(`Properties are not loaded. Creating template now`);
              createTemplate(currentblock, uniqueid);
            }

            if (isFunctionDefined(`${currentblock.propertiesDivPrefix}Load`)) {

              //console.log(`${currentblock.propertiesDivPrefix}Load function is defined. so now trying to run that`);

              /* BEFORE I load the pop-up, let's make sure the proc codes are right
                For instance, for appt_broken, I only need to show 2 proc codes and not all of them
              */

              // Restore original proc codes first, then filter if needed
              if(window.originalProcCodes) {
                window.procCodes = [...window.originalProcCodes]; // Restore from backup
              }
              
              if(window.workflowTrigger && window.workflowTrigger === 'Appointment Broken') {
                window.procCodes = window.procCodes.filter(function(proc) {
                  // Use proc.text or proc.html instead of proc.innerHTML
                  let procText = proc.text || proc.html || '';
                  let temp = /(.*?)-.*/.exec(procText);
                  if(temp && temp.length > 0) {
                    return temp[1].trim() === 'D9986' || temp[1].trim() === 'D9987';
                  }
                  return false; // If no match, exclude it
                });
              }

              //console.log(`about to call function ${currentblock.propertiesDivPrefix}Load with`, tempblock, uniqueid);
              window[`${currentblock.propertiesDivPrefix}Load`](tempblock, uniqueid);

              _this.$nextTick(() => { // Wrap DOM access and listener attachment
                const propertiesEl = document.getElementById(`${currentblock.propertiesDivPrefix}properties-${uniqueid}`);
                const wrapEl = document.getElementById(`${currentblock.propertiesDivPrefix}wrap-${uniqueid}`);
                const closeBtn = document.getElementById(`${currentblock.propertiesDivPrefix}close-${uniqueid}`);

                if (propertiesEl) propertiesEl.classList.add("expanded");
                if (wrapEl) wrapEl.classList.add("itson");
                if (closeBtn) closeBtn.addEventListener("click", eventListenerForCloseProperties);

                let saveFnName = `${currentblock.propertiesDivPrefix}Save`;
                if (isFunctionDefined(saveFnName)) {
                  const saveBtn = document.getElementById(`${currentblock.propertiesDivPrefix}save-${uniqueid}`);
                  if (saveBtn) saveBtn.addEventListener("click", window[saveFnName]);
                }

                // set up on change for wait
                if (currentblock.propertiesDivPrefix === 'wait') {
                  const waitForEl = document.getElementById(`waitFor-${uniqueid}`);
                  const waitUntilEl = document.getElementById(`waitUntilCondition-${uniqueid}`);
                  if (waitForEl) waitForEl.addEventListener("click", waitSaveOnSelect);
                  if (waitUntilEl) waitUntilEl.addEventListener("click", waitSaveOnSelect);

                  //document.getElementById(`waitForTime-${uniqueid}`).addEventListener("click", waitSaveOnSelect);

                  //let elm = document.getElementById(`datepicker-${uniqueid}`);
                  flatpickr(`#datepicker-${uniqueid}`, {
                    enableTime: true,
                    //dateFormat: "Y-m-d H:i",
                    //dateFormat: "Y-m-d H:i",
                    onChange: function(selectedDates, dateStr, instance) {
                      //console.log(selectedDates);
                      //console.log(dateStr);

                      /*
                        AWS Step Function timestamp format:
                        Timestamps must conform to the RFC3339 profile of ISO 8601, with the further restrictions that an uppercase T
                        must separate the date and time portions, and an uppercase Z must denote that a numeric time zone offset is not present,
                        for example, 2016-08-18T17:33:00Z.
                      */
                      // ** FIX: Validate date before using it **
                      let temp;
                      try {
                        const testDate = new Date(dateStr);
                        if (isNaN(testDate.getTime())) {
                          console.warn('Invalid workflow date detected, using current date:', dateStr);
                          temp = new Date().toISOString();
                        } else {
                          temp = testDate.toISOString();
                        }
                      } catch (error) {
                        console.error('Error parsing workflow date, using current date:', dateStr, error);
                        temp = new Date().toISOString();
                      }

                      /*
                      let year = temp.getFullYear();
                      let month = temp.getMonth()+1;
                      let dt = temp.getDate();
                      let hr = temp.getHours();
                      let min = temp.getMinutes();
                      let sec = temp.getSeconds();
                      let final = year + '-' + month + '-' + dt + "T" + hr + ":" + min + ":" + sec + "Z";
                      final = new Date().toISOString();
                      */

                      //let elm = document.getElementById(`waitForTimestamp-${uniqueid}`);
                      //elm.value = temp
                      //console.log(temp);
                    },

                    /*
                    parseDate: (datestr, format) => {
                      return moment(datestr, format, true).toDate();
                    },
                    */
                  });
                }

                rightcard = true;
              }); // End $nextTick
            } else {
              console.error(`function ${currentblock.propertiesDivPrefix}Load not found`);
            }
          }
        }
      }
    };

    // Store reference to Vue instance for global access
    const vueInstance = this;
    
    // Add global block click handler that can be called from flowy.js
    window.handleBlockClick = function(event, clickedBlock) {
      console.log('window.handleBlockClick called with:', {
        event: event,
        clickedBlock: clickedBlock,
        targetId: event.target.id,
        blockId: clickedBlock ? clickedBlock.id : 'none'
      });
      
      // Simulate the doneTouch logic for block selection
      const targetId = event.target.id;
      
      // Handle save buttons - check for both static IDs and IDs with uniqueid suffix
      const saveButtonPrefixes = {
        'xFollowupsCompletedsave': 'xFollowupsCompleted',
        'smssave': 'sms',
        'emailsave': 'email',
        'assigntasksave': 'assigntask',
        'kanbansave': 'kanban',
        'waitsave': 'wait',
        'slacksave': 'slack',
        'sendformsave': 'sendform'
      };
      
      const saveCloseButtonPrefixes = {
        'xFollowupsCompletedsaveclose': 'xFollowupsCompleted',
        'smssaveclose': 'sms',
        'emailsaveclose': 'email',
        'assigntasksaveclose': 'assigntask',
        'kanbansaveclose': 'kanban',
        'waitsaveclose': 'wait',
        'slacksaveclose': 'slack',
        'sendformsaveclose': 'sendform'
      };

      // Check if it's a regular save button (with or without uniqueid suffix)
      let matchedPrefix = null;
      for (let buttonId in saveButtonPrefixes) {
        if (targetId === buttonId || targetId.startsWith(buttonId + '-')) {
          matchedPrefix = saveButtonPrefixes[buttonId];
          if (window[`${matchedPrefix}Save`]) {
            window[`${matchedPrefix}Save`](event); // Pass the event object
          }
          return;
        }
      }
      
      // Special case for saveblock
      if (targetId === "saveblock" || targetId.startsWith("saveblock-")) {
        savePropertiesToDivData();
        return;
      }
      
      // Check if it's a save & close button (with or without uniqueid suffix)
      for (let buttonId in saveCloseButtonPrefixes) {
        if (targetId === buttonId || targetId.startsWith(buttonId + '-')) {
          matchedPrefix = saveCloseButtonPrefixes[buttonId];
          if (window[`${matchedPrefix}Save`]) {
            window[`${matchedPrefix}Save`](event); // Pass the event object
            // Close the sidebar after save
            setTimeout(function() {
              // Find and close the expanded properties panel
              const expandedProps = document.querySelector('.blockprops.expanded');
              const openWrap = document.querySelector('.blockpropswrap.itson');
              
              if (expandedProps) {
                expandedProps.classList.remove("expanded");
              }
              
              setTimeout(function() {
                if (openWrap) {
                  openWrap.classList.remove("itson");
                }
              }, 300);
            }, 100);
          }
          return;
        }
      }

      const closestBlock = clickedBlock || event.target.closest(".block");

      if (closestBlock && closestBlock.classList && !closestBlock.classList.contains("dragging")) {
        // Close any existing properties panel
        if (currentblock && currentblock.propertiesDivPrefix !== "") {
          // Find any currently expanded properties panel
          const existingExpanded = document.querySelector('.blockprops.expanded');
          const existingWrapOn = document.querySelector('.blockpropswrap.itson');
          if (existingExpanded) existingExpanded.classList.remove("expanded");
          if (existingWrapOn) existingWrapOn.classList.remove("itson");
        }

        tempblock = closestBlock;
        
        // Find the blockelemid input by class name (not by index, since delete button shifts indices)
        const blockelemidInput = tempblock.querySelector('.blockelemid');
        console.log('tempblock structure:', {
          tempblock: tempblock,
          blockelemidInput: blockelemidInput,
          blockelemidValue: blockelemidInput ? blockelemidInput.value : 'not found'
        });
        
        if (blockelemidInput && blockelemidInput.value) {
          currentblockid = blockelemidInput.value;
          console.log('Getting snapping block for ID:', currentblockid);
          currentblock = getSnappingBlock(currentblockid);
          console.log('getSnappingBlock returned:', currentblock);
        } else {
          console.error('Could not find .blockelemid input in tempblock');
          return;
        }

        if (currentblock && currentblock.propertiesDivPrefix !== "") {
          if (tempblock.attributes['data-uniqueid']) {
            uniqueid = tempblock.attributes['data-uniqueid'].nodeValue;
          } else {
            uniqueid = uid();
            tempblock.setAttribute('data-uniqueid', uniqueid);
          }

          // Check if properties are already loaded
          let propertiesCheck = window[`${currentblock.propertiesDivPrefix}PropertiesLoaded-${uniqueid}`];

          if (!propertiesCheck) {
            createTemplate(currentblock, uniqueid);
          }

          if (isFunctionDefined(`${currentblock.propertiesDivPrefix}Load`)) {
            // Load procedure codes filtering if needed
            // Restore original proc codes first, then filter if needed
            if(window.originalProcCodes) {
              window.procCodes = [...window.originalProcCodes]; // Restore from backup
            }
            
            if (window.workflowTrigger && window.workflowTrigger === 'Appointment Broken') {
              if (window.procCodes) {
                window.procCodes = window.procCodes.filter(function(proc) {
                  // Use proc.text or proc.html instead of proc.innerHTML
                  let procText = proc.text || proc.html || '';
                  let temp = /(.*?)-.*/.exec(procText);
                  if (temp && temp.length > 0) {
                    return temp[1].trim() === 'D9986' || temp[1].trim() === 'D9987';
                  }
                  return false; // If no match, exclude it
                });
              }
            }

            window[`${currentblock.propertiesDivPrefix}Load`](tempblock, uniqueid);

            vueInstance.$nextTick(() => {
              const propertiesEl = document.getElementById(`${currentblock.propertiesDivPrefix}properties-${uniqueid}`);
              const wrapEl = document.getElementById(`${currentblock.propertiesDivPrefix}wrap-${uniqueid}`);
              const closeBtn = document.getElementById(`${currentblock.propertiesDivPrefix}close-${uniqueid}`);

              console.log('Block click debug:', {
                blockType: currentblock.propertiesDivPrefix,
                uniqueid: uniqueid,
                propertiesEl: propertiesEl,
                wrapEl: wrapEl,
                closeBtn: closeBtn
              });

              if (propertiesEl) propertiesEl.classList.add("expanded");
              if (wrapEl) wrapEl.classList.add("itson");
              if (closeBtn) closeBtn.addEventListener("click", eventListenerForCloseProperties);

              let saveFnName = `${currentblock.propertiesDivPrefix}Save`;
              if (isFunctionDefined(saveFnName)) {
                const saveBtn = document.getElementById(`${currentblock.propertiesDivPrefix}save-${uniqueid}`);
                if (saveBtn) saveBtn.addEventListener("click", window[saveFnName]);
              }

              // Handle special cases for wait block
              if (currentblock.propertiesDivPrefix === 'wait') {
                const waitForEl = document.getElementById(`waitFor-${uniqueid}`);
                const waitUntilEl = document.getElementById(`waitUntilCondition-${uniqueid}`);
                if (waitForEl) waitForEl.addEventListener("click", waitSaveOnSelect);
                if (waitUntilEl) waitUntilEl.addEventListener("click", waitSaveOnSelect);

                if (typeof flatpickr !== 'undefined') {
                  flatpickr(`#datepicker-${uniqueid}`, {
                    enableTime: true,
                    onChange: function(selectedDates, dateStr, instance) {
                      // ** FIX: Validate date before using it **
                      let temp;
                      try {
                        const testDate = new Date(dateStr);
                        if (isNaN(testDate.getTime())) {
                          console.warn('Invalid workflow date detected, using current date:', dateStr);
                          temp = new Date().toISOString();
                        } else {
                          temp = testDate.toISOString();
                        }
                      } catch (error) {
                        console.error('Error parsing workflow date, using current date:', dateStr, error);
                        temp = new Date().toISOString();
                      }
                    }
                  });
                }
              }

              rightcard = true;
            });
          } else {
            console.error(`function ${currentblock.propertiesDivPrefix}Load not found`);
          }
        }
      }
    };

    addEventListener("mousedown", beginTouch, false);
    addEventListener("mousemove", checkTouch, false);
    addEventListener("mouseup", doneTouch, false);
    addEventListenerMulti("touchstart", beginTouch, false, ".block");

    let query = {
        type: 'CLIENT_PROC_CODES',
        siteID: this.siteID
    };

    let results = await this.runQuery(query);
    if(results && results.data && results.data.length > 0) {
      let temp = results.data;
      for (let i = 0; i < temp.length; i++) {
        let code = temp[i];
        this.procCodes.push(
          {
            text: `${code.ProcCode} - ${code.Descript}`,
            value: code.CodeNum,
            html: `${code.ProcCode} - ${code.Descript}`,
          }
        );
      }
    }

    window.procCodes = this.procCodes;
    // Keep a backup of original proc codes for filtering purposes
    window.originalProcCodes = [...this.procCodes]; // Clone the array

    //let wikis = await this.getWikiPages({siteID: this.siteID, tags: 'email-template'});
    let wikis = await this.getWikiPages({siteID: this.siteID});
    if(wikis && wikis.length > 0) {
      this.wikiPages = wikis[0] || [];
      // Reviews templates (review-request) never reach a workflow picker: only the Reviews send
      // path can fill their {{review_link}}.
      const pickable = withoutReviewRequestTemplates(wikis[0]);
      for (let i = 0; i < pickable.length; i++) {
        let wiki = pickable[i];
        //console.dir(wiki);
        if(wiki.Tags && wiki.Tags.indexOf('email-template') >= 0) {
          this.emailTemplates.push({
            text: wiki.Name,
            value: wiki.SendgridTemplateID
          });
          if(wiki.Tags.indexOf('form') >= 0) {
            this.formEmailTemplates.push({
              text: wiki.Name,
              value: wiki.SendgridTemplateID
            });
          }
        } else if(wiki.Tags && wiki.Tags.indexOf('sms-template') >= 0) {
          this.smsTemplates.push({
            text: wiki.Name,
            value: wiki.WikiPageID
          });
          if(wiki.Tags.indexOf('form') >= 0) {
            this.formSmsTemplates.push({
              text: wiki.Name,
              value: wiki.WikiPageID
            });
          }
        } else {
          this.wikisWithoutTemplates.push({
            text: wiki.Name,
            value: wiki.WikiPageID
          });
        }
      }

      window.smsTemplates = this.smsTemplates;
      //console.log(`setting window.smsTemplates to ${JSON.stringify(this.smsTemplates, null, 2)}`);
      window.emailTemplates = this.emailTemplates;

      window.formEmailMessageTemplates = this.formEmailTemplates;
      window.formSmsMessageTemplates = this.formSmsTemplates;

      // Legacy aliases (kept for compatibility)
      window.formEmailTemplates = this.formEmailTemplates;
      //console.log(`setting window.formEmailTemplates to ${JSON.stringify(this.formEmailTemplates, null, 2)}`);
      window.formSmsTemplates = this.formSmsTemplates;
      //console.log(`setting window.formSmsTmplates to ${JSON.stringify(this.formSmsTemplates, null, 2)}`);

      window.wikisWithoutTemplates = this.wikisWithoutTemplates || [];
      window.wikiPages = this.wikiPages || [];
      window.websiteFormElements = [
        {
          text: 'patient_status',
          value: 'patient_status'
        }
      ];

      window.websiteFormElementValues = [
        {
          text: 'New',
          value: 'New'
        },
        {
          text: 'Existing',
          value: 'Existing'
        }
      ];
    }

    const formsRes = await this.getForms({ siteID: this.siteID });
    const forms = Array.isArray(formsRes)
      ? formsRes
      : (formsRes && Array.isArray(formsRes.forms) ? formsRes.forms : []);

    window.forms = (forms || []).map(f => ({
      text: f.Name,
      value: f.FormIDForWeb
    }));
    //console.log(`setting window.forms to ${JSON.stringify(_forms, null, 2)}`);

    await this.$store.dispatch('kanban/fetchBoards', {siteID: this.siteID});

    await this.fetchToDos();
    
    // Ensure tags are ready for UI components
    await this.ensureTagsReady();
  },

  data() {
    return {
      flowyText: null,
      workflow: null,
      workflows: [],
      workflowSaved: false,
      workflowName: 'temp1',
      workflowTrigger: null,
      workflowBlocks: null,
      stlTemplate: null,
      selected: null,
      emailToVerify: null,
      emailTemplate: null,
      emailFromName: '',
      emailFrom: null,
      verifiedEmails: [],
      smsFrom: null,
      procCodes: [],
      mailTemplate: null,
      emailTemplates: [],
      smsTemplates: [],
      formEmailTemplates: [],
      formSmsTemplates: [],
      wikisWithoutTemplates: [],
      wikiPages: [],
      // Available tags for tasks
      availableTaskTags: [],
      // Store locally added tags that aren't yet in tasks
      locallyAddedTags: [],
      createFollowupOptions: [
        { value: null, text: "Please select an option" },
        { value: "immediately", text: "Immediately" },
        { value: "1day", text: "After 1 Day" },
        { value: "2days", text: "After 2 Days" },
      ],
      assignTaskOptionSelected: null,
      xFollowupNumber: 0,
      waitForDurationNum: 1,
      waitForTimestamp: new Date(),
      waitForDurationOptions: [
        { value: null, text: "Select Hours, Days or Months" },
        { value: "minutes", text: "Minutes" },
        { value: "hours", text: "Hours" },
        { value: "days", text: "Days" },
        { value: "months", text: "Months" },
      ],
      waitForDurationOptionSelected: null,
      waitUntilOptions: [
        { value: null, text: "Select condition" },
        { value: "3followups", text: "3 Followups are done" },
        { value: "xdaysafter", text: "X days after last followup" },
      ],
      waitUntilConditionOptionSelected: null,
      followupTypeOptions: [
        { value: null, text: "Please select an option" },
        { value: "recall", text: "Recall" },
        { value: "unsched", text: "Unscheduled Tx" },
        { value: "outstanding", text: "Outstanding Claim" },
      ],
      durationDays: null,
      followupDate: null,
      assignTaskDueDate: null,
      datepickerText: "MM/DD/YYYY",
      toothNum: "",
      code: "",
      followupType: "",
      task: "",
      showKanbanAddTaskModal: false,
      showKanbanEditTaskModal: false,
      refreshKey: 0
    };
  },

  methods: {

    ...mapActions("alert", [
      "setDismissSuccessCountDown",
      "setErrored",
      "setMessage",
    ]),
    ...mapActions("workflow", ["createWorkflow", "getWorkflow", "getAllWorkflows", "updateWorkflow", "enableWorkflow"]),
    ...mapActions('wiki', ['getWikiPages']),
    ...mapActions('teamio', ['runQuery']),
    ...mapActions('tasks', ['getTasksForSite', 'getTasksForEmployee']),
    ...mapActions('forms', ['getForms']),
    // NEW: Dedicated method to initialize tag system
    async initializeTagSystem() {
      console.log('WorkflowBuilder: Initializing tag system...');
      
      // Initialize tag tracking arrays
      if (!window.tagSlimSelectInstances) {
        window.tagSlimSelectInstances = [];
      }
      
      // Subscribe to persistent tags FIRST (before any UI components)
      if (this.siteID) {
        try {
          console.log('WorkflowBuilder: Subscribing to task-tags for site:', this.siteID);
          await this.$store.dispatch('tasks/subscribeSiteTaskTags', { 
            siteID: this.siteID 
          });
          console.log('WorkflowBuilder: Successfully subscribed to task-tags');
        } catch (error) {
          console.error('WorkflowBuilder: Error subscribing to task-tags:', error);
          // Set up fallback tag system
          this.setupFallbackTagSystem();
        }
      }
    },

    // NEW: Ensure tags are ready before UI components
    async ensureTagsReady() {
      // Wait for tags to be loaded (with timeout)
      const maxWaitTime = 3000; // 3 seconds max wait
      const checkInterval = 100; // Check every 100ms
      let waitTime = 0;
      
      while (waitTime < maxWaitTime) {
        const tagsLoaded = this.$store.state.tasks.siteTaskTagsLoaded;
        const hasTags = this.$store.state.tasks.siteTaskTags?.length > 0;
        
        if (tagsLoaded || hasTags) {
          break;
        }
        
        await new Promise(resolve => setTimeout(resolve, checkInterval));
        waitTime += checkInterval;
      }
      
      // Force computation of available tags
      this.computedAvailableTags;
      
      // Update any existing tag dropdowns
      if (typeof window.updateAllTagSlimSelects === 'function') {
        window.updateAllTagSlimSelects();
      }
    },

    // NEW: Helper function to safely get selected values from SlimSelect
    safeGetSelected(slimSelectInstance, fallback = []) {
      try {
        if (!slimSelectInstance || typeof slimSelectInstance.getSelected !== 'function') {
          console.warn('SlimSelect instance not properly initialized, returning fallback');
          return fallback;
        }
        return slimSelectInstance.getSelected() || fallback;
      } catch (error) {
        console.error('Error getting selected values from SlimSelect:', error);
        return fallback;
      }
    },

    // NEW: Set up global variables for workflow builder
    setupGlobalVariables() {
      // Set up other global variables that might be needed
      window.siteID = this.siteID;
      window.workflowID = this.workflowID;
      window.timezone = this.allSettings?.GENERAL_TIMEZONE?.PropertyValue || 'America/New_York';
      window.userID = this.userID;
      window.userName = this.user.Name;
    },

    // NEW: Set up employees after they're loaded from API
    setupEmployeesForDropdowns(employeesData) {
      
      if (employeesData && employeesData.length > 0) {
        window.employees = employeesData.map(emp => ({
          text: emp.Name,
          value: emp.EmployeeID,
          html: emp.Name
        }));
        console.log('Set up window.employees with', window.employees.length, 'employees');
        console.log('Formatted employees:', window.employees);
      } else {
        window.employees = [];
        console.log('No employees data available, setting empty array');
      }
    },
    setupFallbackTagSystem() {
      console.log('WorkflowBuilder: Setting up fallback tag system');
      
      // Initialize with empty tags
      this.$store.commit('tasks/setSiteTaskTags', []);
      this.$store.commit('tasks/setSiteTaskTagsLoaded', true);
      
      // Set up window.availableTaskTags
      window.availableTaskTags = [];
      
      console.log('WorkflowBuilder: Fallback tag system ready');
    },

    async init() {
      // STEP 1: Initialize tag system FIRST (before any UI components)
      await this.initializeTagSystem();
      
      this.workflows = await this.getAllWorkflows({siteID: this.siteID});
      window.workflows = this.workflows;

      if(this.workflowID && this.workflows && Array.isArray(this.workflows)) {
        this.workflowSaved = true;
        let w = this.workflows.filter(workflow => workflow.WorkflowID === this.workflowID);
        if(w.length > 0) {
          this.workflow = w[0];
          let temp = JSON.parse(this.workflow.FlowyText);
          window.flowy.import(temp);
          this.workflowTrigger = temp.blocks[0].data[2].value;
          window.workflowTrigger = this.workflowTrigger;
        } else {
          this.$toast.error('Workflow not found! Please try again');
        }
      }

      console.log('init() called');
      console.log('this.siteID:', this.siteID);
      console.log('this.allSettings:', this.allSettings);

      // STEP 2: Set up global variables for workflow builder
      this.setupGlobalVariables();

      // STEP 3: Fetch all the data we need in parallel for better performance
      const dataPromises = [
        this.$store.dispatch('customer/getEmployees', {sqlQuery: CommonQueries.getEmployees(this.siteID)}),
        this.$store.dispatch('customer/getPatients', {siteID: this.siteID}),
        this.$store.dispatch('customer/getProcCodes', {siteID: this.siteID}),
        this.fetchToDos()
      ];

      try {
        const [
          _employees, _patients, _procCodes
        ] = await Promise.all(dataPromises);

        // Set up global variables
        window.employees = _employees;
        console.log('Loaded employees:', _employees?.length || 0, 'employees');
        console.log('Raw employees data:', _employees);
        
        // Set up employees for dropdowns
        this.setupEmployeesForDropdowns(_employees);
        
        window.patients = _patients;
        
        // FIXED: Format procCodes for SlimSelect (needs "text" and "value" fields, not "ProcCode" and "Descript")
        const formattedProcCodes = (_procCodes || []).map(code => ({
          text: `${code.ProcCode} - ${code.Descript}`,
          value: code.CodeNum,
          html: `${code.ProcCode} - ${code.Descript}`
        }));
        window.procCodes = formattedProcCodes;

        console.log('All data loaded successfully');
        
        // STEP 4: Ensure tags are ready for UI components
        await this.ensureTagsReady();
        
      } catch (error) {
        console.error('Error loading workflow data:', error);
        // Continue with partial data rather than failing completely
        await this.ensureTagsReady();
      }

      // Shared five-shape parser — the hand-rolled `.split(',')` handled only the CSV
      // shape and would hand SendGrid a broken address for the JSON shapes.
      this.verifiedEmails = listVerifiedEmails(this.allSettings && this.allSettings.GENERAL_VERIFIED_EMAILS);
      this.smsFrom = this.allSettings && this.allSettings.GENERAL_PHONE ? this.allSettings.GENERAL_PHONE.PropertyValue : '';
      window.smsFrom = this.smsFrom;
    },

    async fetchToDos () {
      try {

        if(
          (this.myCreatedTasks && this.myCreatedTasks.length === 0) ||
          (this.assignedToMeTasks && this.assignedToMeTasks.length === 0) ||
          (this.myEmployeesTasks && this.myEmployeesTasks.length === 0)
        ) {
          if(this.user.Role === 'Super Admin' || this.user.Role === 'Admin' || this.user.Role === 'Outsourced')
            await this.getTasksForSite({siteID: this.siteID, employeeID: this.userID});
          else
            await this.getTasksForEmployee({siteID: this.siteID, employeeID: this.userID});
        }
      } catch (error) {
        console.error('Error fetching tasks:', error);
        this.busy = false;
        this.$toast.error(error.message || 'Failed to load tasks');
      }
    },

    verifyEmail() {
      //console.log(`Now trying to verify email`);
    },

    hideModal(ref) {
      this.$refs[ref].hide()
    },

    getImg(imgUrl) {
      //console.log(`i am called`);
      let img = require(`../assets/img/${imgUrl}`);
      return `<img src="${img}">`;
      //document.getElementById("saumil").innerHTML = html;
    },

    reset() {
      this.showModal('sure-modal-remove-all-blocks');
    },

    runSureOk(confirmFor) {
        switch(confirmFor) {
            case 'REMOVE-ALL-BLOCKS': window.flowy.deleteBlocks();
                                      this.setErrored(false);
                                      break;
            default: break;
        }
    },

    validateAndSave() {
        this.setErrored(false);

        if(window.error) {
          let msg = `Can not save the workflow: ${window.error}`;
          alert(msg);
          return false;
        }

        this.flowyText = window.flowy.output();
        if (!this.verifySmsSerialization(this.flowyText)) {
          return false;
        }
        //console.log(`Flowy output below`);
        //console.dir(this.flowyText);
        if (this.flowyText && this.flowyText.blocks && this.flowyText.blocks.length > 0) {
          this.workflowTrigger = this.flowyText.blocks[0].data[2].value;
          if(!this.workflowTrigger) {
            this.$toast.error('Workflow trigger is not recognized. Please try reloading the page again');
            return false;
          }
          if (this.validate(this.flowyText.blocks)) {
              this.workflowBlocks = this.flowyText.blocks;
              if(!this.workflowID && !this.workflowSaved)
                this.showModal('modal-workflow-save-name');
              else
                this._saveWorkflow();
          }
        }  else {
            this.$toast.error('You do not have any trigger or actions defined for your workflow yet.');
        }
    },

    verifySmsSerialization(flowyOutput) {
      if (!flowyOutput || !Array.isArray(flowyOutput.blocks)) {
        return true;
      }

      const problematicBlocks = [];

      flowyOutput.blocks.forEach(block => {
        if (!block || !block.attr) {
          return;
        }

        const attrMap = (block.attr || []).reduce((acc, entry) => {
          const [key, value] = Object.entries(entry || {})[0] || [];
          if (key) {
            acc[key] = value;
          }
          return acc;
        }, {});

        if (attrMap['data-blocktype'] !== 'sms') {
          return;
        }

        const serialized = attrMap['data-send-sms-properties'];
        let parsedLength = 0;
        let parseError = null;

        if (serialized) {
          try {
            const parsed = JSON.parse(serialized);
            parsedLength = Array.isArray(parsed) ? parsed.length : 0;
          } catch (err) {
            parseError = err.message;
            problematicBlocks.push({
              blockId: block.id,
              uniqueid: attrMap['data-uniqueid'] || null,
              reason: 'parse-error',
              details: err.message
            });
          }
        } else {
          problematicBlocks.push({
            blockId: block.id,
            uniqueid: attrMap['data-uniqueid'] || null,
            reason: 'missing-data'
          });
        }

      });

      if (problematicBlocks.length) {
        if (this.$toast) {
          this.$toast.error('One or more “Send Text Message” blocks have unsaved selections. Please open them and click Save before saving the workflow.');
        }
        return false;
      }

      return true;
    },

    validate(blocks) {
      /*
            1. First element has to be of type trigger
            2. There could be ONLY 1 trigger
            3. Action blocks should be configured
            4. Make sure there isn't already a workflow defined with the same trigger
      */

      //console.log(blocks);

      let firstBlockIsTrigger = blocks[0].data[0].value === "triggers";
      let onlyOneTrigger = blocks.filter((a) => a.data.find((b) => b.value === "triggers")).length === 1;
      let atleastOneAction = blocks.filter((a) => a.data.find((b) => b.value === "actions")).length >= 1;
      let workflowExistsWithSameTrigger = this.workflows && this.workflows.filter(w => w.TriggerOn === window.workflowTrigger).length > 0;

      if (!this.workflowID && workflowExistsWithSameTrigger) {
        this.$toast.error(`You already have a workflow with trigger type ${this.workflowTrigger}. Please click reset to start over and choose another trigger or go back and modify the existing workflow`);
        return false;
      }

      if (firstBlockIsTrigger) {
        if (!onlyOneTrigger) {
          this.$toast.error(
            `You can not have more than one trigger for a workflow`
          );
          return false;
        }
      } else {
        this.$toast.error(`First block has to be a trigger in a workflow`);
        return false;
      }

      if(!atleastOneAction) {
        this.$toast.error(`You need to have atleast one action block for a workflow`);
        return false;
      }

        try {
            this.stlTemplate = AwsStlConverter.convert(blocks);
            //console.log(`Got template: ${JSON.stringify(this.stlTemplate)}`);
        } catch(err) {
            console.log(err);
            let errMsg = "Something went wrong. Please try again";
            switch (err.code) {
                case "BLOCK_TYPE_MISSING":
                    errMsg = `One or more of your blocks are not configured properly. Did you configure each of your action blocks? Make sure to click each one and hit save`;
                    break;
                default:
                    break;
            }
            this.$toast.error(errMsg);
            return false;
        }

      return true;
    },

    /**
    *
    * Changes TriggerOn value from "New Patient" to "NEW_PATIENT" or "Appointment Completed" to "APPOINTMENT_COMPLETED"
    */

   /*
    normalizeTriggerType(trigger) {
      let capitalized = trigger.toUpperCase();
      return capitalized.replace(' ', '_');
    },
    */

    isValidWorkflowName(str) {
      // Regular expression to match invalid characters
      const invalidChars = /[\s<>{}\[\]?*"#$%\\^|~`$&,:;/\u0000-\u001F\u007F-\u009F]/;

      // Test the string against the regular expression
      return !invalidChars.test(str);
    },

    async _saveWorkflow(e) {

      // Make sure no spaces in the workflow name
      //this.workflowName = this.workflowName.replace(/\s+/g, '-');

      if(this.workflowName.length > 44) {
        this.$toast.error("Workflow Name is Too Long. Please try again");
        return false;
      }

      if(!this.isValidWorkflowName(this.workflowName)) {
        this.$toast.error("Invalid Workflow Name: Workflow name can not have white space, brackets or any special characters except dashes");
        return false;
      }

      let payload = {
        ...(this.workflowID && { WorkflowID: this.workflowID }),
        ...(this.workflow && this.workflow.AWSStateMachineArn && { AWSStateMachineArn : this.workflow.AWSStateMachineArn }),
        SiteID: this.siteID,
        Name: this.workflowName,
        FlowyText: JSON.stringify(this.flowyText),
        JsonText: JSON.stringify(this.stlTemplate),
        TriggerOn: window.workflowTrigger,
        CreatedByEmpID: this.userID,
        CreatedOn: moment().format("YYYY-MM-DD")
      };

      console.dir(payload);
      console.dir(this.stlTemplate);

      if(!this.workflowID) {
        if(!this.workflowName) {
            this.$toast.error('Please enter a name for your Workflow first');
            return false;
        }

        // Check to make sure workflow name is not already taken
        if(this.workflows.filter(a => a.Name === this.workflowName).length > 0) {
            this.$toast.error('You already have a workflow with this name. Please try again');
            return false;
        }

        try {
          let res = await this.createWorkflow(payload);
          //console.log(`Response: ${JSON.stringify(res)}`);
          if(res.status === 200) {
            this.workflowID = res.data;
            this.workflowSaved = true;
            if(this.workflowTriggers && this.workflowTriggers.length > 0) {
              this.workflowTriggers.push(window.workflowTrigger);
              this.setWorkflowTrigger(this.workflowTriggers);
            }
          } else {
            let errMsg = "Something went wrong. Please try again";
            this.$toast.error(errMsg);
          }
        } catch (err) {
          console.log(err);
          console.log(JSON.stringify(err));
          let errMsg = "Something went wrong. Please try again";
          switch (err.code) {
              case "BLOCK_TYPE_MISSING":
                  errMsg = `One or more of your blocks are not configured properly. Did you configure each of your action blocks? Make sure to click each one and hit save`;
                  break;
              default:
                  break;
          }
          this.$toast.error(errMsg);
        }

      } else {
        // this means we're trying trying to update an existing workflow
        //console.log(`Trying to Update workflow now. Payload: ${JSON.stringify(payload)}`);

        try {
          let res = await this.updateWorkflow(payload);
          //console.log(res);
        } catch(err) {
          let errMsg = "Something went wrong. Please try again";
          switch (err.code) {
              case "BLOCK_TYPE_MISSING":
                  errMsg = `One or more of your blocks are not configured properly. Did you configure each of your action blocks? Make sure to click each one and hit save`;
                  break;
              default:
                  break;
          }
          this.$toast.error(errMsg);
        }
      }
    },

    async activate(e) {
      if(!this.workflowSaved || !this.workflowID || this.workflowID === '') {
        this.$toast.error('Something went wrong. Please try refreshing the page and then try to activate the workflow again');
        return false;
      }

      try {
        await this.enableWorkflow({WorkflowID: this.workflowID});
        this.workflow.Active = 1;
      } catch(err) {
        console.log(`Caught error while trying to activate workflow: ${JSON.stringify(err, null, 4)}`);
      }
    },

    getColumnsByFbboardId(fbboardId) {
      console.log('fbboards', this.fbboards);
      const fbboard = this.fbboards.find(board => board.id === fbboardId);
      console.log('in getColumnsByFbboardId, fbboard', fbboard);
      if (fbboard) {
        return fbboard.columns;
      } else {
        return null; // or throw an error, depending on your use case
      }
    },

    getCardsByFbboardIdAndColumnId(fbboardId, columnId) {
      console.log(`fbboardId: ${fbboardId}, columnId: ${columnId}`);
      const fbboard = this.fbboards.find(board => board.id === fbboardId);
      if (fbboard) {
        const column = fbboard.columns.find(col => col.id === columnId);
        console.log('column', column);
        if (column) {
          return column.tasks;
        } else {
          return null; // or throw an error, depending on your use case
        }
      } else {
        return null; // or throw an error, depending on your use case
      }
    },

    afterChange(newValue) {
      console.log('afterChange called', newValue);
    },

    // Feature request event handlers
    onFeatureRequestSent(featureName) {
      this.$toast.success(`${featureName} request sent successfully! Our team will contact you soon to configure this feature.`);
    },

    onFeatureRequestError(error) {
      this.$toast.error(`Failed to send request: ${error.message || 'Please try again or contact support directly.'}`);
    },

    // Helper method to get columns by board ID
    getColumnsByBoardId(boardId) {
      try {
        // Access Kanban boards from Vuex store
        const board = this.fbboards?.find(b => b.id === boardId);
        return board ? board.columns || [] : [];
      } catch (error) {
        console.error('Error getting columns by board ID:', error);
        return [];
      }
    },

    // Helper method to get cards by board ID and column ID
    getCardsByFbboardIdAndColumnId(boardId, columnId) {
      try {
        // Access Kanban boards from Vuex store
        const board = this.fbboards?.find(b => b.id === boardId);
        if (!board) return [];
        
        const column = board.columns?.find(c => c.id === columnId);
        return column ? column.tasks || [] : [];
      } catch (error) {
        console.error('Error getting cards by board and column ID:', error);
        return [];
      }
    }

  },

  computed: {

    ...mapState({
      fbboards: state => state.kanban.boards,
      myCreatedTasks: state => state.tasks.myCreatedTasks,
      assignedToMeTasks: state => state.tasks.assignedToMeTasks,
      myEmployeesTasks: state => state.tasks.myEmployeesTasks,
      tasksLoaded: state => state.tasks.tasksLoaded,
    }),

    ...mapGetters({
      'getBoard' : 'kanban/getBoard',
    }),

    boardOptions() {
      if (this.fbboards && this.fbboards.length > 0) {
         return [
         {
          placeholder: true,
          text: 'Select board',
        },
        ...this.fbboards.map(board => ({
            value: board.id,
            text: board.name,
            html: board.name,
          }))
        ]
      } else return [];
    },

    allowActivate() {
      if(this.workflow) {
        if(this.workflow.Active && this.workflow.Active === 1)
          return false;
        else
          return true;
      } else {
        if(this.workflowID && this.workflowSaved)
          return true;
        else
          return false;
      }
    },

    waitForOptions() {
      let ret = [];
      for (let i = 1; i <= 365; i++) {
        ret.push(i);
      }
      return ret;
    },

    activeEmployees() {
      if(this.employees) {
        return this.employees.filter(e => e.Active === 1);
      } else
        return [];
    },

    allTasks() {
      return [
        ...(this.myCreatedTasks || []),
        ...(this.assignedToMeTasks || []),
        ...(this.myEmployeesTasks || [])
      ];
    },

    // Feature availability checks for SMS and Email workflow actions
    // The SMS step is usable only where an SMS may be SENT (siteCapability.isSmsEnabled) —
    // a WhatsApp-only office has a number but outbound SMS is off, so its notice explains
    // that instead of offering to set texting up.
    smsFeatureEnabled() {
      return isSmsEnabled(this.allSettings);
    },
    smsOutboundOff() {
      return hasSmsNumber(this.allSettings) && !isSmsEnabled(this.allSettings);
    },
    smsDisabledMessage() {
      return SMS_DISABLED_MESSAGE;
    },

    emailFeatureEnabled() {
      // Derived email capability via the shared five-shape parser — identical to the
      // old naive `.trim() !== ''` for bare-string prod values, but correctly reports
      // disabled for senderless shapes like "[]"/"{}". See src/utils/siteCapability.js.
      return isEmailEnabled(this.allSettings);
    },

    computedAvailableTags() {
      // PRIORITY 1: Get persistent tags from task-tags collection (Firestore)
      const persistentTags = this.$store.state.tasks.siteTaskTags || [];
      
      // PRIORITY 2: Get tags from currently loaded tasks (backwards compatibility)
      const taskTags = new Set();
      if (this.allTasks) {
        const tasks = this.allTasks || [];
        tasks.forEach(task => {
          if (Array.isArray(task.tags)) {
            task.tags.forEach(tag => {
              if (typeof tag === 'string' && tag.trim() !== '') {
                taskTags.add(tag.trim());
              }
            });
          }
        });
      }
      
      // PRIORITY 3: Get locally added tags (current session only - for backwards compatibility)
      const localTags = new Set();
      if (Array.isArray(this.locallyAddedTags)) {
        this.locallyAddedTags.forEach(tag => {
          if (typeof tag === 'string' && tag.trim() !== '') {
            localTags.add(tag.trim());
          }
        });
      }
      
      // PRIORITY 4: Extract tags from workflow builder DOM blocks (existing workflows)
      const workflowBlockTags = new Set();
      try {
        // Find all blocks with assign-task-properties data attributes
        const blocks = document.querySelectorAll('[data-assign-task-properties]');
        blocks.forEach(block => {
          try {
            const propertiesJson = block.getAttribute('data-assign-task-properties');
            if (propertiesJson) {
              const properties = JSON.parse(propertiesJson);
              if (Array.isArray(properties)) {
                properties.forEach(prop => {
                  // Handle both legacy 'tag' (string) and new 'tags' (array)
                  if (prop.tags && Array.isArray(prop.tags)) {
                    prop.tags.forEach(tag => {
                      if (typeof tag === 'string' && tag.trim() !== '') {
                        workflowBlockTags.add(tag.trim());
                      }
                    });
                  } else if (prop.tag && typeof prop.tag === 'string' && prop.tag.trim() !== '') {
                    workflowBlockTags.add(prop.tag.trim());
                  }
                });
              }
            }
          } catch (e) {
            console.error('Error parsing task properties for tags:', e);
          }
        });

        // Also look for properties with dynamic IDs (data-assign-task-properties-XXXX)
        const allElements = document.querySelectorAll('*');
        allElements.forEach(el => {
          const attributes = el.attributes;
          for (let i = 0; i < attributes.length; i++) {
            const attr = attributes[i];
            if (attr.name.startsWith('data-assign-task-properties-')) {
              try {
                const properties = JSON.parse(attr.value);
                if (Array.isArray(properties)) {
                  properties.forEach(prop => {
                    // Handle both legacy 'tag' (string) and new 'tags' (array)
                    if (prop.tags && Array.isArray(prop.tags)) {
                      prop.tags.forEach(tag => {
                        if (typeof tag === 'string' && tag.trim() !== '') {
                          workflowBlockTags.add(tag.trim());
                        }
                      });
                    } else if (prop.tag && typeof prop.tag === 'string' && prop.tag.trim() !== '') {
                      workflowBlockTags.add(prop.tag.trim());
                    }
                  });
                }
              } catch (e) {
                console.error(`Error parsing task properties for tags from ${attr.name}:`, e);
              }
            }
          }
        });
      } catch (e) {
        console.error('Error extracting tags from workflow builder:', e);
      }
      
      // MERGE ALL SOURCES: Persistent tags take priority, then add others
      const allTags = new Set([
        ...persistentTags,           // Priority 1: Persistent tags
        ...Array.from(taskTags),     // Priority 2: Task tags
        ...Array.from(localTags),    // Priority 3: Local tags
        ...Array.from(workflowBlockTags) // Priority 4: Workflow block tags
      ]);
      
      const uniqueTags = Array.from(allTags).sort();
      
      // Update window.availableTaskTags for SlimSelect
      window.availableTaskTags = uniqueTags.map(tag => ({ value: tag, text: tag }));
      
      return uniqueTags;
    }
  },

  watch: {
    allSettings(newValue, oldValue) {
      if(!oldValue) {
        this.init();
      }
    },

    allTasks(newValue, oldValue) {
      this.computedAvailableTags;
    },
    
    // NEW: Watch for persistent tags changes from Firestore
    '$store.state.tasks.siteTaskTags': {
      handler(newTags, oldTags) {
        
        // Trigger recomputation of available tags
        this.computedAvailableTags;
        
        // Update all SlimSelect instances with new tags
        if (window.updateAllTagSlimSelects) {
          window.updateAllTagSlimSelects();
        }
      },
      deep: true
    }
  },

  beforeDestroy() {
    // Remove workflow-page class from body when leaving the component
    document.body.classList.remove('workflow-page');
    
    // NEW: Unsubscribe from tags listener
    console.log('WorkflowBuilder: Unsubscribing from task-tags');
    this.$store.dispatch('tasks/unsubscribeSiteTaskTags');
    
    // Clean up dropdown positioning observer
    if (this._dropdownObserver) {
      this._dropdownObserver.disconnect();
      console.log('✅ SlimSelect dropdown observer disconnected');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .custom-checkbox {
    padding-left: 1.5rem !important;
  }

  #header2 {
    margin-top: 0;
    margin-bottom: 0;
  }

  /* ==========================================
     Feature Not Enabled Notice Styles (Prominent)
     ========================================== */
  .workflow-feature-notice {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    margin: 0 -40px 24px -40px;
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    border-bottom: 2px solid #93c5fd;
    border-top: 1px solid #bfdbfe;
  }

  .workflow-feature-notice .notice-icon-container {
    width: 44px;
    height: 44px;
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  }

  .workflow-feature-notice .notice-icon {
    color: white;
    font-size: 20px;
  }

  .workflow-feature-notice .notice-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .workflow-feature-notice .notice-title {
    font-size: 15px;
    font-weight: 700;
    color: #1e40af;
    letter-spacing: -0.01em;
  }

  .workflow-feature-notice .notice-text {
    color: #3b82f6;
    font-size: 13px;
    font-weight: 500;
  }

  .workflow-feature-notice .notice-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    color: white;
    font-weight: 600;
    font-size: 13px;
    border-radius: 8px;
    text-decoration: none;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
    transition: all 0.2s ease;
  }

  .workflow-feature-notice .notice-button:hover {
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
    color: white;
    text-decoration: none;
  }

  .workflow-feature-notice .notice-button i {
    font-size: 12px;
  }


  /* Disabled overlay for form controls when feature not enabled */
  .feature-disabled-overlay {
    position: relative;
    opacity: 0.6;
    pointer-events: none;
    user-select: none;
  }

  .feature-disabled-overlay::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 10px,
      rgba(0, 0, 0, 0.03) 10px,
      rgba(0, 0, 0, 0.03) 20px
    );
    z-index: 1;
    pointer-events: none;
    border-radius: 8px;
  }

  .feature-disabled-overlay * {
    cursor: not-allowed !important;
  }

  /* ==========================================
     Send Form Properties - Enhanced Styling
     ========================================== */
  #sendformwrap #sendformproperties {
    padding: 40px !important;
  }

  /* Checkbox section at top - clean card style */
  #send-form-properties > .form-group:first-child {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 20px 24px;
    margin-bottom: 32px;
  }

  #send-form-properties > .form-group:first-child .section-label {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
    cursor: pointer;
    margin-bottom: 6px;
  }

  #send-form-properties > .form-group:first-child .section-label input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin-right: 12px;
    accent-color: #3b82f6;
    cursor: pointer;
  }

  #send-form-properties > .form-group:first-child .form-text {
    margin-left: 30px;
    font-size: 13px;
    color: #64748b;
  }

  /* Table styling for Send Form */
  #send-form-proc-table {
    width: 100% !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
    margin-top: 8px;
  }

  #send-form-proc-table thead th {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
    color: #374151 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    padding: 14px 12px !important;
    border-bottom: 2px solid #e5e7eb !important;
    text-align: left !important;
  }

  #send-form-proc-table tbody tr {
    background: #ffffff !important;
    transition: background-color 0.15s ease !important;
  }

  #send-form-proc-table tbody tr:hover {
    background: #f9fafb !important;
  }

  #send-form-proc-table tbody td {
    padding: 16px 12px !important;
    border-bottom: 1px solid #f1f5f9 !important;
    vertical-align: middle !important;
  }

  /* Better column widths for Send Form table */
  #send-form-proc-table thead th:nth-child(1),
  #send-form-proc-table tbody td:nth-child(1) {
    width: 25% !important;
  }

  #send-form-proc-table thead th:nth-child(2),
  #send-form-proc-table tbody td:nth-child(2) {
    width: 25% !important;
  }

  #send-form-proc-table thead th:nth-child(3),
  #send-form-proc-table tbody td:nth-child(3) {
    width: 15% !important;
  }

  #send-form-proc-table thead th:nth-child(4),
  #send-form-proc-table tbody td:nth-child(4) {
    width: 30% !important;
  }

  #send-form-proc-table thead th:nth-child(5),
  #send-form-proc-table tbody td:nth-child(5) {
    width: 5% !important;
  }

  /* Style the "Add more" link for Send Form */
  #addMoreCodesForSendForm {
    display: inline-flex;
    align-items: center;
    padding: 10px 20px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    color: #3b82f6;
    text-decoration: none;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;
    margin-top: 16px;
  }

  #addMoreCodesForSendForm:hover {
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    border-color: #93c5fd;
    color: #2563eb;
    text-decoration: none;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
  }

  #addMoreCodesForSendForm::before {
    content: '+';
    margin-right: 8px;
    font-weight: 700;
    font-size: 16px;
  }

  /* Remove old margin/padding from proccode properties container */
  #send-form-proccode-properties {
    margin-left: 0 !important;
    margin-top: 0 !important;
  }

  /* ==========================================
     Assign Task Properties - Enhanced Styling
     ========================================== */
  #assigntaskwrap #assigntaskproperties {
    padding: 40px !important;
  }

  /* Table styling for Assign Task */
  #assign-task-proc-table {
    width: 100% !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
    margin-top: 8px;
  }

  #assign-task-proc-table thead th {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
    color: #374151 !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    padding: 14px 10px !important;
    border-bottom: 2px solid #e5e7eb !important;
    text-align: left !important;
    white-space: nowrap !important;
  }

  #assign-task-proc-table tbody tr {
    background: #ffffff !important;
    transition: background-color 0.15s ease !important;
  }

  #assign-task-proc-table tbody tr:hover {
    background: #f9fafb !important;
  }

  #assign-task-proc-table tbody td {
    padding: 12px 8px !important;
    border-bottom: 1px solid #f1f5f9 !important;
    vertical-align: middle !important;
  }

  /* Optimized column widths for Assign Task table - give more space to Task Description */
  #assign-task-proc-table thead th:nth-child(1),
  #assign-task-proc-table tbody td:nth-child(1) {
    width: 16% !important; /* If Proc Code matches */
  }

  #assign-task-proc-table thead th:nth-child(2),
  #assign-task-proc-table tbody td:nth-child(2) {
    width: 14% !important; /* Assign Task To */
  }

  #assign-task-proc-table thead th:nth-child(3),
  #assign-task-proc-table tbody td:nth-child(3) {
    width: 22% !important; /* Task Description - WIDER */
    min-width: 180px !important;
  }

  #assign-task-proc-table thead th:nth-child(4),
  #assign-task-proc-table tbody td:nth-child(4) {
    width: 18% !important; /* Task Due Date */
  }

  #assign-task-proc-table thead th:nth-child(5),
  #assign-task-proc-table tbody td:nth-child(5) {
    width: 14% !important; /* Attach Wiki */
  }

  #assign-task-proc-table thead th:nth-child(6),
  #assign-task-proc-table tbody td:nth-child(6) {
    width: 12% !important; /* Tags */
  }

  #assign-task-proc-table thead th:nth-child(7),
  #assign-task-proc-table tbody td:nth-child(7) {
    width: 4% !important; /* Delete button */
  }

  /* Task Description textarea styling - ensure proper height for 2+ lines */
  textarea.task-description-textarea,
  textarea.workflowTextbox.task-description-textarea {
    width: 100% !important;
    min-height: 56px !important;
    height: auto !important;
    max-height: 200px !important;
    padding: 8px 10px !important;
    font-size: 13px !important;
    line-height: 1.4 !important;
    border: 1px solid #d1d5db !important;
    border-radius: 6px !important;
    resize: vertical !important;
    font-family: inherit !important;
    background: #ffffff !important;
    transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
    box-sizing: border-box !important;
    overflow-y: auto !important;
  }

  .task-description-textarea:focus {
    outline: none !important;
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  }

  .task-description-textarea::placeholder {
    color: #9ca3af !important;
    font-style: italic !important;
  }

  #assign-task-proc-table tbody td:nth-child(3),
  #assign-task-website-form-table tbody td:nth-child(4) {
    vertical-align: top !important;
  }

  /* Website Form Submission table - same treatment */
  #assign-task-website-form-table {
    width: 100% !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
    margin-top: 8px;
  }

  #assign-task-website-form-table thead th {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
    color: #374151 !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    padding: 14px 10px !important;
    border-bottom: 2px solid #e5e7eb !important;
    text-align: left !important;
    white-space: nowrap !important;
  }

  #assign-task-website-form-table tbody tr {
    background: #ffffff !important;
    transition: background-color 0.15s ease !important;
  }

  #assign-task-website-form-table tbody tr:hover {
    background: #f9fafb !important;
  }

  #assign-task-website-form-table tbody td {
    padding: 12px 8px !important;
    border-bottom: 1px solid #f1f5f9 !important;
    vertical-align: middle !important;
  }

  /* Optimized column widths for Website Form table */
  #assign-task-website-form-table thead th:nth-child(1),
  #assign-task-website-form-table tbody td:nth-child(1) {
    width: 10% !important; /* If Form Element */
  }

  #assign-task-website-form-table thead th:nth-child(2),
  #assign-task-website-form-table tbody td:nth-child(2) {
    width: 10% !important; /* Matches */
  }

  #assign-task-website-form-table thead th:nth-child(3),
  #assign-task-website-form-table tbody td:nth-child(3) {
    width: 14% !important; /* Assign Task To */
  }

  #assign-task-website-form-table thead th:nth-child(4),
  #assign-task-website-form-table tbody td:nth-child(4) {
    width: 20% !important; /* Task Description - WIDER */
    min-width: 160px !important;
  }

  #assign-task-website-form-table thead th:nth-child(5),
  #assign-task-website-form-table tbody td:nth-child(5) {
    width: 16% !important; /* Task Due Date */
  }

  #assign-task-website-form-table thead th:nth-child(6),
  #assign-task-website-form-table tbody td:nth-child(6) {
    width: 14% !important; /* Attach Wiki */
  }

  #assign-task-website-form-table thead th:nth-child(7),
  #assign-task-website-form-table tbody td:nth-child(7) {
    width: 10% !important; /* Tags */
  }

  #assign-task-website-form-table thead th:nth-child(8),
  #assign-task-website-form-table tbody td:nth-child(8) {
    width: 6% !important; /* Delete button */
  }

  /* Ensure other table cells align properly with taller task description */
  #assign-task-proc-table tbody td,
  #assign-task-website-form-table tbody td {
    vertical-align: top !important;
  }

  /* Style the "Add more" link for Assign Task */
  #addMoreCodesForAssignTask,
  #addMoreCodesForAssignTaskWebform {
    display: inline-flex;
    align-items: center;
    padding: 10px 20px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    color: #3b82f6;
    text-decoration: none;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;
    margin-top: 16px;
    margin-left: 0 !important;
  }

  #addMoreCodesForAssignTask:hover,
  #addMoreCodesForAssignTaskWebform:hover {
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    border-color: #93c5fd;
    color: #2563eb;
    text-decoration: none;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.15);
  }

  #addMoreCodesForAssignTask::before,
  #addMoreCodesForAssignTaskWebform::before {
    content: '+';
    margin-right: 8px;
    font-weight: 700;
    font-size: 16px;
  }

  /* Remove old margin from proccode properties container */
  #assign-task-proccode-properties {
    margin-left: 0 !important;
    margin-top: 0 !important;
  }

  /* Section header for Website Form Properties */
  #assign-task-website-form-properties #header3 {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #374151 !important;
    margin-top: 40px !important;
    margin-bottom: 16px !important;
    padding-bottom: 12px !important;
    border-bottom: 2px solid #e5e7eb !important;
  }

  /* Style the save buttons when disabled */
  .feature-disabled-overlay ~ .save-button-container .saveblock {
    opacity: 0.5;
    cursor: not-allowed !important;
    pointer-events: none;
  }

  /* Workflow Feature Request Styling */
  .workflow-feature-request {
    padding: 1.5rem;
    background: linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%);
    border: 2px solid #fc8181;
    border-radius: 8px;
    margin: 1rem 0;
  }

  .workflow-feature-request .feature-request-container {
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
  }

  .workflow-feature-request .feature-request-header {
    margin-bottom: 1.5rem;
  }

  .workflow-feature-request .feature-request-header .feature-icon {
    font-size: 2.5rem;
    color: #e53e3e;
    margin-bottom: 0.75rem;
    display: block;
  }

  .workflow-feature-request .feature-request-header h4 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 0.5rem;
  }

  .workflow-feature-request .feature-request-header .feature-description {
    font-size: 0.95rem;
    color: #4a5568;
    line-height: 1.5;
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    .workflow-feature-request {
      padding: 1rem;
      margin: 0.5rem 0;
    }
    
    .workflow-feature-request .feature-request-header .feature-icon {
      font-size: 2rem;
    }
    
    .workflow-feature-request .feature-request-header h4 {
      font-size: 1.1rem;
    }
    
    .workflow-feature-request .feature-request-header .feature-description {
      font-size: 0.9rem;
    }
  }

  /* Fix for left sidebar layout */
  #leftcard {
    width: 363px !important;
    overflow: visible !important;
  }

  #blocklist {
    width: 100% !important;
    overflow-x: visible !important;
    overflow-y: auto !important;
  }

  .blockelem {
    width: 318px !important;
    max-width: 318px !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  }

  .blockelem .blocktext {
    width: 100% !important;
    overflow: visible !important;
    white-space: normal !important;
  }

  .blocktitle {
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    line-height: 1.4 !important;
  }

  .blocktext p {
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-wrap: break-word !important;
  }

  .blockdescription {
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    font-size: 12px !important;
    line-height: 1.3 !important;
  }

  /* Properties Panel Improvements - Extra Wide for Complex Forms */
  .blockpropswrap {
    width: calc(100vw - 320px) !important; /* Even wider - closer to left sidebar */
    max-width: 1200px !important; /* Much larger maximum width */
    min-width: 800px !important; /* Larger minimum width */
  }

  .blockprops {
    width: calc(100vw - 320px) !important; /* Even wider - closer to left sidebar */
    max-width: 1200px !important; /* Much larger maximum width */
    min-width: 800px !important; /* Larger minimum width */
    right: calc(-100vw + 320px) !important; /* Adjust positioning for slide-in */
  }

  .blockprops.expanded {
    right: 0px !important;
  }

  /* Improved form styling for Properties Panels */
  .blockprops {
    padding: 40px !important;
  }

  /* Better spacing for form groups */
  .blockprops .form-group {
    margin-bottom: 24px !important;
  }

  .blockprops .form-group:last-child {
    margin-bottom: 0 !important;
  }

  /* Improved label styling */
  .blockprops label {
    font-weight: 600 !important;
    color: #374151 !important;
    margin-bottom: 8px !important;
    display: block !important;
    font-size: 14px !important;
  }

  /* Better form control spacing */
  .blockprops .form-control,
  .blockprops select,
  .blockprops input {
    margin-bottom: 0 !important;
    height: 42px !important;
    font-size: 14px !important;
    padding: 10px 14px !important;
  }

  /* Multi-select and complex inputs */
  .blockprops .form-control.multi-select {
    height: auto !important;
    min-height: 42px !important;
  }

  /* Table-like form layouts for complex properties */
  .form-table {
    display: table;
    width: 100%;
    border-spacing: 0 12px;
  }

  .form-table-row {
    display: table-row;
  }

  .form-table-cell {
    display: table-cell;
    vertical-align: top;
    padding-right: 16px;
  }

  .form-table-cell:last-child {
    padding-right: 0;
  }

  /* Compact form layout for dense information */
  .form-compact .form-group {
    margin-bottom: 16px !important;
  }

  .form-compact label {
    margin-bottom: 4px !important;
    font-size: 13px !important;
  }

  .form-compact .form-control {
    height: 36px !important;
    font-size: 13px !important;
    padding: 8px 12px !important;
  }

  /* Multi-column layout for wider panels */
  #proplist {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  /* For wider panels, we can use grid layout for complex forms */
  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: start;
    margin-top: 24px;
    margin-bottom: 32px;
  }

  /* Three column layout for very complex forms */
  .form-grid-three {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 24px;
    align-items: start;
  }

  /* Four column layout for maximum density */
  .form-grid-four {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;
    align-items: start;
  }

  .form-grid-full {
    grid-column: 1 / -1;
  }

  /* Responsive grid adjustments */
  @media (max-width: 1400px) {
    .form-grid-four {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (max-width: 1200px) {
    .form-grid-three,
    .form-grid-four {
      grid-template-columns: 1fr 1fr;
    }
  }

  /* Make sidebar take full width and height - expand to fill available space */
  .blockpropswrap {
    width: calc(100vw - 280px) !important; /* Even wider - leave just space for left sidebar */
    height: calc(100vh - 80px) !important; /* Take up most of the screen height */
    max-width: none !important;
    max-height: none !important;
    right: 0 !important;
    left: auto !important;
    top: 72px !important; /* Position from top, accounting for navigation */
    overflow: visible !important; /* Allow dropdowns to escape */
  }

  .blockprops {
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    max-height: none !important;
    padding: 40px !important;
    padding-bottom: 100px !important; /* Extra padding at bottom for dropdowns */
    overflow-y: auto !important; /* Allow scrolling if content is too tall */
    overflow-x: visible !important; /* Allow horizontal overflow for dropdowns */
  }

  /* Enhanced header styling - prominent but clean */
  /* Target both static and dynamic IDs */
  .blockpropswrap .blockprops #header2,
  .blockpropswrap .blockprops p[id^="header2-"],
  #waitwrap #waitproperties #header2,
  #waitwrap #waitproperties p[id^="header2-"],
  div.blockprops p#header2,
  div.blockprops p[id^="header2-"],
  #waitproperties #header2,
  #waitproperties p[id^="header2-"] {
    font-size: 28px !important;
    font-weight: 700 !important;
    color: #ffffff !important;
    margin-bottom: 32px !important;
    padding: 24px 20px !important;
    border-bottom: none !important;
    text-align: center !important;
    background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
    margin: -40px -40px 32px -40px !important;
    position: relative !important;
    border-radius: 0 !important;
    margin-top: -40px !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
    letter-spacing: 0.5px !important;
    border-top: 4px solid #1d4ed8 !important;
  }

  /* Remove all animations and pseudo-elements */
  .blockpropswrap .blockprops #header2::before,
  .blockpropswrap .blockprops p[id^="header2-"]::before,
  #waitwrap #waitproperties #header2::before,
  #waitwrap #waitproperties p[id^="header2-"]::before,
  div.blockprops p#header2::before,
  div.blockprops p[id^="header2-"]::before,
  #waitproperties #header2::before,
  #waitproperties p[id^="header2-"]::before {
    display: none !important;
  }

  .blockpropswrap .blockprops #header2::after,
  .blockpropswrap .blockprops p[id^="header2-"]::after,
  #waitwrap #waitproperties #header2::after,
  #waitwrap #waitproperties p[id^="header2-"]::after,
  div.blockprops p#header2::after,
  div.blockprops p[id^="header2-"]::after,
  #waitproperties #header2::after,
  #waitproperties p[id^="header2-"]::after {
    display: none !important;
  }

  #wait-properties .form-group {
    margin-bottom: 32px;
  }

  #wait-properties .form-group:last-child {
    margin-bottom: 0;
  }

  #wait-properties .section-label {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #374151 !important;
    margin-bottom: 16px !important;
    display: block !important;
    text-transform: none !important;
  }

  #wait-properties .form-group label:not(.section-label) {
    font-weight: 600;
    color: #374151;
    margin-bottom: 12px;
    display: block;
    font-size: 14px;
  }

  #wait-properties .radio-group {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
  }

  #wait-properties .radio-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-left: 12px;
  }

  #wait-properties .radio-content strong {
    font-size: 16px;
    color: #1f2937;
    font-weight: 600;
  }

  #wait-properties .radio-content small {
    font-size: 14px;
    color: #6b7280;
    font-weight: normal;
    line-height: 1.4;
  }

  /* Style "Add more" links in property panels instead of hiding them */
  .blockprops a[id*="addMore"],
  .blockprops a[href="#"] {
    color: #3b82f6 !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    text-decoration: none !important;
    margin-top: 8px !important;
    display: inline-block !important;
    position: relative !important;
    z-index: 9999 !important;
    pointer-events: auto !important;
    cursor: pointer !important;
    padding: 8px 12px !important;
    background: rgba(59, 130, 246, 0.1) !important;
    border-radius: 6px !important;
    border: 1px solid rgba(59, 130, 246, 0.3) !important;
    transition: all 0.2s ease-in-out !important;
  }

  .blockprops a[id*="addMore"]:hover,
  .blockprops a[href="#"]:hover {
    color: #ffffff !important;
    background: #3b82f6 !important;
    border-color: #3b82f6 !important;
    text-decoration: none !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3) !important;
  }

  /* Ensure the parent containers don't interfere with click events */
  .blockprops {
    position: relative !important;
  }

  .blockprops * {
    pointer-events: auto !important;
  }

  /* Improve table spacing in property panels */
  .blockprops table {
    border-collapse: separate !important;
    border-spacing: 0 8px !important;
    margin-top: 16px !important;
  }

  .blockprops table th {
    padding: 12px 8px !important;
    background-color: #f8fafc !important;
    border-bottom: 2px solid #e2e8f0 !important;
    font-weight: 600 !important;
    color: #374151 !important;
    font-size: 14px !important;
  }

  .blockprops table td {
    padding: 12px 8px !important;
    border-bottom: 1px solid #e5e7eb !important;
    vertical-align: top !important;
  }

  .blockprops table tr:hover {
    background-color: #f9fafb !important;
  }

  /* Improve form spacing in table layouts */
  .blockprops table select,
  .blockprops table input,
  .blockprops table textarea {
    width: 100% !important;
    min-height: 36px !important;
    padding: 8px 12px !important;
    border: 1px solid #d1d5db !important;
    border-radius: 6px !important;
    font-size: 14px !important;
  }

  .blockprops table select:focus,
  .blockprops table input:focus,
  .blockprops table textarea:focus {
    outline: none !important;
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  }

  /* Enhanced Kanban Properties styling - full width layout */
  .blockprops .form-row,
  .blockprops .row {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr !important; /* 5 columns for more space */
    gap: 20px !important;
    margin-bottom: 24px !important;
    align-items: start !important;
    width: 100% !important;
  }

  /* Make dropdowns use full available width */
  .blockprops .form-group {
    width: 100% !important;
  }

  .blockprops .form-group,
  .blockprops .col-md-3,
  .blockprops .col-sm-3 {
    margin-bottom: 20px !important;
  }

  .blockprops .form-group label {
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #374151 !important;
    margin-bottom: 8px !important;
    display: block !important;
  }

  .blockprops select,
  .blockprops input[type="text"],
  .blockprops input[type="email"],
  .blockprops textarea {
    width: 100% !important;
    padding: 10px 12px !important;
    border: 1px solid #d1d5db !important;
    border-radius: 6px !important;
    font-size: 14px !important;
    background: #ffffff !important;
    transition: all 0.2s ease !important;
  }

  .blockprops select:focus,
  .blockprops input:focus,
  .blockprops textarea:focus {
    outline: none !important;
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  }

  /* Special styling for multi-select elements */
  .blockprops select[multiple] {
    min-height: 80px !important;
    padding: 8px !important;
  }

  .blockprops select[multiple] option {
    padding: 6px 8px !important;
    margin-bottom: 2px !important;
    border-radius: 4px !important;
  }

  .blockprops select[multiple] option:checked {
    background: #3b82f6 !important;
    color: white !important;
  }

  /* Duplicate styles removed - consolidated above */

  /* Wait Block - Coming Soon Feature Styling */
  .blockprops .wait-option-container.disabled-container {
    opacity: 0.8;
    cursor: not-allowed;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
    border: 2px dashed #cbd5e1 !important;
  }

  .blockprops .disabled-option {
    position: relative;
    cursor: not-allowed;
    display: block;
    width: 100%;
  }

  .blockprops .disabled-option input[type="radio"] {
    cursor: not-allowed;
    margin-right: 8px;
  }

  .blockprops .disabled-option .radio-content {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }

  .coming-soon-badge {
    background: linear-gradient(135deg, #f59e0b, #d97706);
    color: white;
    font-size: 10px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 12px;
    margin-left: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
  }

  .feature-preview {
    margin-top: 8px;
    padding: 10px;
    background: rgba(59, 130, 246, 0.05);
    border-radius: 6px;
    border-left: 3px solid #3b82f6;
    max-width: 100%;
    box-sizing: border-box;
  }

  .preview-title {
    font-weight: 600;
    color: #1e40af;
    margin-bottom: 8px;
    font-size: 13px;
  }

  .preview-list {
    margin: 0;
    padding-left: 14px;
    list-style: none;
  }

  .preview-list li {
    margin: 3px 0;
    font-size: 11px;
    color: #475569;
    position: relative;
    line-height: 1.3;
  }

  .preview-list li::before {
    content: "→";
    color: #3b82f6;
    font-weight: bold;
    position: absolute;
    left: -10px;
    font-size: 10px;
  }

  .preview-note {
    margin-top: 6px;
    font-size: 10px;
    color: #6366f1;
    font-style: italic;
    font-weight: 500;
    text-align: center;
    padding: 4px 6px;
    background: rgba(99, 102, 241, 0.1);
    border-radius: 4px;
    line-height: 1.2;
  }

  /* Radio group styling for wait block */
  .blockprops .radio-group {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .blockprops .wait-option-container {
    display: block;
    width: 100%;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;
    background: #fafbfc;
  }

  .blockprops .radio-inline {
    display: block;
    width: 100%;
    margin-bottom: 0;
  }

  .blockprops .radio-inline input[type="radio"] {
    margin-right: 8px;
    vertical-align: top;
    margin-top: 2px;
  }

  .blockprops .radio-content {
    display: inline-block;
    width: calc(100% - 20px);
    vertical-align: top;
  }

  /* Duration controls styling */
  .blockprops .wait-option-details {
    margin-top: 12px;
    margin-left: 24px;
    padding-left: 12px;
    border-left: 3px solid #3b82f6;
    background: rgba(59, 130, 246, 0.05);
    border-radius: 0 6px 6px 0;
    padding: 12px;
  }

  .blockprops .duration-controls {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .blockprops .duration-input {
    width: 80px;
    flex-shrink: 0;
  }

  .blockprops .duration-select {
    flex: 1;
    min-width: 120px;
  }

  /* Animation for coming soon badge */
  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }

   /* Send Form Properties - New Patient Options Styling */
   .new-patient-options {
     margin-top: 15px;
     margin-bottom: 0;
     padding: 0;
   }

   /* Ensure no extra spacing when hidden */
   .new-patient-options[style*="display: none"] {
     margin: 0;
     padding: 0;
   }

   .new-patient-options .options-container {
     margin-left: 24px; /* Indent to show these are sub-options */
     padding: 20px;
     background: rgba(59, 130, 246, 0.03);
     border-left: 4px solid #3b82f6;
     border-radius: 0 8px 8px 0;
     box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
   }

   .new-patient-options .section-label {
     font-weight: 600;
     color: #374151;
     margin-bottom: 12px;
     display: block;
   }

   .new-patient-options .send-options {
     display: flex;
     gap: 20px;
     margin-bottom: 20px;
     padding: 12px;
     background: rgba(255, 255, 255, 0.7);
     border-radius: 6px;
     border: 1px solid #e5e7eb;
   }

   .new-patient-options .checkbox-inline {
     display: flex;
     align-items: center;
     margin: 0;
     padding: 8px 12px;
     background: white;
     border-radius: 4px;
     border: 1px solid #d1d5db;
     transition: all 0.2s ease;
     cursor: pointer;
   }

   .new-patient-options .checkbox-inline:hover {
     border-color: #3b82f6;
     box-shadow: 0 1px 3px rgba(59, 130, 246, 0.1);
   }

   .new-patient-options .checkbox-inline input[type="checkbox"] {
     margin-right: 8px !important;
   }

   .new-patient-options .option-text {
     font-weight: 500;
     color: #374151;
   }

   .delivery-method-section {
     margin-bottom: 24px;
     padding: 16px;
     background: rgba(255, 255, 255, 0.8);
     border-radius: 6px;
     border: 1px solid #e5e7eb;
   }

   .delivery-method-section:last-child {
     margin-bottom: 0;
   }

   .method-header {
     font-size: 14px;
     font-weight: 600;
     color: #1f2937;
     margin: 0 0 16px 0;
     padding-bottom: 8px;
     border-bottom: 1px solid #e5e7eb;
   }

   .new-patient-options .form-group {
     margin-bottom: 16px;
   }

   .new-patient-options .form-group:last-child {
     margin-bottom: 0;
   }

   .new-patient-options .form-label {
     font-weight: 500;
     color: #374151;
     margin-bottom: 6px;
     display: block;
   }

   .new-patient-options .form-control {
     width: 100%;
     padding: 8px 12px;
     border: 1px solid #d1d5db;
     border-radius: 4px;
     font-size: 14px;
     transition: border-color 0.2s ease;
   }

   .new-patient-options .form-control:focus {
     outline: none;
     border-color: #3b82f6;
     box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
   }

   /* Better responsive layout for wider panels */
   @media (max-width: 1800px) {
     .blockprops .form-row,
     .blockprops .row {
       grid-template-columns: 1fr 1fr 1fr 1fr !important; /* 4 columns for medium-large screens */
       gap: 16px !important;
     }
   }

  @media (max-width: 1400px) {
    .blockprops .form-row,
    .blockprops .row {
      grid-template-columns: 1fr 1fr 1fr !important; /* 3 columns for medium screens */
      gap: 14px !important;
    }
  }

  @media (max-width: 1000px) {
    .blockprops .form-row,
    .blockprops .row {
      grid-template-columns: 1fr 1fr !important; /* 2 columns for smaller screens */
      gap: 12px !important;
    }
  }

  @media (max-width: 600px) {
    .blockprops .form-row,
    .blockprops .row {
      grid-template-columns: 1fr !important; /* Single column for mobile */
      gap: 16px !important;
    }
  }

  /* Add padding around the entire workflow builder container - fix top spacing */
  .workflow-builder-container,
  .main-content {
    padding: 20px !important;
    margin: 24px 16px 16px 16px !important; /* More top margin */
    background: #ffffff !important;
    border-radius: 12px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06) !important;
  }

  /* Add top spacing to the entire page */
  body, html {
    padding-top: 20px !important;
  }

  /* Add internal spacing to workflow components - fix scrollbar issues */
  #canvas {
    margin: 16px !important;
    padding: 20px !important;
    background: #fafbfc !important;
    border-radius: 8px !important;
    border: 1px solid #e5e7eb !important;
    min-height: 500px !important;
    overflow: hidden !important; /* Prevent double scrollbars */
  }

  #leftcard {
    margin: 16px 8px 16px 16px !important;
    padding: 16px !important;
    background: #ffffff !important;
    border-radius: 8px !important;
    border: 1px solid #e5e7eb !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
    overflow-y: auto !important; /* Allow vertical scrolling when needed */
    overflow-x: hidden !important; /* Hide horizontal scrollbar */
    max-height: calc(100vh - 200px) !important; /* Limit height to prevent overflow */
  }

  /* Add spacing to the blocks section - allow vertical scroll */
  #blocklist {
    padding: 12px !important;
    overflow-y: visible !important; /* Let parent handle vertical scrolling */
    overflow-x: hidden !important; /* No horizontal scroll */
    max-height: none !important; /* Let parent handle scrolling */
    height: auto !important;
  }

  /* Fix horizontal scrollbar issues only - keep vertical scrollbar for leftcard */
  .blockelem-container,
  .blocks-wrapper {
    overflow-x: hidden !important; /* Only hide horizontal */
    overflow-y: visible !important; /* Allow vertical */
  }

  /* Hide horizontal scrollbars but keep vertical for leftcard */
  .blockelem-container::-webkit-scrollbar:horizontal,
  .blocks-wrapper::-webkit-scrollbar:horizontal,
  #blocklist::-webkit-scrollbar:horizontal {
    display: none !important; /* Hide horizontal scrollbars only */
  }

  /* Style the vertical scrollbar for leftcard to look clean */
  #leftcard::-webkit-scrollbar {
    width: 6px !important;
  }

  #leftcard::-webkit-scrollbar-track {
    background: #f1f5f9 !important;
    border-radius: 3px !important;
  }

  #leftcard::-webkit-scrollbar-thumb {
    background: #cbd5e1 !important;
    border-radius: 3px !important;
  }

  #leftcard::-webkit-scrollbar-thumb:hover {
    background: #94a3b8 !important;
  }

  .blockelem {
    margin-bottom: 12px !important;
    padding: 16px !important;
    border-radius: 8px !important;
    border: 1px solid #e5e7eb !important;
    background: #ffffff !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
    transition: all 0.2s ease !important;
    width: calc(100% - 8px) !important; /* Prevent horizontal overflow */
    box-sizing: border-box !important;
  }

  .blockelem:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    transform: translateY(-1px) !important;
  }

  /* Fix the overlap line issue */
  .workflow-builder-container,
  .main-content {
    overflow: hidden !important; /* Prevent content overflow */
    position: relative !important;
  }

  /* Hide any problematic lines or borders - comprehensive fix */
  .overlap-line,
  .divider-line,
  hr,
  .separator,
  .border-line {
    display: none !important;
  }

  /* Remove any lines that might be causing overlap */
  *::before,
  *::after {
    border: none !important;
    background-image: none !important;
  }

  /* Ensure proper container sizing */
  .container-fluid {
    padding: 0 !important;
    margin: 0 !important;
    overflow-x: hidden !important;
  }

  /* Fix any remaining visual artifacts */
  .workflow-container {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* Remove any problematic borders from flowy elements */
  .flowy-container,
  .flowy-element,
  .canvas-container {
    border: none !important;
    outline: none !important;
  }

  /* Add spacing to navigation */
  #navigation {
    padding: 16px 20px !important;
    margin-bottom: 16px !important;
    background: #f8fafc !important;
    border-radius: 8px !important;
    border: 1px solid #e5e7eb !important;
  }

  /* Add spacing to tabs */
  #subnav {
    padding: 0 16px !important;
    margin-bottom: 16px !important;
  }

  .side {
    padding: 12px 16px !important;
    margin-right: 8px !important;
    border-radius: 6px !important;
  }

  /* Improve overall page container */
  .page-container {
    padding: 24px !important;
    max-width: 100% !important;
    margin: 0 auto !important;
  }

  /* Improve close icon styling to match blue theme */
  .workflow-close {
    position: absolute !important;
    top: 16px !important;
    right: 16px !important;
    width: 40px !important;
    height: 40px !important;
    background: rgba(255, 255, 255, 0.2) !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
  }

  .workflow-close:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    border-color: rgba(255, 255, 255, 0.5) !important;
    transform: scale(1.05) !important;
  }

  .workflow-close img {
    width: 16px !important;
    height: 16px !important;
    filter: brightness(0) invert(1) !important; /* Makes icon white */
    opacity: 0.9 !important;
  }

  .workflow-close:hover img {
    opacity: 1 !important;
  }

  /* Improve Save button centering */
  .saveblock {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 200px !important;
    height: 48px !important;
    margin: 32px auto 20px auto !important;
    padding: 0 !important;
    background: #10b981 !important;
    color: white !important;
    border: none !important;
    border-radius: 8px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
    text-align: center !important;
    line-height: 1 !important;
    position: static !important;
    clear: both !important;
  }

  .saveblock:hover {
    background: #059669 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
  }

  .saveblock:active {
    transform: translateY(0) !important;
  }

  /* Save button container for side-by-side layout */
  .save-button-container {
    display: flex !important;
    gap: 12px !important;
    justify-content: center !important;
    align-items: center !important;
    margin: 32px auto 20px auto !important;
    width: 100% !important;
    padding: 0 20px !important;
  }

  .save-button-container .saveblock {
    margin: 0 !important;
    flex: 0 0 auto !important;
    width: 140px !important;
  }

  /* Save & Close button variant */
  .saveblock-close {
    background: #3b82f6 !important;
  }

  .saveblock-close:hover {
    background: #2563eb !important;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
  }

  #wait-properties .radio-inline {
    display: flex;
    align-items: flex-start;
    padding: 20px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin: 0;
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  #wait-properties .radio-inline:hover {
    border-color: #3b82f6;
    background-color: #f8fafc;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }

  #wait-properties .radio-inline input[type="radio"] {
    margin-right: 0;
    margin-top: 4px;
    transform: scale(1.3);
    flex-shrink: 0;
  }

  #wait-properties .radio-inline input[type="radio"]:checked {
    accent-color: #3b82f6;
  }

  #wait-properties .radio-inline:has(input[type="radio"]:checked) {
    border-color: #3b82f6;
    background-color: #eff6ff;
    color: #1e40af;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
  }

  #wait-properties .radio-inline:has(input[type="radio"]:checked) .radio-content strong {
    color: #1e40af;
  }

  /* Duration controls styling */
  .duration-controls {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .duration-input {
    flex: 0 0 100px;
    text-align: center;
    font-weight: 600;
  }

  .duration-select {
    flex: 1;
    min-width: 140px;
  }

  #wait-properties .form-control {
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 14px;
    transition: all 0.2s ease;
    background: #ffffff;
  }

  #wait-properties .form-control:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    transform: translateY(-1px);
  }

  #wait-properties .form-control:hover {
    border-color: #9ca3af;
  }


  /* Improved save button - better positioning for wide panels */
  .saveblock {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border: none;
    padding: 16px 32px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 200px;
    text-align: center;
    font-size: 16px;
    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
    margin: 32px auto 20px auto;
    display: block;
    position: static;
    line-height: 1;
    clear: both;
  }

  .saveblock:hover {
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  }

  .saveblock:active {
    transform: translateY(0);
  }

  /* Save button container for better positioning */
  .save-button-container {
    display: flex;
    justify-content: center;
    padding-top: 24px;
    border-top: 1px solid #e5e7eb;
    margin-top: 32px;
  }

  /* Divider styling - better for wide panels */
  #divisionthing {
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, #e5e7eb 10%, #e5e7eb 90%, transparent 100%);
    margin: 40px 0 0 0;
    opacity: 0.8;
    clear: both;
  }

  /* Close button improvements */
  .workflow-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid #e5e7eb;
  }

  .workflow-close:hover {
    background: #e5e7eb;
    transform: scale(1.05);
  }

  .workflow-close img {
    width: 12px;
    height: 12px;
    opacity: 0.6;
  }

  /* Simple Kanban Table Styling */
  #kanban-table tbody tr {
    background: #ffffff;
  }

  /* Add padding to table cells for better spacing */
  #kanban-table tbody tr td {
    padding: 16px 8px !important;
    vertical-align: top;
    border-bottom: 1px solid #f1f5f9;
  }

  /* Style the card properties container */
  #kanban-table .card-update-field {
    margin-bottom: 12px;
    padding: 8px;
    background: #f9fafb;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
  }

  #kanban-table .card-update-field:last-child {
    margin-bottom: 0;
  }

  #kanban-table .card-update-field label {
    font-size: 11px;
    font-weight: 600;
    color: #6b7280;
    margin-bottom: 4px;
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  #kanban-table .card-update-field input,
  #kanban-table .card-update-field textarea,
  #kanban-table .card-update-field select {
    font-size: 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 6px 8px;
  }

  #kanban-table .card-update-field input:focus,
  #kanban-table .card-update-field textarea:focus,
  #kanban-table .card-update-field select:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
    outline: none;
  }


  /* Highlight active row when card properties are visible */
  #kanban-table tbody tr:has([id*="kanban-card-update-properties"][style*="block"]) {
    background: #f0f9ff;
    border-left: 4px solid #3b82f6;
    padding-left: 12px;
  }

  #kanban-table tbody tr:has([id*="kanban-card-update-properties"][style*="block"])::before {
    background: #3b82f6;
    opacity: 1;
    width: 6px;
  }

  /* Add subtle animation when properties appear */
  #kanban-table [id*="kanban-card-update-properties"] {
    transition: all 0.3s ease;
    overflow: hidden;
  }

  /* Style the table header for better contrast */
  #kanban-table thead th {
    background: #f8fafc;
    color: #374151;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 12px 8px;
    border-bottom: 2px solid #e5e7eb;
  }

  /* Add visual grouping for the card properties column */
  #kanban-table tbody tr td:nth-child(6) {
    background: #fafbfc;
    border-left: 1px solid #e5e7eb;
    border-right: 1px solid #e5e7eb;
  }

  /* Style the Add more button */
  #addMoreCodesForKanban {
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;
    background: #f3f4f6;
    color: #374151;
    text-decoration: none;
    border-radius: 6px;
    border: 1px solid #d1d5db;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    margin-top: 12px;
  }

  #addMoreCodesForKanban:hover {
    background: #e5e7eb;
    color: #1f2937;
    text-decoration: none;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  #addMoreCodesForKanban::before {
    content: '+';
    margin-right: 6px;
    font-weight: 600;
    font-size: 14px;
  }

</style>


